var keys = {
  messages: {
    ar: {
      message: {
        general: {
          required_email: "البريد الالكتروني مطلوب",
          stop: "الموقع لايعمل للاغراض الصيانة",
          sorry: "نعتذر منكم ونقدر صبركم وتفهمكم",
          call: "تواصل معنا",
          warence:
            " لاغراض الصيانة سيتم إيقاف موقعنا  يوم السبت من الساعة 5 صباحا حتى 3 مساء. نقدر صبركم وتفهمكم",
          correct: "صحيح",
          wrong: "غير صحيح",
          min_chars: "يجب أن يكون",
          characters: "أحرف على الأقل",
          max_chars: "أقصى عدد من الرموز هو",
          between_chars: "يجب أن يكون بين",
          provide_valid_email: "يرجى إدخال عنوان بريد إلكتروني فعال",
          provide_valid_phone: "يرجى إدخال رقم هاتف فعال",
          select_valid_birthyear: "يرجى اختيار سنة الميلاد",
          captcha_label: "ولكن قبل الإتمام، إليك تحدٍ صغير",
          correctـanswer: "اجابة صحيحة",
          password_identical_msg: "يجب أن تكون كلمات المرور متطابقة.",
          options_selected: "الخيارات المحددة",
          dont_show: "لا تظهر هذا مرة أخرى",
          team: "بواسطة فريق Hello World Kids",
          title: "مسار دراسي مثبت وواضح لتعلم البرمجة",
          sub_title: "التعلم الذاتي لجميع الأعمار ومستويات الخبرة",
          note: "يوسع الطفل إبداعاته عندما يتعلم كيفية البرمجة",
          special_chars: "يجب أن لا يحتوي الاسم على رموز",
          all_feilds: "يرجى تعبئة الحقول المطلوبة",
          city: "يرجى ادخال المدينة باللغة الانكليزية",
          MiddleName: "يرجى ادخال  باللغة الانكليزية",
          FirstName: "يرجى ادخال الاسم الأول باللغة الانكليزية",
          lastName: "يرجى ادخال اسم العائلة باللغة الانكليزية",
        },
        Community: {
          postplaceholder: "ماذا تفكر الآن؟",
          Comments: "التعليقات",
          Comment: "التعليق",
          Likes: " الإعجابات",
          Like: "الإعجاب",
          commentPlaceHolder: "اكتب تعليق",
          Edit: "التعديل",
          Remove: "المسح",
          posts: "المنشورات",
        },
        kidsSafe: {
          content: " البيئة الآمنة والممتعة التي يحتاجها طفلك ",
          sub_title:
            "أثناء تعلم كيفية تصميم وبناء تقنيات جديدة من خلال منهج برمجي مميز",
          register: "التسجيل مجاني",
          card_title: "تحفيز الإبداع",
          card_text:
            "Fully layered dolor sit amet, consectetur adipisicing elit. Facere, nobis, id ",
          place_title: "منصة سليمة وآمنة ",
          play_title: "مناهج معتمدة",
          title_game: "التعلم باللعب ",
          card_text:
            "أطلق العنان لإبداع أطفالك لينعكس على مشاريعهم البرمجية المميزة.",
          des_place:
            "يمكن لأطفالك بناء عالمهم وأفكارهم الخاصة في مكان آمن وممتع.",
          des_play: "سيحصل الطفل على شهادة معتمدة بعد إنهائه لأي دورة برمجية.",
          des_game:
            "لضمان حصول الأطفال على أكبر قدر من المتعة والمرح أثناء التعلم .",
        },
        amazingkidssection: {
          title_heading: "شاهد إبداع المبرمجين الصغار على منصة هلوكود",
          text_heading:
            "ألقِ نظرة على بعض المشاريع الرائعة التي أنشأها الأطفال باستخدام منصة هلوكود",
          text_btn: "الإطلاع على منهاجنا",
          course_title: " دورة سموذي البرمجية",
          project_title: "مشروع الأهرامات",
          project_des:
            " انعكاس لإحدى عجائب الدنيا في عرض برمجي جميل مصمم باستخدام لغة ترميز متقدمة.",
          name_and_grade: "احمد عامر  -الصف الثالث",
          advanced_programming: " دورة سموذي البرمجية",
          project_advanced: "لعبة إكس-أو (Tic-tac-toe)",
          des_advanced: "لعبة أطفال يومية بسيطة تحولت الى مشروع برمجي متطور.",
          name_and_gradeSc: "ابراهيم احمد -الصف الرابع",
          course_hwk: " دورة سموذي البرمجية",
          project_hwk: "قطار الرياضيات",
          des_hwk:
            "مشروع برمجي يبدو بسيطاً للوهلة الأولى، لكنه يدل على فهم مميز لمادة الرياضيات.",
          name_and_3rdgrade: "مها احمد  -الصف الخامس",
        },
        coursesSection: {
          title_heading: "دورات برمجية مميزة تناسب جميع الأعمار",
          text_heading:
            "يتألق الأطفال وستظهر مواهبهم وإبداعاتهم من خلال هذه الدورات التفاعلية والمتنوعة. هذه الدورات المصممة من قبل خبراء برمجيين، هي الخطوة الأولى لبناء مستقبل أطفالك.",
          text_btn: "انظر جميع الدورات",
          course_title: "البرمجة الأساسية",
          description_title: "دورات الحاسوب للمبتدئين",
          description_text:
            "سيبدأ الأطفال رحلتهم التكنولوجية بتعلم مهارات الحاسوب الأساسية من خلال الدمج بين نهجيّ التعلم واللعب. كما ستركز المستويات على تطوير مهارات الأطفال في حل المشكلات والتفكير خارج الصندوق.",
          course_titlekids: "من مرحبا هلوورلد كيدز",
          description_titleKids: "دورة سموذي البرمجية",
          description_text:
            "سيبدأ الأطفال رحلتهم التكنولوجية بتعلم مهارات الحاسوب الأساسية من خلال الدمج بين نهجيّ التعلم واللعب. كما ستركز المستويات على تطوير مهارات الأطفال في حل المشكلات والتفكير خارج الصندوق.",
          description_smoothy:
            "في دورة البرمجة هذه سيتعلم الأطفال أولاً أساسيات البرمجة، ثم سيبدأون  بتطوير التطبيقات والألعاب وإنشاء قصص في عالمهم الخاص. تنقسم دورة لغة سموذي إلى المستويات التالية: أساسي ومتوسط ومتقدم وخبير.",
          title_smoothy: 'دورة‌ ‌البرمجة "‌‍‌سموذي‌" ‌ ',
          course_smoothy: "من هلوو ورلد كيدز",
          course_advance: "دورة  تطبيقات الويب",
          description_advance: "دورة  تطبيقات الويب",
          text_advance:
            "سيتعلم الأطفال خلال هذه الدورة كيفية إنشاء وتصميم المواقع الإلكترونية وصفحات الويب وعناصرها المختلفة وبرمجتها باستخدام لغات برمجة متقدمة مثل JavaScript و HTML و CSS.",
          learnMore: "المزيد",
        },
        contribution: {
          linesofcode: " سطر من الرموز تمت كتابتهم بواسطة أطفال مبدعين.",
          numofschool: "مدرسة تثق في هلوكود ودوراتها لتعليم طلابها.",
          numofstudent: "طالب تم تسجيلهم في هلوكود من مدارس مختلفة.",
          numofclasses:
            " معلم قاموا بإنشاء فصول دراسية متعددة على مختلف مستويات.",
        },
        boostProductivitySection: {
          main_title: "أطلق العنان لإبداعك",
          main_text: "استمتع بتعلم البرمجة على منصتنا التفاعلية من أي جهاز",
          upperCardDText: "تحديثات منتظمة",
          lowerCardDText: "تطوير مستمر لخصائص وميزات حسابات المعلمين والطلاب.",
          Responsiveweb: "تصميم يتناسب مع جميع الأجهزة",
          Responsive_text:
            "صممت منصة هلوكود لتلائم جميع الأجهزة ومختلف أحجام الشاشات.",
          loadedfeat: "مليئة بالميزات المثيرة",
          features_des:
            "منصة هلوكود مليئة بالميزات مثل إدارة الصفوف الدراسية والتقييم التلقائي.",
          request_btn: "طلب عرض تجريبي",
          register_btn: "طلب عرض تجريبي",
          features_update: "مليئة بالميزات المثيرة",
          text_update:
            "ليس من الضروري أن تتعطل آلتك المزيتة جيدًا بسبب عمليات البناء.",
          process:
            "لا يتعين عليك التزيت جيدًا بسبب العمليات المعقدة ، أو ضيق الوقت لفرض الاتساق.",
        },
        cycileSection: {
          text: "منصة مصممة للمعلمين",
          Register: "إدارة الصفوف",
          request_text:
            "استخدم مجموعة متنوعة من الأدوات لمساعدتك على إدارة الصفوف بسهولة وسلاسة. ",
          see_text: "تواصل معنا!",
          Addteacher: "متابعة تقدم الطلاب",
          text_addteacher:
            "تقييم تعلم الطلاب على أساس منتظم، بالإضافة إلى تقدم المعلم وتطوره.",
          Assignclassess: "التقييم التلقائي",
          Assign_teacher: "أداة تقييم إلكترونية تدعم جميع أنواع التمارين.",
          AddStudent: "بيئة برمجية",
          text_addstudent:
            "يمكن للطلاب الاستمتاع بالبرمجة في أي وقت من خلال بيئة العمل المدمجة لدينا.",
        },
        schoolsQuotes: {
          main_title: "تجارب المعلمين مع هلو كود",
          teacher_name: " حنان خليفة",
          school_name: "مدارس الميار الدولية",
          quotes:
            "أحب هلوكود لأنه ساعد الطلاب على تعلم مفاهيم الرياضيات بطريقة أفضل،  حيث أنهم يستخدمون المحور Y والمحور X  لرسم الأشكال في مشاريعهم البرمجية بطريقة ممتعة",
          secondteacher_name: "احمد التعمري",
          secondschool_name: "مدارس الميار الدولية",
          second_quotes:
            " أصبحت البرمجة هوايتي المفضلة فأنا أحب قضاء الوقت مع طلابي على منصة هلوكود لإنشاء التطبيقات والمشاريع البرمجية في بيئة تمتاز بالسهولة والمتعة.",
          request_demo: " طلب عرض تجريبي",
        },
        helloCodeHeros: {
          text_main: "مرحبًا بأبطال الكود!",
          name_student: "ميرا البكري ",
          des_student:
            "طفلة ذكية وموهوبة، وهي أول من أنشأ مشروع برسمة ثلاثية الأبعاد على منصة هلوكود.",
          student_school: "مدارس الرضوان",
          secondStudent: "جاد عمّاري ",
          seconddes_student:
            "ساعدته البرمجة على فهم الرياضيات، وهو يعمل الآن على تطوير مهاراته ليصبح مبرمجاً في المستقبل.",
          secondschool: "المدارس المعمدانية ",
          thirdrdStudent: "عصام وائل سيتان ",
          thirddes_Student:
            '"ذكي ومبتكر ويفكر خارج الصندوق، نحن على ثقة سيكون له مستقبل مبهر "هكذا وصفه معلموه.',
          third_school: " مدارس الرضوان",
          fourthStudent: "عيد غازي ",
          fourthdes_Student:
            "واحد من أمهر المبرمجين الصغار، حيث يكتب الأسطر البرمجية بمهارة عالية ولديه قدرة كبيرة على الابتكار.",
          fourth_school: "المدارس المستقلة الدولية",
          fifthStudent: "لين الخضيري",
          fifthdes_Student:
            "ذكية وسريعة البديهة، وهي من أصغر المبرمجين على منصة هلوكود، وتطمح لأن تكون مبرمجة محترفة.",
          fifth_school: "مدارس  الأهلية ",
          btn_demo: "طلب عرض تجريبي",
        },
        schoolSection: {
          shared_title: "هلوكود للجميع",
          parent_title: "للأطفال وأولياء الأمور",
          teacher_title:
            "اجعل من طفلك خبيرًا تكنولوجيًا من خلال دوراتنا الممتعة والديناميكية.",
          text_inner: "شاهد التطور المميز لشخصياتهم.",
          text_view: "شاهد إبداعاتهم وإنجازاتهم.",
          text_control: "استمتع بتقدمهم",
          parent_register: "التسجيل المجاني",
          school_title: "للمدارس وطلابها",
          school_text: "ابدأ ببناء جيل جديد من المفكرين المبدعين والمحللين.",
          create_class: "مكّن طلابك من اكتساب مهارات حياتية حاسمة.",
          assign: "طور من قدراتهم على الملاحظة وحل المشكلات.",
          Add_multiplething:
            "ساهم بإعدادهم لمستقبل تقوده التكنولوجيامن خلال اكتساب المعارف والمهارات الأساسية.",
          school_btn: "جولة مجانية",
        },
        testimonialsection: {
          sub_title: "فخور ب",
          sub_lines: "سطر برمجي.",
          btn: "اكتب السطر التالي",
          nameTestimonial1: "هيا قراعين",
          ageTestimonial1: "٨ سنوات",
          textTestimonial1:
            "أحب منصة هلوكود لأنها ساعدتني في إنشاء تطبيقي الخاص الذي يهدف إلى مساعدة الفقراء. بعد ذلك سأقوم بإنشاء تطبيق آخر لإصلاح الهواتف المحمولة وأجهزة الايباد، لأن شاشة الايباد الخاصة بي تتعطل باستمرار",
          nameTestimonial2: "دينا عبد المجيد",
          ageTestimonial2: "المؤسس و الرئيس التنفيذي في  360 Moms",
          textTestimonial2:
            "لقد استمتع ابني البالغ من العمر 8 سنوات حقًا بتعلم البرمجة من خلال هلوكود. الشخصيات الجميلة تجعلها ممتعة للغاية! والميزة الكبيرة  هي أنهم كلما تدربوا أكثر وتمكنوا من القيام بالترميز الصحيح، فإنهم يحصلون على نقاط أكثر، وكأنهم يلعبون لعبة",
          num_code: "4,500,000",
        },
        footersection: {
          about_text: "عالم من الإمكانيات",
          contact_heading: "للاتصال بنا",
          footer_phone_number: "962790488840+",
          links_heading: "روابط مفيده",
          Courses: "مناهجنا",
          ForSchools: "  للمدارس",
          SupportCenter: "مركز الدعم",
          Termsofuse: "شروط الأستخدام",
          privacy: "سياسة الاستخدام",
          form_heading: "نشرتنا الإخبارية ",
          text_form:
            "اشترك  في نشرتنا الإخبارية للاطلاع على آخر المستجدات المتعلقة بخدماتنا ومنتجاتنا.",
          email_placeholder: "ادخل عنوان بريدك الالكتروني",
          input_btn: "انضم !",
          copyright_text: "حقوق النشر Hello World Kids",
          social_text: "تابعنا",
          location: "شارع مكة المكرمة بناية رقم 33 الطابق - 5 ، عمان ، الأردن",
        },
        thirdSectionHome: {
          titlePage: "لغة سموذي!",
          Paragraph:
            "سموذي هي لغة برمجة ممتعة وفريدة من نوعها تم تطويرها خصيصاً للمبرمجين الصغار لتكون بمثابة جسر يمكنهم من تعلم لغات البرمجة الاحترافية بسهولة.",
          card_title: "بسيطة وسهلة",
          title_pazzel: "مصممة خصيصًا للأطفال",
          title_game: "البرمجة باحتراف",
          card_para:
            "يمكن للأطفال استخدام سموذي لتطوير التطبيقات والألعاب أو ببساطة لإنشاء قصص إبداعية.",
          pazzel_para:
            "لغة سموذي تعمل على تبسيط البرمجة للأطفال بطريقة ممتعة وسهلة الفهم.",
          game_para:
            "تعلم طفلك للغة سموذي هي خطوته الأولى ليصبح مبرمجًا محترفًا!",
          text_btn: "طلب عرض تجريبي",
          btn_reg: "التسجيل في حساب مجاني",
        },
        registerFree: {
          main_title: "حان دورك الآن..",
          main_text:
            "ابدأ تجربتك في عالم البرمجة وتعلم كيف يمكنك إطلاق العنان لإبداعك وتحويل أحلامك إلى حقيقة.",
          btn_register: "تسجيل  مجاني",
        },
        skillsSection: {
          main_text: "مهارات الطلاب",
          Idea_title: "مهارات التفكير",
          des_Idea: "ستتطور مهارات التفكير لدى الطلاب من خلال دوراتنا.",
          empathy_title: " مهارات حل المشكلات ",
          des_empathy: "تزيد البرمجة من قدرة الطلاب على ملاحظة المشكلات.",
          plan_title: "مهارات التخطيط",
          des_plan:
            "من خلال التعلم القائم على إنشاء المشاريع، سيتعلم الطلاب تنظيم وقتهم.",
          Communication: "مهارات التواصل",
          des_commun: "ستتحسن مهارات التواصل لدى الطلاب. ",
          Creative_title: "مهارات الابتكار",
          des_Creative: "سيعكس الطلاب واقعهم وسينشئون عالمهم الخاص.",
          coding_title: " مهارات البرمجة",
          des_coding:
            "من خلال منصة هلوكود، سيبدأ الطلاب بكتابة الرموز وتحليلها. ",
          btn_demo: "اطلب عرض تجريبي",
        },
        safeQuestion: {
          title: "أجب على السؤال الآمن",
          btn: "انهاء",
          answer: "اكتب إجابة السؤال",
          messages: "الإجابة أو السؤال خطأ",
        },
        topSectionA: {
          Revol: "ابدأ بتعليم",
          main_title: "لغة المستقبل",
          main_text:
            "بيئة تعليمية فريدة تقدم بأسلوب ممتع وسهل باستخدام الألعاب وتهدف لتعليم البرمجة وتطوير مهارات التفكير وحل المشكلات لدى الطلاب.",
          feature_one:
            "حزمة من الموارد التعليمية (مقاطع فيديو، أدلة إرشادية، وغيرها).",
          feature_two: "مراقبة لتقدم الطلاب بشكل منتظم وسهل",
          feature_three: "دروس مبتكرة وألعاب تفاعلية",
          demo_book: "احجز عرضاً تجريبياً",
          meeting:
            "اكتشف منصة هلوكود وميزاتها المذهلة عن طريق حجز عرض تجريبي سريع، وتعرف على كيفية عمل المنصة وكيف يمكنك تطوير عمليتك التعليمية.",
          org_name: "اسم المنظمة",
          email_school: "البريد الإلكتروني للمدرسة",
          mobile: "رقم الهاتف",
          req_submit: "تقديم الطلب",
          req_demo: " اطلب عرض تجريبي",
          Trusted: "عملائنا",
          close: "إلغاء",
          success_message:
            "سيقوم مندوب من فريق المبيعات لدينا بالتواصل معك قريبًا",
        },
        AsneakPeakatourcourses: {
          main_title: "نظرة خاطفة على دوراتنا",
          main_text: "لدينا المزيد من الدورات",
          second_mainText: "استمتع بهذه القطع الذهبية أدناه.",
          card_text: "دورات الحاسوب للمبتدئين",
          card_html: 'دورات البرمجة "سموذي"',
          text_smoothy: "دورة  تطبيقات الويب",
          text_python: "دورة تطبيقات البايثون",
          title_card: "دورة الحاسوب للمبتدئين ",
          // second_titleCard:'الحاسوب للمبتدئين ',
          title_html: ' دورة البرمجة "سموذي"',
          //  second_titlehtml:' سموذي البرمجية',
          title_smoothy: "دورةتطبيقات الويب",
          // second_titlesmoothy:' تطبيقات الويب',
          title_python: " دورة بايثون البرمجية",
          text_card:
            "سيبدأ الأطفال رحلتهم التكنولوجية بتعلم مهارات الحاسوب الأساسية من خلال الدمج بين نهجيّ التعلم واللعب .",
          text_smoo:
            "سيتعلم الأطفال أولا أساسيات البرمجة، ثم سيبدأون بتطوير مشاريعهم وإنشاء قصصهم الخاصة.",
          text_web:
            " سيتعلم الأطفال خلال هذه الدورة كيفية بناء وتصميم مواقع الويب باستخدام لغات برمجة متقدمة.",
          smoothy_card:
            "في دورات البرمجة الممتعة والفريدة هذه ، سيتعلم الأطفال أولاً أساسيات البرمجة ، ثم يبدأون في تطوير التطبيقات والألعاب.",
          btn_vido: "عرض",
        },
        rgChild: {
          sm_text: "الرجوع",
          KidsRegisteration: "تسجيل الطفل",
          main_text: "سيكون لديك وصول مباشر إلى دورات هلوكود ",
          Register_text: "التسجيل",
          Register_Child: "تسجيل الطفل",
          card_title:
            "هناك الكثير من الألعاب والدورات التعليمية الممتعة بانتظارك في هلوكود",
          card_text:
            "مرحباً، سررت بلقائك، ما اسمك؟ نحن بحاجة لهذه البيانات لإنشاء اسم المستخدم الخاص بحسابك",
          full_name: "الاسم الكامل",
          name: "الاسم",
          Generateusername: "اختيار اسم عشوائي",
          member_text: "عضوا فعلا؟",
          sign_text: "تسجيل الدخول",
          register_btn: "اكتب تاريخ ميلادك",
          try: "محاولة مرة اخرى",
          usertaken: "الاسم موجود مسبقا",
          goodname: "رائع، الآن يمكنك تسجيل الدخول",
          strong_pass: "انشاء كلمة سر قوي",
          pass_text:
            "أضف كلمة مرور يمكنك تذكرها بسهولة. لا تقلق، ستكون سراً بيننا.",
          lab_pass: "باسورد",
          Account_free: "إنشاء حساب مجاني الآن",
          good_password: "رائع، الآن يمكنك تسجيل الدخول ",
          save_pass: "الآن احفظه في مكان آمن حتى تتمكن من تذكره.",
          not_enough: "ليس كافي",
          write_more: "امنحه المزيد من الرموز",
          almost_good: "اوشكت على الوصول.",
          yearofbirth: "كم هو عمرك؟",
          mess_text:
            "تذكر ، العمر هو مجرد رقم ، ومع ذلك ، يجب أن يكون عمرك 8 على الأقل للتسجيل",
          password_btn: "استمرار في كتابة الباسورد",
          parent_registration: "مرحبا بأولياء الأمور ",
          accsess: " طفلك على وشك أن يخوض تجربة رائعة ",
          select_safe_question: "اختار سؤال الأمان",
          no_chara:
            "يمكن أن يتضمن اسم المستخدم أحرفًا وأرقامًا وواحدًا من - أو _ أو. لكن بدون رموز خاصة",
          courses_det: "تفاصيل الدورات",
          courses: "دورات",
          ensure:
            "الأمر ليس بالكمية، ولكن في القيمة المكتسبة. اختر عدد الكورسات التي ترغب بتعليمها لطفلك",
          sale: "تم اضافة كود الخصم",
          alreadyBought: "تم شراء كل الكورسات لهذا الطالب",
        },
        offer_hellocode: {
          the_offer: "ما يميز منصة هلوكود ؟",
          Reward: " شهادات معتمدة للدورات البرمجية",
          time: "النشاط المثالي لاستغلال وقت طفلك",
          creative: "تعليم البرمجة بطريقة ممتعة ومميزة",
          calcu: "تنمية مهارات الطفل الفكرية والإبداعية.",
          course_title: "دورات هلوكود",
          course_one: "دورة الحاسوب للمبتدئين",
          course_two: 'دورة البرمجة "سموذي"',
          course_three: "دورة برمجة  الويب",
          Course_one:
            "سيبدأ الأطفال رحلتهم التكنولوجية بتعلم مهارات الحاسوب الأساسية من خلال الدمج بين نهجيّ التعلم واللعب.",
          Course_two:
            "في هذه الدورة البرمجية سيتعلم الأطفال أولاً أساسيات البرمجة، ثم سيبدأون بتطوير التطبيقات والألعاب.",
          Course_three:
            "سيتعلم الأطفال خلال هذه الدورة كيفية إنشاء وتصميم وبرمجة المواقع الإلكترونية وصفحات الويب.",
          Frequently: "أسئلة مكررة",
          FAQs: "أسئلة وأجوبة",
          main_Question: "ماهو التعليم المساند؟",
          Q_one: "كيف يتم تعليم البرمجة للأطفال على منصة هلوكود؟",
          Q_two: "ما هي خدمة التعلم المساند ؟",
          Q_three: "الأعمار المناسبة للتسجيل ؟ ",
          // Sub_title:"العنوان الفرعي",
          // Second_title:"العنوان الفرعي",
          main_para:
            "يقوم معلم معتمد من هلو وورلد كيدز بتقييم مشاريع طفلك و إعطاء ملاحظات و توجيهات مباشرة لمساعدة الطفل في التعلم",
          para_one:
            "تقدم هلوكود لأطفالكم تجربة فريدة في عالم البرمجة عن طريق تقديم المواد التعليمية بأسلوب سهل وممتع، حيث قمنا بتطوير أسلوب تعليمي صُمم خصيصاً لتحفيز إبداعهم وتنمية مهارات التفكير لديهم وتطوير مهاراتهم الأكاديمية وتعزيز مهارات التواصل لديهم.",
          para_two:
            " خدمة التعلم المساند هي خدمة توفرها منصة هلوكود حيث يقوم معلم معتمد من هلو وورلد كيدز بتقييم مشاريع طفلك وتقديم الملاحظات والتوجيهات للطفل مباشرة لمساعدته على التعلم.  سعر هذه الخدمة هو  (10$) لكل كورس. ",
          para_three:
            "منصة هلوكود لتعليم البرمجة للأطفال مناسبة للفئة العمرية من 6 الى 15 سنة.",
        },

        plan_hellocode: {
          main_text: "!تهانينا",
          text_main:
            "لقد قمت بتسجيل طفلك على منصة هلوكود بنجاح وتم إرسال‌ ‌الإيصال ‌‍‌على البريد الإلكتروني",
          text: "‌.لا تنسى أن دعمك وتشجيعك لطفلك سيحفزه على مواصلة الإبداع",
          sub_text:
            ".يمكن لطفلك البدء برحلته التعليمية الآن.‌  ‌الدورات متاحة ضمن خطة طفلك‌ ",
          video_text: "الفيديو الأول",
          lesson_title: " الأشكال",
          second_video: "الفيديو الثاني",
          second_lesson: " المتغيرات",
          third_video: "الفيديو الثالث",
          third_lesson: "التحديات",
          btn_back: "العودة إلى الصفحة الرئيسة",
          heading_title: "تحديث الخطة",
          explain_text:
            "قم بتحديث خطتك والوصول إلى المزيد من الدورات التدريبية",
        },

        addkid: {
          text: "لم تقم بإضافة أي طفل بعد",
          main_text: "أضف طفلك الآن ليبدأ تجربة تعلم مميزة.",
          btn_add: "أضف طفلك الآن",
          btn_exist: "اربط حسابك طفلك",
          main_title: "نافذة إضافة الطفل",
          create_btn: "إنشاء حساب",
          cancle: "الغاء",
          thank: "شكراً لك!",
          text_mess:
            "تم إنشاء حساب طفلك بنجاح، يمكن لطفلك الآن البدء بتعلم البرمجة على منصة هلوكود شارك معلومات الحساب",
          done_btn: "انتهيت من هنا",
          btn_link: "ربط حساب المبرمج",
          main_link:
            "أدخل اسم المستخدم وكلمة المرور الخاصة بحساب طفلك لربطه بحسابك الشخصي على منصة هلوكود.",
          title_link: "اربط حساب طفلك بحسابك",
          full_name: "الاسم الكامل",
          user_name: "اسم المستخدم",
          password: "كلمة السر",
          generate: "اختيار اسم عشوائي",
          birthday: "العمر",
          vali_password: "الحد الأدني لعدد الرموز هو 6",
          goodname: "الحد الأدني لعدد الرموز هو 3",
          userlinked:
            "اسم المستخدم أو كلمة المرور خاطئة ، أو أن هذا الطفل لديه أحد الوالدين بالفعل",
        },
        register: {
          num: "4.5 مليون سطر",
          lines: " برمجي مليء بالإبداع كتبه الأطفال",
          Time: "الاستمتاع بالوقت وتعلم مهارة حياتية مهمة.",
          Reward: "شهادات معتمدة خاصة بدورات البرمجة.",
          creative: "أساليب تعلم مبدعة وممتعة.",
          packges: "أظهر إبداعك واجعل أفكارك تنبض بالحياة.",
          discount: "يتم تطبيق كوبون خصم%٢٥",
          twoType: "سجل كولي أمر أو طفل",
          Free: "انه مجانا. لا حاجة لبطاقة ائتمان",
          who: "أنا طفل",
          Iwant: "وأود أن أستمتع وأتعلم البرمجة",
          Who_is: "أنا ولي أمر ",
          Ineed: "وأود منح أطفالي تجربة تعلم مميزة",
          register_btn: "سجل حساب مجاني",
          Ihaveaccount: "عضوا فعلا؟",
          SignIn: "تسجيل الدخول",
          strong_password: "إبتكر رقم سري قوي",
          remember_password:
            "أدخل كلمة مرور يمكنك تذكرها بسهولة. نعم تماما، كلمة المرور التي تستخدمها كثيراً.",
          hello_parent: "مرحبًا, ولي الأمر",
          great_exp: "ابنك يخوض تجربة رائعة",
          emai_address: "عنوان البريد الإلكتروني",
          phone_insted: "استخدم رقم الهاتف عوضاً عن البريد",
          email_insted: "استخدم بريدك الالكتروني",
          free_acc: " افتح حسابًا الآن، انّه مجّاني",
          get_in_with: "او ادخل عن طريق",
          email_confirmation: "قم بتأكيد عنوان بريدك الإلكتروني",
          email_confirmationMsg: "لقد أرسلنا رمزًا إلى ",
          email_confirmationMsgPt2:
            "يرجى التأكيد حتى نتمكن من المضي قدمًا في إنشاء حسابك",
          not_getting_code: "لم تقم بإستلام الرمز بعد؟",
          or: "أو",
          contact_support: "اتصل بالدعم",
          change_email: "قم بتغيير عنوان بريدك الالكتروني",
          resend: "أرسل رمزًا آخر بعد",
          seconds: "ثانية",
          resendCode: "أعد ارسال الرمز",
          resend_email: "أعد ارسال الايميل",
          verify: "مصادقة",
          otp: "تأكيد الرمز",
          confirm: "تأكيد رقم الهاتف",
          Register_Parent: " تسجيل الوالدين",
          change_phone: "قم بتغيير رقم الهاتف",
        },
        demo: {
          request: "طلب عرض تجريبي",
        },

        questions_ide: {
          hello: "مرحبا، بالتوفيق.",
          correct: "إجابة صحيحة، الآن هيّا ننتقل إلى الدرس التالي.",
          incorrect: "إجابة غير صحيحة، الآن هيّا ننتقل إلى الدرس التالي.",
          correct_final: " أحسنت! إجابة صحيحة.",
          incorrect_final: " لا بأس يمكنك المحاولة مرة أخرى.",
          question_number: "السؤال رقم",
          congrats: "تهانينا",
          next_btn: "التالي",
          check_my_answer: "تحقق من الإجابة",
          notChoseAnswer: "الرجاء اختيار إجابة",
          notFilledAnswer: " يرجى التأكد من ملء جميع الحقول",
          titleAnswer: "عذراً",
          acceptAnswer: "موافق",
          lets_try_another_one: "حاول مرة أخرى",
          submit_btn: "ارسال",
          checked:
            " الرجاء اختيار طفل والتأكد من  قراءة شروط الاستخدام و الموافقة عليها لإكمال عملية التسجيل",
          drag_and_drop:
            "قم بسحب وإسقاط الإجابات المتوقعة أدناه في المستطيلات الأكثر صلة",
          error_message:
            "يرجى إسقاط جميع الإجابات والتأكد من أن لديك إجابة واحدة لكل سؤال",
        },
        notifications: {
          approved: "مقبول",
          disapproved: "غير مقبول",
          pending: "قيد الانتظار",
          error_pending: "لا يوجد مشاريع قيد الانتظار",
          error_approved: "لا يوجد مشاريع مقبولة",
          error_disapproved: "لا يوجد مشاريع غير مقبولة",
          click_to_review_code: "اضغط لمراجعة مشروعك ",
          no: "لا",
          yes: "نعم",
        },
        games: {
          maze_instruction_modal: ".حرك المؤشر عبر النفق لتصل إلى الكنز",
          maze_instruction: ".حرك المؤشر من السهم إلى الكنز",
          maze_instruction2: ".لا تدع المؤشر يلمس الصناديق ",
          lose_maze: ".أوه! لقد لامس المؤشر الصناديق .إلعب مرة أخرى",
          win_maze: "!لقد فزت",
          typing_instruction_modal:
            ".اضغط على مفاتيح الأرقام والحروف الظاهرة على الشاشة",
          typing_instruction: ". حاول أن تحصل على أكثر من 10 نقاط خلال دقيقة ",
          typing_instruction1:
            "Shift او Caps Lock  اضغط مع الحرف او الرمز  للحصول على الاحرف الكبيرة   ",
          typing_lose: ".مجموع نقاطك أقل من 10! إلعب مرة أخرى",
          typing_win: "!لقد فزت",
          typing_score: "النقاط",
          typing_time: "الوقت المتبقي",
          presentation_instruction: "عرض تقديمي",
          word_instruction: "Microsoft word",
          excel_instruction: "Microsoft Excel",
          paint_challenge_instruction: "لنرسم باستخدام القلم",
          paint_challenge_two_instruction: "لنرسم باستخدام الفُرش",
          paint_challenge_three_instruction: "لنقم بإضافة الأشكال",
          paint_challenge_four_instruction: "لنقم بإضافة النصوص",
          done: "إنهاء",
          start: "إبدأ",
          coloring_instruction_modal: ".لون الرسمة! لا تنسى قاعدة اللعبة  ",
          coloring_instruction: ".لون شكل",
          coloring_instruction2:
            ".تذكر! الأشكال التي تشترك بضلع لا يمكن أن تمتلك اللون ذاته",
          coloring_win: "!لقد فزت",
          coloring_lose: ".ترتيب الألوان غير صحيح! إلعب مرة أخرى",
          choose_color: " : الرجاء اختيار اللون ",
          Block: "الصندوق",
          color: "اللون",
          address_instruction_modal: "لون صناديق الجدول السحري",
          address_instruction:
            "تحقق من جدول المعلومات لتلوين صناديق الجدول السحري",
          address_lose: "ترتيب الألوان غير صحيح! إلعب مرة أخرى",
          address_win: "!لقد فزت",
          sudoko_instruction_modal:
            "تذكر! لا تكرر الشكل ذاته مرتين في الصف أو العامود <br> ضع الأشكال لملئ الصنادق الفارغة",
          play_btn: "العب",
          table_info: "جدول المعلومات",
          magic_table: "الجدول السحري",
        },
        video: {
          watch_story: "شاهد قصتنا",
        },
        footer: {
          terms: "شروط الخدمة",
          privacy: "سياسة الخصوصية",
          copy_right: " Hello World Kids حقوق النشر محفوظة 2021 © لـ ",
          contact_us: "اتصل بنا",
        },
        student_course_details: {
          spinModal: {
            spin: "!دوّر العجلة",
            redoEasy: " سهل ",
            greenoHard: " صعب",
          },
          premium_modal: {
            title: "تفعيل الحساب",
            text1: "أطلق العنان للمبرمج الرائع بداخلك!",
            text2: "لتفعيل حسابك الرجاء الطلب من ولي الأمر تسجيل الدخول",
            text3: "إلى حساب ولي الأمر أو تسجيل حساب ولي أمر",
            text4: "المزيد من الدروس والمشاريع الممتعة بانتظارك",
            login: "تسجيل الدخول",
          },
          info_modal: {
            title1: "رائع! شكراً",
            text2:
              "الآن ارسل معلومات حساب طفلك عبر تطبيق الواتساب، أو بإمكانك تسجيل الدخول الى حساب طفلك مباشرة من هنا.",
            text3: "إرسال عبر الواتساب",
            text4: "استمرار في حساب االمبرمج",
          },
          offer_modal: {
            title1: "اشترك الآن!",
            text2: "استمر مجاناً",
          },
          well_done_modal: {
            text:
              "لقد أكملت هذا الدورة بنجاح! حان الوقت للانتقال إلى الدورة التالية!",
            text_school: "لقد أكملت هذا الدورة بنجاح! نراك في الفصل القادم!",
            text_connect: "اطلب دورتك القادمة",
            Certificate: "مبروك! انتظر شهادتك",
            Certificate_text:
              "يرجى ملء الحقول أدناه باسمك باللغة الإنجليزية ، من أجل طباعته على شهادتك.",
            Certificate_note: "ملاحظة : سيتم تثبيت اسمك على جميع الشهادات",
            generate: "إنشاء",
          },
          project_modal: {
            text: "تحدي المشاريع",
            text_1: "اختر مشروعك",
          },
          stones: {
            lesson: "درس",
            game: "لعبة",
            challenge: "تحدي",
            code: "الكود",
            review: "مراجعة الكود",
            no_code: "لا يوجد كود لمراجعته",
            graduationProject: "مشروع تخرج",
            project: "مشروع",
          },
          btns: {
            start: "ابدأ",
            completed: "مكتمل",
            soon: "قريبا",
            next: "التالي",
            locked: "مقفل",
            finish: "تم إنهاؤه",
          },
        },
        ide: {
          course: "المستوى ",
          lesson: "درس: ",
          comments: "التعليقات",
          good_job: "عمل جيد!",
          think_again: "فكر مرة أخرى",
          hello_modal1: "عزيزي المبرمج، نحن بانتظار مشاريعك الرائعة! ",
          hello_modal2:
            "يُمكنك إرسال ثلاثة مشاريع يومياً، أرسل أفضل المشاريع لديك لزيادة نقاطك.",
          hello_modal3: "تأكد من عدم إرسال المشاريع الغير المكتملة.  ",
          hello_modal4: "لقد قمت بإرسال ٠ مشروع. ",
          hello_modal5: "هل أنت متأكد بأنك ستقوم بإرسال هذا المشروع؟",
          hello_modal6:
            "لقد قمت بإرسال ثلاثة مشاريع اليوم، قم بحفظ مشروعك ومن ثم أرسله غداّ.",
          hello_modal7: "سوف يتم تصحيح مشروعك خلال أسبوع",
          btn_yes: "نعم",
          btn_no: "لا",
          use_hint:
            "هل أنت متأكد من أنك تريد استخدام وسيلة المساعدة ،سوف يقلل مجموع نقاطك بمقدار    ١٠ نقاط",
          waiting: "انتظار...",
          help_me: "ساعدني",
          sound_lib: "مكتبة الصوت",
          my_projects: "مشاريعي",
          save_project: "احفظ المشروع",
          see_more: "شاهد المزيد",
          Sound_library: "مكتبة الصوت",
          Image_library: "مكتبة الصور",
          playground_Saved_Projects: "المشاريع المحفوظة",
          teacher_project: "مشاريع المدرس",
          Add_new_project: "إضافة مشروع",
          PlaygroundـProjects: " مشاريع ساحة اللعب",
          CoursesـProjects: "مشاريع الدروس ",
          playground_course_title: "مشروع الدورة",
          playground_note_refresh:
            "ملاحظة : اذا لم تستطع الكتابة على ساحة اللعب قم بتحديث الصفحة",
          playground_course_desc:
            "تذكر ، هذا هو هدف مشروعك. دعنا نواصل الترميز. يمكنك أن تفعل ذلك",
          playground_course_desc1:
            "يمكنك كسب المزيد من النقاط من خلال إنشاء مشاريع أضافية في ساحة اللعب",
          playground_title: "مرحبًا بكم في ساحة اللعب HelloCode!",
          teacherIde_title: "هنا Smoothy مرحبًا يمكنك كتابة كود ",
          playground_desc:
            "حيث يمكنك استكشاف الترميز. لا تتردد في إنشاء برامج خاصة بك ، بالطريقة التي تريدها.",
          playground_desc_share: "أنشأ برامجك الخاصة، بالطريقة التي تريدها",
          show_Project_goal: "إظهار هدف المشروع",
          img_lib: "مكتبة الصور",
          click_copied: "اضغط لنسخ الرابط",
          text_copied: "تم النسخ",
          text_copy: "نسخ الرابط",
          loading: "جار التحميل",
          back: "رجوع",
          run: "شغل البرنامج",
          next: "التالي",
          cancel: "إلغاء",
          social_title_modal: "يمكنك مشاركة مشروعك عبر",
          full_screen: "تكبير الشاشة",
          daily_submission: "المشاريع المرسلة ",
          share: "شارك",
          empty_notifications: "لا توجد اشعارات ",
          video: "فيديو",
          greeno_tutorial: {
            hello_message: "مرحبا",
            points_left: "يمكنك كتابة كود Smoothy هنا",
            point1:
              "يمكنك الضغط على زر الإعدادات للذهاب إلى الصفحة الرئيسية ...",
            point2: "يمكنك الضغط على الأزرار داخل الإعدادات من أجل ....",
            point3:
              "يمكنك الوصول إلى مكتبة الصور عن طريق الضغط على زر كتاب الصور",
            point4: "يمكنك الوصول إلى الأصوات والصور",
            point5: "اضغط على زر الفيديو لمشاهدة فيديو الدرس مرة أخرى",
            point6: "كلما احتجت إلى مساعدة، يمكنك الضغط على زر الضوء الأصفر",
            point7:
              "يمكنك مشاركة مشروعك مع اصدقائك عبر وسائل التواصل الاجتماعي",
            point8: "يمكنك تكبير شاشة العرض من خلال هذا الزر",
            congrats: "🎉 تهانينا! يمكنك الانتقال إلى الحلقة القادمة 🎉",
            mistake: "لا بأس بارتكاب الأخطاء، ومن الرائع إصلاحها",
          },
          mobile_text:
            "البرمجة هي تجربة فريدة من نوعها حيث يمكنك استخدام كل أصابعك العشرة للكتابة!",
          mobile_backe_drop:
            "أيها المبرمج الصغير، يجب عليك ان تستخدم جهاز الكمبيوتر أو اللابتوب للحصول على أفضل تجربة في تعلم لغة سموذي للبرمجة.",
          mobile_btton: "حسناً",
          code: "كتابة البرنامج",
          output: "نتيجة البرنامج",
        },
        student_reg: {
          tab_header: "كن مبتكراً!",
          tab_title: "طالب",
          title: "معلومات الطالب",
          child_progress: "تقدم الطفل",
          skill: "المهارات",
          classroom_info: "معلومات الغرفة الصفيه",
          course_info: "معلومات المادة",
          username_label: "اسم المستخدم للطفل ",
          password_label: "كلمة السر للطفل",
          parent_email: "البريد الإلكتروني لوليّ الأمر",
          email: " البريد الإلكتروني للطالب",
          birth_year_label: "سنة الميلاد",
          submit_btn: "إرسال",
          join_btn: "انضم الان",
          challenges: "مشاريع المستوى",
          lessons: "مشاريع ساحة اللعب",
          student_rate: "تقييم الطالب",
          Projects: "المشاريع",
          overview: "معلومات الطالب",
        },
        student_header: {
          my_world: "عالمي",
          playWithUs: "العب معنا",
          playground: "ساحة اللعب",
          smoothy_ide: "محرر سموذي",
          web_development: "محرر الويب",
          python_development: "محرر بايثون",
          notifications: "إشعارات",
          contact_us: "اتصل بنا",
          logout: "الخروج",
          soon: "...قريباً",
        },
        parent_reg: {
          tab_header: "أطلق العنان لإبداعهم",
          tab_title: "وليّ الأمر",
          title: "معلومات  وليّ الأمر",
          username_label: "اسم المستخدم",
          password_label: "كلمه السر",
          update: "تحديث",
          confirm_password_label: "تأكيد كلمة السر",
          email: "عنوان البريد الإكتروني",
          first_name_label: "الاسم الأول",
          last_name_label: "اسم العائلة",
          phone_number_label: "رقم الهاتف",
          sign_up_btn: "تسجيل",
          join_btn: "انضم الان",
          login: "تسجيل الدخول إلى حساب طفلك",
          title1:
            "هل انت متأكد أنك تريد تسجيل الدخول لحساب طفلك؟ إن الاستمرار سيخرجك من حساب ولي الأمر.",
          continue: "استمرار",
          have_account: "ليس لديك حساب HelloCode؟",
          skip_ide: " تريد تخطي كتابة الكود؟ ",
          account: "هل لديك حساب HelloCode بالفعل؟",
          join: "تسجيل الدخول",
        },
        school_reg: {
          tab_header: "أطلق العنان لإبداعهم",
          tab_title: "المدرسة",
          form1: {
            title: "معلومات المدرسة",
            school_name_label: "اسم المدرسة",
            abbreviation_label: "اختصار اسم المدرسة",
            website_label: "الموقع الإلكتروني",
            email: "عنوان البريد الإلكتروني",
            city_label: "المدينة",
            country_label: "البلد",
            full_address_label: "العنوان الكامل",
            phone_number_label: "رقم الهاتف",
            language_label: "اللغة المفضلة",
            language_option1: "اللغة الإنجليزية",
            language_option2: "اللغة العربية",
            next_btn: "التالي",
            join_btn: "انضم الان",
            skip_btn: "الانتقال الى الاسئله",
            next: "التالي",
            prev: "عالمي",
            school_title: "تسجيل حساب المدرسة",
            school_para:
              "يرجى التأكد من أن جميع المعلومات المطلوبة في مستندات المدرسة",
          },
          form2: {
            title: "معلومات مدير المدرسة",
            username_label: "اسم المستخدم",
            password_label: "كلمه السر",
            confirm_password_label: "تأكيد كلمة السر",
            email: "عنوان البريد الإكتروني",
            first_name_label: "الاسم الأول",
            last_name_label: "اسم العائلة",
            phone_number_label: "رقم الهاتف",
            back_btn: "السابق",
            submit_request_btn: "تقديم الطلب",
            join_btn: "انضم الان",
            school_title: "تسجيل حساب المدرسة",
            school_para:
              "يرجى التأكد من أن جميع المعلومات المطلوبة في مستندات المدرسة",
          },
        },
        loginPage: {
          parent_username: "اسم المستخدم لولي الأمر",
          parent_password: "كلمة السر لولي الأمر",
          title: "كن مبتكراً!",
          username: "اسم المستخدم",
          password: "كلمة السر",
          forget_password: "نسيت كلمة السر",
          remember: "تذكرنى",
          login_btn: "تسجيل الدخول",
          login_as_parent: " تسجيل الدخول كولي أمر",
          welcomeBack: "أهلا بك",
          userInput: "اسم المستخدم أو البريد الإلكتروني",
          passwordInput: "كلمة السر",
          forgetPassword: "نسيت كلمة السر ؟",
          noAccountYet: "لا تملك حسابا حتى الآن ؟",
          notMemberYet: "لست عضوا بعد ؟",
          signIn: "تسجيل الدخول",
          register: "تسجيل",
          empty: "فارغ",
          keepMe: "ابقني مسجل",
          letGet: "هيا بنا لنبدأ البرمجة",
          home: "الرئيسية",
          placeholderPassword: "ادخل رقمك السري",
          placeholderUsername: "أدخل اسم المستخدم الخاص بك",
          placeholderEmail: "أدخل عنوان بريدك الالكتروني أو اسم المستخدم",
          userName: "اسم االمستخدم",
          emailInstead: "استخدم عنوان البريد الإلكتروني بدلاً من ذلك",
          email: "عنوان البريد الالكترونى",
          mobileInstead:
            "استخدم رقم الهاتف المحمول أو اسم المستخدم بدلاً من ذلك",
          mobile: "رقم الهاتف المحمول",
          usernameInstead: "استخدم اسم المستخدم بدلا من ذلك",
          continue_with: "او ادخل عن طريق",
          free_re: "سجل مجانا",
          master: "في صفحة تسجيل الدخول إلى هلوماستر!",
          exam:
            "استخدم اسم المستخدم وكلمة المرور الخاصين بطفلك لتسجيل الدخول والتسجيل في الإمتحانات",
        },
        recover_page: {
          title: "استعادة كلمة السر",
          recoverTitle: "استعادة كلمة السر",
          signIn: "تسجيل الدخول",
          home: "الرئيسية",
          dontWorry: "لا تقلق ، سوف نجعلها سريعة .",
          accessInfo: "معلومات الوصول الخاصة بك",
          back: "رجوع",
          userInput: "اسم المستخدم أو البريد الإلكتروني أو رقم الهاتف",
          empty: "فارغ",
          recoverNow: "استعادة الآن",
          ifKid: "إذا كنت طفلا ، من فضلك",
          contactParent: "الاتصال بالوالد",
        },
        create_new_password_page: {
          titleBoard: "إنشاء كلمة مرور جديدة",
          subTitle:
            "أضف كلمة مرور يمكنك تذكرها بسهولة. لا تقلق، ستكون سراً بيننا.",
          passwordInput: "كلمة السر",
          repeatPassword: "اعد كلمة السر",
          notMatch: "كلمة السر غير متطابقة",
          completeBtn: "أكمل",
        },
        email_sent_page: {
          titleBoard: "أُرسل البريد الإلكتروني",
          subTitle:
            "لقد أرسلنا رابط الاسترداد إلى بريدك الإلكتروني ، يرجى التأكيد حتى نتمكن من متابعة استعادة كلمة المرور الخاصة بك.",
          notGettingLink:
            "لم تحصل على أي رابط ؟ الرجاء التحقق من مجلد الرسائل غير المرغوب فيها.",
          nothingYet: "لا شيء حتى الان؟",
          contactSupport: "اتصل بالدعم",
          or: "أو",
          changeEmail: "تغيير الايميل",
        },
        code_sent_page: {
          titleBoard: "نريد التحقق من هويتك.",
          subTitle:
            "لقد أرسلنا رمزًا إلى رقم هاتفك المحمول ، يرجى التأكيد حتى نتمكن من متابعة استعادة كلمة المرور الخاصة بك.",
          notGetting: "لم تحصل على أي رمز ؟",
          checkSpam: "يرجى التحقق من الرسائل العشوائية الخاصة بك.",
          changeNumber: "تغيير الرقم",
          otp: "تأكيد الرمز",
        },
        recovery_completed_page: {
          titleBoard: "اكتملت استعادة كلمة المرور الآن.",
          subTitle:
            "يمكنك الآن تسجيل الدخول باستخدام كلمة المرور الجديدة الخاصة بك.",
          letIn: "دعني ادخل",
        },
        main_navbar: {
          btnSchool: "دخول للمدرسة",
          contact_us: "اتصل بنا",
          pricing: "الأسعار",
          about_us: "الرئيسية",
          why_hellocode: " لماذا HelloCode ؟",
          help_center: "مركز المعلومات",
          Curriculum: "مناهجنا",
          courses: "مناهجنا",
          support: "المساعدة و الدعم",
          forSchools: "المدارس",
          forSchoolsSmall: "نسخة المدارس",
          forIndividuals: "نسخة الأفراد",
          arabic: "عربي",
          Certification: "الشهادات",
          social: "مجتمعي",
        },
        join_modal: {
          student: {
            title: "طالب",
            text: "تعلم كيفية إنشاء الكود، وصمّم مشاريع رائعة!",
            sign_up_btn: "تسجيل",
            join_btn: "انضم الان",
            login: "تسجيل الدخول إلى حساب طفلك",
            title1:
              "هل انت متأكد أنك تريد تسجيل الدخول لحساب طفلك؟ إن الاستمرار سيخرجك من حساب ولي الأمر.",
            continue: "استمرار",
            have_account: "ليس لديك حساب HelloCode؟",
            skip_ide: " تريد تخطي كتابة الكود؟ ",
            account: "هل لديك حساب HelloCode بالفعل؟",
            join: "تسجيل الدخول",
          },
          school_reg: {
            tab_header: "أطلق العنان لإبداعهم",
            tab_title: "المدرسة",
            form1: {
              title: "معلومات المدرسة",
              school_name_label: "اسم المدرسة",
              abbreviation_label: "اختصار اسم المدرسة",
              website_label: "الموقع الإلكتروني",
              email: "عنوان البريد الإلكتروني",
              city_label: "المدينة",
              country_label: "البلد",
              full_address_label: "العنوان الكامل",
              phone_number_label: "رقم الهاتف",
              language_label: "اللغة المفضلة",
              language_option1: "اللغة الإنجليزية",
              language_option2: "اللغة العربية",
              next_btn: "التالي",
              join_btn: "انضم الان",
              skip_btn: "الانتقال الى الاسئله",
            },
            form2: {
              title: "معلومات مدير المدرسة",
              username_label: "اسم المستخدم",
              password_label: "كلمه السر",
              confirm_password_label: "تأكيد كلمة السر",
              email: "عنوان البريد الإكتروني",
              first_name_label: "الاسم الأول",
              last_name_label: "اسم العائلة",
              phone_number_label: "رقم الهاتف",
              back_btn: "السابق",
              submit_request_btn: "تقديم الطلب",
              join_btn: "انضم الان",
              new: "الاسم الجديد",
              edit: "اعادة تعيين الاسم",
              alert: "قم بإدخال اسم مناسب ",
            },
          },
          parent: {
            title: "وليّ الأمر",
            text:
              "أنشئ حسابات لأطفالك، وشاهدهم يصنعون أشياء رائعة باستخدام البرمجة!",
          },

          recover_page: {
            title: "استعادة كلمة السر",
            recoverTitle: "استعادة كلمة السر",
            signIn: "تسجيل الدخول",
            home: "الرئيسية",
            dontWorry: "لا تقلق ، سوف نجعلها سريعة .",
            accessInfo: "معلومات الوصول الخاصة بك",
            back: "رجوع",
            userInput: "اسم المستخدم أو البريد الإلكتروني أو رقم الهاتف",
            empty: "فارغ",
            recoverNow: "استعادة الآن",
            ifKid: "إذا كنت طفلا ، من فضلك",
            contactParent: "الاتصال بالوالد",
          },
          create_new_password_page: {
            titleBoard: "إنشاء كلمة مرور جديدة",
            subTitle:
              "أضف كلمة مرور ستتذكرها ، نعم ، تلك التي تستخدمها كثيرًا.",
            passwordInput: "كلمة السر",
            repeatPassword: "اعد كلمة السر",
            notMatch: "كلمة السر غير متطابقة",
            completeBtn: "أكمل",
          },
          email_sent_page: {
            titleBoard: "أُرسل البريد الإلكتروني",
            subTitle:
              "لقد أرسلنا رابط الاسترداد إلى بريدك الإلكتروني ، يرجى التأكيد حتى نتمكن من متابعة استعادة كلمة المرور الخاصة بك.",
            notGettingLink:
              "لم تحصل على أي رابط ؟ الرجاء التحقق من مجلد الرسائل غير المرغوب فيها.",
            nothingYet: "لا شيء حتى الان؟",
            contactSupport: "اتصل بالدعم",
            or: "أو",
            changeEmail: "تغيير الايميل",
          },
          code_sent_page: {
            titleBoard: "نريد التحقق من هويتك.",
            subTitle:
              "لقد أرسلنا رمزًا إلى رقم هاتفك المحمول ، يرجى التأكيد حتى نتمكن من متابعة استعادة كلمة المرور الخاصة بك.",
            notGetting: "لم تحصل على أي رمز ؟",
            checkSpam: "يرجى التحقق من الرسائل العشوائية الخاصة بك.",
            changeNumber: "تغيير الرقم",
            otp: "تأكيد الرمز",
          },
          recovery_completed_page: {
            titleBoard: "اكتملت استعادة كلمة المرور الآن.",
            subTitle:
              "يمكنك الآن تسجيل الدخول باستخدام كلمة المرور الجديدة الخاصة بك.",
            letIn: "دعني ادخل",
          },
          main_navbar: {
            contact_us: "اتصل بنا",
            pricing: "الأسعار",
            about_us: "الرئيسية",
            why_hellocode: " لماذا HelloCode ؟",
            help_center: "مركز المعلومات",
            Curriculum: "مناهجنا",
            courses: "المساقات",
            support: "المساعدة و الدعم",
            forSchools: "المدارس",
            forSchoolsSmall: "نسخة المدارس",
            forIndividuals: "نسخة الأفراد",
            arabic: "عربي",
          },
          join_modal: {
            student: {
              title: "طالب",
              text: "تعلم كيفية إنشاء الكود، وصمّم مشاريع رائعة!",
            },
            parent: {
              title: "وليّ الأمر",
              text:
                "أنشئ حسابات لأطفالك، وشاهدهم يصنعون أشياء رائعة باستخدام البرمجة!",
            },
            school: {
              title: "المدرسة",
              text: "أنشئ حسابات لمدارسك، وأدر نوادي المدرسة!",
            },
            create_account: "أنشئ حساب!",
            have_account: "هل لديك حساب",
          },
          leaderboard_modal: {
            rank: "مرتبة #",
            message: "لا يوجد طلاب حالياً",
            name: "اسم الطالب",
            weekly_points: " النقاط الاسبوعية",
            leaderboard_rank: " قائمة الصدارة",
            leaderboard: "المتصدرين",
          },
          homepage: {
            homepage_start_btn: "ابدأ التعلم",
            how_it_works_button: "انظر كيف يعمل!",
            top_title: "الإبداع و الابتكار من خلال تعلم البرمجة",
            top_landing_title:
              "أفضل وقت لتعليم أطفالك كيفية البرمجة باستخدام لغة سموذي",
            landing_subscribe: "اشترك الان",
            free_trial_start: "30 يوما تجربة مجانية",
            testimonial_text:
              "استمتع ابني البالغ من العمر 8 سنوات حقًا بتعلم البرمجه من خلال هلوكود الشخصيات الجميلة تجعلها ممتعة للغاية! الإضافة الكبيرة هي أنه كلما تدربوا أكثر وحصلوا على الترميز الصحيح ، كلما حصلوا على المزيد من النقاط ، فإن الأمر يشبه ممارسة لعبة.",
            testimonial_text_haya:
              "أنا أحب Redo و Greeno ، لأنهما سيساعدانني في إنشاء تطبيقي الخاص. سيساعد تطبيقي الفقراء. ربما سأقوم بعمل تطبيق آخر لإصلاح الهواتف المحمولة وأجهزة iPad ، لأن شاشة iPad الخاصة بي تتوقف عن العمل في بعض الأحيان",
            testimonial_name: "دينا عبد المجيد",
            testimonial_name_haya: "هيا قراعين",
            testimonial_details: "المؤسس والرئيس التنفيذي في 360Moms",
            join_button: "إنشاء حساب",
            btn_competition: "سجل الان وسنقوم بالتواصل معكم",
            age_competition: "الاعمار من ٧-١٢ سنة",
            text1_competition: "مسابقة هلو وورلد كيدز للمبرمجين الصغار ٢٠٢٠",
            text2_competition: "اكبر مسابقة برمجة في الاردن",
            signin_button: "تسجيل الدخول",
            menuBtn: "القائمة",
            start_code:
              "تخفيضات بداية العام الجديد - خصم 20٪ على اشتراك مدى الحياة",
            start: "ابدأ التعلم",
            title: "البرمجة أصبحت ممتعة للأطفال",
            coursal_title: "منصة هلوكود ...... البرمجة",
            sub_title:
              "الطريقة الممتعة لتعلم البرمجة وتطوير مهارات حل المشكلات والتفكير المنطقي ! الأعمار من 7 إلى 15 سنة",
            button_title: "ابدأ التعلم مجاناً",
            testimonials: "آراء المستخدمين في برامجنا",
            title1:
              "لقد ساعدتنا منصة هلوكود بالفعل. لقد تعلم أطفالي شيئا مفيداً جداً أثناة فترة الحظر الشامل. لقد بدأنا تعلم الدروس معاً، لكن الآن هم قادرون على العمل على المنصة بشكل مستقل وهم مستمتعون جداً!",
            title2:
              "لقد انجذبت إلى هلوكود مع الرسوم المتحركة، لكنني لم أصدق أبدًا أن أطفالي سيكونون قادرين على تعلم إنشاء رسوماتهم الخاصة في مثل هذا الوقت القصير. يسعدني حقًا أن أرى تقدمهم، وقد جعلت منصة هلوكود التجربة سهلة للغاية أود أن أوصي جميع الأهالي بتسجيل أولادهم على منصة هلوكود",
            title3:
              "أقضي ليلتين في الأسبوع مع ابني نلعب الألعاب، لكننا الآن أضفنا يومًا ثالثًا لتعليمه البرمجة على هلوكود. إنه يتعلم جميع الأشياء التي كنت أتمنى لو تعلمتها وأنا في مثل عمره. ومن الرائع أن نراه يستمتع!",
            title15:
              "معظم مواقع الألعاب تدعي أنها تعليمية. لكن هذا الأمر لا ينطبق على منصة هلوكود. يظهر لي أطفالي المشاريع التي صنعوها بأنفسهم من خلال البرمجة. لقد أصبحوا مرتبطين بالمنصة ويبدو أنهم يستمتعون كثيراً!",
            title16:
              "هذه حقا لعبة تعليمية رائعة. تحصل على الدروس الأولى مجانًا ويمكنك تعلم الكثير من البداية. أطفالي يحبونها ويقولون إنها أفضل بكثير من الواجبات المدرسية.",
            title17:
              "إن هلوكود منصة رائعة وتعطي فرصة للأهالي بالمشاركة في تعليم الطفل. يمكنهم التعلم بعد عودتهم من المدرسة أو أثناء التعلم المنزلي، ولديهم طريقة منظمة للتعلم دون وجود ضغوطات علينا نحن الأهل. يمكننا التعلم معهم ودعمهم، ويمكننا اعطائهم الفرصة للتعلم الذاتي.",
            title18:
              "انني استمتع مع ابنتي اثناء تعلمها البرمجة على منصة هلوكود. تظهر المنصة تصميمًا ممتعًا وجذاباً، مع فرص لبناء وتصميم قصص من خلال البرمجة. تعلم المنصة التركيز والتفكير الإبداعي، الأمر الذي كان مفيدًا جداً أثناء الدراسة من المنزل.",
            title19:
              "البرمجة برأي ستصبح من أهم مهارات المستقبل. لذلك اغتنمت الفرصة بتسجيل أطفالي على منصة هلوكود للتعلم من المنزل. هذه المنصة توفر تجربة فريدة من نوعها للأطفال، مع إعطائنا فرصة مراقبة تقدمهم وتقدير جهدهم ونشره. أحيكم على هذه المنصة.",
            title20:
              "لقد أمضى أحفادي الكثير من الوقت معي أثناء الحظر الشامل، لذلك سجلتهم على منصة هلوكود. وقد لاحظت أنهم مستمتعون بالفعل و أجبرهم بصعوبة بترك الكمبيوتر لتناول العشاء. وقد قامت المدرسة بتشجيع هذه المنصة، وإضافة على ذلك فهم يتعلمون مهارة مهمة للمستقبل. وأنا سعيدة بهذا الخيار!",
            title21:
              "لقد وجدت أن منصة هلوكود هي أداة تعليمية قيمة يستمتع بها أطفالي. يمكنهم الآن قضاء الكثير من الوقت على الكمبيوتر بطريقة مفيدة جداً.",
            title22:
              "بصفتي مدرسًا بالمدرسة الإعدادية، أستخدم هلوكود كجزء من فصولي الأسبوعية. الطلاب حقًا ويتفاعلون كثيراً مع الشخصيات. لقد أظهروا تقدماً مثيرا للإعجاب، والمنصة تسمح لي بمتابعة أي طالب يحتاج للمساعدة. أوصي به لجميع زملائي",
            title23:
              "سعيد جداً بتسجيل طفلي في منصة هلوكود, فهو يستثمر وقته في تعلم البرمجة التي أعي أهميتها جداً. لقد استبدل ألعابه الإلكترونية بمنصة هلوكود. نحن فخورون به، وسنبقى متابعين جميع إنجازاته.",
            name: "سمر يوسف",
            name1: "بسمة صلاح",
            name2: "أشرف سلمان",
            name3: "فرح ماجد",
            name4: "سوسن ربيع",
            name5: "شرين فاضل",
            name6: "داليا عون",
            name7: "بدر ياسين",
            name8: "صباح محمد",
            name9: "كمال قاسم",
            name10: "وسيم فواز",
            name11: "مريم طلال",
            title4:
              "يوصي تسعة من كل عشرة أطباء بـ HelloCode على العلامات التجارية المنافسة. تعال إلى الداخل ، وانظر بنفسك ، وارفع مستوى مهاراتك التنموية بشكل كبير في هذه العملية.",
            title5: "تعلم البرمجة مفيد بغض النظر عن طموحاتك المهنية.",
            title6:
              "مرحبًا ، نحن دائمًا منفتحون على التعاون والاقتراحات ، تلقى أخبار المنتج والتحديثات في صندوق الوارد الخاص بك.",
            title7: "النشرة الإخبارية",
            title8: "اتصل بنا",
            title9: "روابط مفيدة",
            title10: "سجل",
            title11: "النشره الاخباريه",
            find_us: "موقعنا",
            email_us: "البريد الإلكتروني",
            title12: "دردشة",
            title13: "تابعنا",
            title14: "آخر الأخبار",
            title15:
              "لقد تلقينا بريدك الإلكتروني شكرًا لك ، فهذه طريقة رائعة للبقاء على اتصال بأحدث المستجدات من HelloCode ، بما في ذلك التحديثات على منتجاتنا ودوراتنا وروابط لمشاريع رائعة للأطفال ومعلومات عامة حول تعريف الأطفال بالبرمجة. ",
            title18: "اذهب الى الاسئله",
            title_footer:
              "اشترك في النشرة الإخبارية لدينا للحصول على آخر التحديثات والخدمات",
            preview: "عرض",
            grade_1: "الصف الأول",
            grade_2: "الصف الثاني",
            grade_3: "الصف الثالث",
            grade_4: "الصف الرابع",
            grade_5: "الصف الخامس",
            grade_6: "الصف السادس",
            grade_7: "الصف السابع",
            curriculum_button: "اجعل أطفالك يبدأون",
            title_affiliate: "برنامج التسويق بالعمولة",
            cards: {
              learn_card_title: "تعلم",
              learn_card_body:
                "Hello Code تعلم الأطفال مبادئ البرمجة من خلال لغة برمجة ممتعة ومميزة طوّرت وصمّمت خصيصاً لهم: SmoothY! التعلم عن طريق المرح واللعب سيعزز حبهم للتعلم من خلال اكتشاف عالم البرمجة بطريقة لم يختبروها من قبل.",
              learning:
                "Hello Code تعلم الأطفال مبادئ البرمجة من خلال لغة برمجة ممتعة ومميزة طوّرت وصمّمت خصيصاً لهم: SmoothY! التعلم عن طريق المرح واللعب سيعزز حبهم للتعلم من خلال اكتشاف عالم البرمجة بطريقة لم يختبروها من قبل.",
              express_card_title: "التعبير",
              express_card_body:
                "تقدم Hello Code للأطفال المعرفة التي يحتاجونها لبناء عالم خاص بهم. سيكونون قادرين على بناء التطبيقات والألعاب، أو ببساطة إنشاء مشاهد جذابة تحكي قصة من اختيارهم.",
              innovate_card_title: "الابتكار",
              innovate_card_body:
                "الآن وبعدما أصبح لدى الأطفال الأدوات المناسبة، حان الوقت لاستخدامها! Hello Code تلهم إبداعهم لترجمة أفكارهم إلى واقع حيّ. ساعد أطفالك على أن يصبحوا منتجين للتكنولوجيا ويفكروا بإبداع.",
            },
            slider: {
              title1: "ما هي Hellocode?",
              slide1:
                "HelloCode هي منصة تفاعلية عبر الإنترنت تهدف إلى تعليم الأطفال البرمجة وكتابة الأوامر. يبدأ الأطفال بالتعلم عن طريق سرد قصصي من وحي حياة الأطفال اليومية. الترابط مع شخصيات HelloCode بالإضافة إلى الدروس المبتكرة والتمارين الممتعة تشكل بيئة تعلم شمولية تقدم للطفل مجموعة من مهارات الحياة المهمة، مثل: حل المشاكل، التفكير الحسابي والتحليلي، الإبداع والتبرير المنطقي، كل ذلك عن طريق المرح!",
              title2: "أولياء الأمور",
              slide2:
                "Hello Code تعلم الأطفال البرمجة وكتابة الأوامر بطريقة ممتعة وسهلة. كوليّ أمر، بإمكانك الدخول إلى لوحة التحكم الخاصة بحسابات أطفالك لتتابع تقدمهم وإنجازهم، وبالطبع، سيكون لديك التحكم الكامل بحسابات أطفالك.",
              title3: "المدارس",
              slide3:
                "Hello Code توفر العديد من المميزات الإضافية للمدارس مثل، القدرة على إنشاء غرف صفية افتراضية بحيث يمكن للمعلمين متابعة تقدم وإنجاز طلابهم، والتأكد من عدم توقف الطالب عند مستوى معين.",
            },
            smoothy: {
              title: "لغة سموذي ",
              text1:
                "SmoothY هي لغة برمجة طورتها Hello World Kids خصيصاً للأطفال.",
              text2:
                "بإمكان الأطفال استخدام SmoothY لبناء تطبيقات، ألعاب، أو ببساطة إنشاء مشاهد جذابة تحكي قصص عالمهم الخاص بهم.",
              text3:
                "تهدف SmoothY إلى تبسيط مبادئ ومصطلحات البرمجة للأطفال من خلال تراكيب ممتعة وسهلة التعلم، بالإضافة إلى الحفاظ على نفس المنطق والدلالات الموجودة في معظم لغات البرمجة الشائعة والمألوفة لأي مبرمج.",
            },
            inspiring: {
              text1: "الابتكار الملهم",
              text2: "من خلال تعلم البرمجة",
            },
            pricing: "!تحقق من خطط التسعير لدينا",
          },
          whyhellocode: {
            slide1: {
              title: "أمان الاطفال",
              text:
                "تهتم Hello Code بأمان الأطفال. خلال تصميم المنصة كان الأمان أولوية دائماً. كما ونضمن ما يلي: تصميم موجه لاستخدام الأطفال، العائلات والمدارس.",
              point1: "الرقابة الأبوية على حساب الطفل.",
              point2: "محتوى مناسب للعمر وسلامة البيانات وإجراءات الأمان.",
              point3: "الحد الأدنى من البيانات المطلوبة من الأطفال.",
            },
            slide2: {
              title: "المشاركة مضمونة  ",
              text:
                "Hello Code هي منصة تفاعلية، تقدم تجربة تعليمية ممتعة مع مواقف الحياة الحقيقية، تثير فضول أطفالك الصغار من خلال أسلوب سرد القصص البسيط والمحبب، والذي يثري التجربة التعليمية للأطفال، ويزيد مستوى تحفيزهم.",
            },
            slide3: {
              title: "منهاج دراسي أكاديمي",
              text:
                "Hello Code تستند بالكامل على منهاج Hello World Kids الدراسي، وهو منهاج منظم وجيد التصميم، يقدم علم البرمجة وصناعة البرمجيات بالإضافة إلى الذكاء الاصطناعي.",
            },
            slide4: {
              title: "التعلم المبني على اللعبة",
              text:
                "تمتلك Hello Code عنصر الخيال الذي يدمج الأطفال في الأنشطة التعليمية من خلال القصص. يخوض الأطفال تجربة اللعب؛ بالانتقال وفتح المستويات، حل المشاريع، الحصول على النجوم والجوائز. في الوقت ذاته يشاركون في تجربة تعليمية متكاملة.",
            },
          },
          school: {
            title: "المدرسة",
            text: "أنشئ حسابات لمدارسك، وأدر نوادي المدرسة!",
          },
          create_account: "أنشئ حساب!",
          have_account: "هل لديك حساب",
        },
        leaderboard_modal: {
          rank: "مرتبة #",
          message: "لا يوجد طلاب حالياً",
          name: "اسم الطالب",
          weekly_points: " النقاط الاسبوعية",
          leaderboard_rank: " قائمة الصدارة",
          leaderboard: "المتصدرين",
        },
        homepage: {
          homepage_start_btn: "ابدأ التعلم",
          how_it_works_button: "انظر كيف يعمل!",
          top_title: "الإبداع و الابتكار من خلال تعلم البرمجة",
          top_landing_title:
            "أفضل وقت لتعليم أطفالك كيفية البرمجة باستخدام لغة سموذي",
          landing_subscribe: "اشترك الان",
          free_trial_start: "30 يوما تجربة مجانية",
          testimonial_text:
            "استمتع ابني البالغ من العمر 8 سنوات حقًا بتعلم البرمجه من خلال هلوكود الشخصيات الجميلة تجعلها ممتعة للغاية! الإضافة الكبيرة هي أنه كلما تدربوا أكثر وحصلوا على الترميز الصحيح ، كلما حصلوا على المزيد من النقاط ، فإن الأمر يشبه ممارسة لعبة.",
          testimonial_text_haya:
            "أنا أحب Redo و Greeno ، لأنهما سيساعدانني في إنشاء تطبيقي الخاص. سيساعد تطبيقي الفقراء. ربما سأقوم بعمل تطبيق آخر لإصلاح الهواتف المحمولة وأجهزة iPad ، لأن شاشة iPad الخاصة بي تتوقف عن العمل في بعض الأحيان",
          testimonial_name: "دينا عبد المجيد",
          testimonial_name_haya: "هيا قراعين",
          testimonial_details: "المؤسس والرئيس التنفيذي في 360Moms",
          join_button: "إنشاء حساب",
          btn_competition: "سجل الان وسنقوم بالتواصل معكم",
          age_competition: "الاعمار من ٧-١٢ سنة",
          text1_competition: "مسابقة هلو وورلد كيدز للمبرمجين الصغار ٢٠٢٠",
          text2_competition: "اكبر مسابقة برمجة في الاردن",
          signin_button: "تسجيل الدخول",
          menuBtn: "القائمة",
          start_code:
            "تخفيضات بداية العام الجديد - خصم 20٪ على اشتراك مدى الحياة",
          start: "ابدأ التعلم",
          title: "البرمجة أصبحت ممتعة للأطفال",
          coursal_title: "منصة هلوكود ...... البرمجة",
          sub_title:
            "الطريقة الممتعة لتعلم البرمجة وتطوير مهارات حل المشكلات والتفكير المنطقي ! الأعمار من 7 إلى 15 سنة",
          button_title: "ابدأ التعلم مجاناً",
          testimonials: "آراء المستخدمين في برامجنا",
          title1:
            "لقد ساعدتنا منصة هلوكود بالفعل. لقد تعلم أطفالي شيئا مفيداً جداً أثناة فترة الحظر الشامل. لقد بدأنا تعلم الدروس معاً، لكن الآن هم قادرون على العمل على المنصة بشكل مستقل وهم مستمتعون جداً!",
          title2:
            "لقد انجذبت إلى هلوكود مع الرسوم المتحركة، لكنني لم أصدق أبدًا أن أطفالي سيكونون قادرين على تعلم إنشاء رسوماتهم الخاصة في مثل هذا الوقت القصير. يسعدني حقًا أن أرى تقدمهم، وقد جعلت منصة هلوكود التجربة سهلة للغاية أود أن أوصي جميع الأهالي بتسجيل أولادهم على منصة هلوكود",
          title3:
            "أقضي ليلتين في الأسبوع مع ابني نلعب الألعاب، لكننا الآن أضفنا يومًا ثالثًا لتعليمه البرمجة على هلوكود. إنه يتعلم جميع الأشياء التي كنت أتمنى لو تعلمتها وأنا في مثل عمره. ومن الرائع أن نراه يستمتع!",
          title15:
            "معظم مواقع الألعاب تدعي أنها تعليمية. لكن هذا الأمر لا ينطبق على منصة هلوكود. يظهر لي أطفالي المشاريع التي صنعوها بأنفسهم من خلال البرمجة. لقد أصبحوا مرتبطين بالمنصة ويبدو أنهم يستمتعون كثيراً!",
          title16:
            "هذه حقا لعبة تعليمية رائعة. تحصل على الدروس الأولى مجانًا ويمكنك تعلم الكثير من البداية. أطفالي يحبونها ويقولون إنها أفضل بكثير من الواجبات المدرسية.",
          title17:
            "إن هلوكود منصة رائعة وتعطي فرصة للأهالي بالمشاركة في تعليم الطفل. يمكنهم التعلم بعد عودتهم من المدرسة أو أثناء التعلم المنزلي، ولديهم طريقة منظمة للتعلم دون وجود ضغوطات علينا نحن الأهل. يمكننا التعلم معهم ودعمهم، ويمكننا اعطائهم الفرصة للتعلم الذاتي.",
          title18:
            "انني استمتع مع ابنتي اثناء تعلمها البرمجة على منصة هلوكود. تظهر المنصة تصميمًا ممتعًا وجذاباً، مع فرص لبناء وتصميم قصص من خلال البرمجة. تعلم المنصة التركيز والتفكير الإبداعي، الأمر الذي كان مفيدًا جداً أثناء الدراسة من المنزل.",
          title19:
            "البرمجة برأي ستصبح من أهم مهارات المستقبل. لذلك اغتنمت الفرصة بتسجيل أطفالي على منصة هلوكود للتعلم من المنزل. هذه المنصة توفر تجربة فريدة من نوعها للأطفال، مع إعطائنا فرصة مراقبة تقدمهم وتقدير جهدهم ونشره. أحيكم على هذه المنصة.",
          title20:
            "لقد أمضى أحفادي الكثير من الوقت معي أثناء الحظر الشامل، لذلك سجلتهم على منصة هلوكود. وقد لاحظت أنهم مستمتعون بالفعل و أجبرهم بصعوبة بترك الكمبيوتر لتناول العشاء. وقد قامت المدرسة بتشجيع هذه المنصة، وإضافة على ذلك فهم يتعلمون مهارة مهمة للمستقبل. وأنا سعيدة بهذا الخيار!",
          title21:
            "لقد وجدت أن منصة هلوكود هي أداة تعليمية قيمة يستمتع بها أطفالي. يمكنهم الآن قضاء الكثير من الوقت على الكمبيوتر بطريقة مفيدة جداً.",
          title22:
            "بصفتي مدرسًا بالمدرسة الإعدادية، أستخدم هلوكود كجزء من فصولي الأسبوعية. الطلاب حقًا ويتفاعلون كثيراً مع الشخصيات. لقد أظهروا تقدماً مثيرا للإعجاب، والمنصة تسمح لي بمتابعة أي طالب يحتاج للمساعدة. أوصي به لجميع زملائي",
          title23:
            "سعيد جداً بتسجيل طفلي في منصة هلوكود, فهو يستثمر وقته في تعلم البرمجة التي أعي أهميتها جداً. لقد استبدل ألعابه الإلكترونية بمنصة هلوكود. نحن فخورون به، وسنبقى متابعين جميع إنجازاته.",
          name: "سمر يوسف",
          name1: "بسمة صلاح",
          name2: "أشرف سلمان",
          name3: "فرح ماجد",
          name4: "سوسن ربيع",
          name5: "شرين فاضل",
          name6: "داليا عون",
          name7: "بدر ياسين",
          name8: "صباح محمد",
          name9: "كمال قاسم",
          name10: "وسيم فواز",
          name11: "مريم طلال",
          title4:
            "يوصي تسعة من كل عشرة أطباء بـ HelloCode على العلامات التجارية المنافسة. تعال إلى الداخل ، وانظر بنفسك ، وارفع مستوى مهاراتك التنموية بشكل كبير في هذه العملية.",
          title5: "تعلم البرمجة مفيد بغض النظر عن طموحاتك المهنية.",
          title6:
            "مرحبًا ، نحن دائمًا منفتحون على التعاون والاقتراحات ، تلقى أخبار المنتج والتحديثات في صندوق الوارد الخاص بك.",
          title7: "النشرة الإخبارية",
          title8: "اتصل بنا",
          title9: "روابط مفيدة",
          title10: "سجل",
          title11: "النشره الاخباريه",
          find_us: "موقعنا",
          email_us: "البريد الإلكتروني",
          title12: "دردشة",
          title13: "تابعنا",
          title14: "آخر الأخبار",
          title15:
            "لقد تلقينا بريدك الإلكتروني شكرًا لك ، فهذه طريقة رائعة للبقاء على اتصال بأحدث المستجدات من HelloCode ، بما في ذلك التحديثات على منتجاتنا ودوراتنا وروابط لمشاريع رائعة للأطفال ومعلومات عامة حول تعريف الأطفال بالبرمجة. ",
          title18: "اذهب الى الاسئله",
          title_footer:
            "اشترك في النشرة الإخبارية لدينا للحصول على آخر التحديثات والخدمات",
          preview: "عرض",
          grade_1: "الصف الأول",
          grade_2: "الصف الثاني",
          grade_3: "الصف الثالث",
          grade_4: "الصف الرابع",
          grade_5: "الصف الخامس",
          grade_6: "الصف السادس",
          grade_7: "الصف السابع",
          curriculum_button: "اجعل أطفالك يبدأون",
          title_affiliate: "برنامج التسويق بالعمولة",
          cards: {
            learn_card_title: "تعلم",
            learn_card_body:
              "Hello Code تعلم الأطفال مبادئ البرمجة من خلال لغة برمجة ممتعة ومميزة طوّرت وصمّمت خصيصاً لهم: SmoothY! التعلم عن طريق المرح واللعب سيعزز حبهم للتعلم من خلال اكتشاف عالم البرمجة بطريقة لم يختبروها من قبل.",
            learning:
              "Hello Code تعلم الأطفال مبادئ البرمجة من خلال لغة برمجة ممتعة ومميزة طوّرت وصمّمت خصيصاً لهم: SmoothY! التعلم عن طريق المرح واللعب سيعزز حبهم للتعلم من خلال اكتشاف عالم البرمجة بطريقة لم يختبروها من قبل.",
            express_card_title: "التعبير",
            express_card_body:
              "تقدم Hello Code للأطفال المعرفة التي يحتاجونها لبناء عالم خاص بهم. سيكونون قادرين على بناء التطبيقات والألعاب، أو ببساطة إنشاء مشاهد جذابة تحكي قصة من اختيارهم.",
            innovate_card_title: "الابتكار",
            innovate_card_body:
              "الآن وبعدما أصبح لدى الأطفال الأدوات المناسبة، حان الوقت لاستخدامها! Hello Code تلهم إبداعهم لترجمة أفكارهم إلى واقع حيّ. ساعد أطفالك على أن يصبحوا منتجين للتكنولوجيا ويفكروا بإبداع.",
          },
          slider: {
            title1: "ما هي Hellocode?",
            slide1:
              "HelloCode هي منصة تفاعلية عبر الإنترنت تهدف إلى تعليم الأطفال البرمجة وكتابة الأوامر. يبدأ الأطفال بالتعلم عن طريق سرد قصصي من وحي حياة الأطفال اليومية. الترابط مع شخصيات HelloCode بالإضافة إلى الدروس المبتكرة والتمارين الممتعة تشكل بيئة تعلم شمولية تقدم للطفل مجموعة من مهارات الحياة المهمة، مثل: حل المشاكل، التفكير الحسابي والتحليلي، الإبداع والتبرير المنطقي، كل ذلك عن طريق المرح!",
            title2: "أولياء الأمور",
            slide2:
              "Hello Code تعلم الأطفال البرمجة وكتابة الأوامر بطريقة ممتعة وسهلة. كوليّ أمر، بإمكانك الدخول إلى لوحة التحكم الخاصة بحسابات أطفالك لتتابع تقدمهم وإنجازهم، وبالطبع، سيكون لديك التحكم الكامل بحسابات أطفالك.",
            title3: "المدارس",
            slide3:
              "Hello Code توفر العديد من المميزات الإضافية للمدارس مثل، القدرة على إنشاء غرف صفية افتراضية بحيث يمكن للمعلمين متابعة تقدم وإنجاز طلابهم، والتأكد من عدم توقف الطالب عند مستوى معين.",
          },
          smoothy: {
            title: "لغة سموذي ",
            text1:
              "SmoothY هي لغة برمجة طورتها Hello World Kids خصيصاً للأطفال.",
            text2:
              "بإمكان الأطفال استخدام SmoothY لبناء تطبيقات، ألعاب، أو ببساطة إنشاء مشاهد جذابة تحكي قصص عالمهم الخاص بهم.",
            text3:
              "تهدف SmoothY إلى تبسيط مبادئ ومصطلحات البرمجة للأطفال من خلال تراكيب ممتعة وسهلة التعلم، بالإضافة إلى الحفاظ على نفس المنطق والدلالات الموجودة في معظم لغات البرمجة الشائعة والمألوفة لأي مبرمج.",
          },
          inspiring: {
            text1: "الابتكار الملهم",
            text2: "من خلال تعلم البرمجة",
          },
          pricing: "!تحقق من خطط التسعير لدينا",
        },
        whyhellocode: {
          slide1: {
            title: "أمان الاطفال",
            text:
              "تهتم Hello Code بأمان الأطفال. خلال تصميم المنصة كان الأمان أولوية دائماً. كما ونضمن ما يلي: تصميم موجه لاستخدام الأطفال، العائلات والمدارس.",
            point1: "الرقابة الأبوية على حساب الطفل.",
            point2: "محتوى مناسب للعمر وسلامة البيانات وإجراءات الأمان.",
            point3: "الحد الأدنى من البيانات المطلوبة من الأطفال.",
          },
          slide2: {
            title: "المشاركة مضمونة  ",
            text:
              "Hello Code هي منصة تفاعلية، تقدم تجربة تعليمية ممتعة مع مواقف الحياة الحقيقية، تثير فضول أطفالك الصغار من خلال أسلوب سرد القصص البسيط والمحبب، والذي يثري التجربة التعليمية للأطفال، ويزيد مستوى تحفيزهم.",
          },
          slide3: {
            title: "منهاج دراسي أكاديمي",
            text:
              "Hello Code تستند بالكامل على منهاج Hello World Kids الدراسي، وهو منهاج منظم وجيد التصميم، يقدم علم البرمجة وصناعة البرمجيات بالإضافة إلى الذكاء الاصطناعي.",
          },
          slide4: {
            title: "التعلم المبني على اللعبة",
            text:
              "تمتلك Hello Code عنصر الخيال الذي يدمج الأطفال في الأنشطة التعليمية من خلال القصص. يخوض الأطفال تجربة اللعب؛ بالانتقال وفتح المستويات، حل المشاريع، الحصول على النجوم والجوائز. في الوقت ذاته يشاركون في تجربة تعليمية متكاملة.",
          },
        },
        pricing: {
          title: "حزم الاشتراك",
          partner_title: "شركاؤنا",
          subheader: "خطط اشتراكات مختلفة مع فترة تجربة لمدة ثلاثة أيام.",
          buy_btn: "اشترك الآن",
          free: "مجانا ل٣٠ يوم",
          basic: "الأساسي",
          pre: "الممتاز",
          opt: "الأمثل",
          best: "موصى به",
          now: "اشترك الآن واحصل على خصم 50٪",
          just_now: "الآن",
        },
        offer: {
          title: "عرض خاص",
          text: "اشترك الآن واحصل على خصم 30%  على جميع حزم الاشتراك",
          time: "استخدم كوبون كود",
          mobile:
            "ملاحظة: للحصول على أفضل تجربة في تعلم لغة سموذي للبرمجة يجب عليك ان تستخدم جهاز الكمبيوتر أو اللابتوب",
          discount: "ملاحظة: عند مغادرة الصفحة ، ستفقد قسيمة الخصم الخاصة بك",
        },
        connect: {
          contact_us: "اتصل بنا",
          form: {
            name: "الاسم",
            email: "البريد الإلكتروني",
            reason: "السبب",
            message: "الرسالة",
            local_address: "عنوان المقر  ",
            select_reason: "يرجى اختيار السبب",
            option1: "أفكار جديدة لمشاركتها معنا",
            option2: "بلغ عن خطأ/مشكلة",
            option3: "شراكة",
            option4: "أنت معلم أو مدرسة",
            option5: "طلب دورة جديدة",
            option6: "أخرى",
            min_chars: "الحد الأدنى لعدد الرموز هو",
            provide_valid_email: "يرجى إدخال عنوان بريد إلكتروني فعال",
          },
          send_button: "إرسال",
          address_title: "عنوان المقر  ",
          po_box_title: "صندوق البريد",
          landline_number_title: "رقم الهاتف",
          address: "شارع مكة المكرمة بناية رقم 33 الطابق - 5 ، عمان ، الأردن",

          po_box: "٢٣٠١٩٦",
          landline_number: "  ٧٩٠٤٨٨٨٤٠ ٩٦٢+ ",
          whatsapp: "الرقم ",
          whatsapp_number: " ٧٩٠٤٨٨٨٤٠ ٩٦٢+ ",
        },
        teacher_classrooms: {
          general_report: "تحميل التقرير لجميع المدارس",
          students: "عدد الطلاب",
          teachers: "عدد المعلمات",
          title: "الغرف الصفية",
          students: "الطلاب",
          top_stu: "أفضل خمسة طلاب أسبوعيًا",
          total: "مجموع النقاط",
          over_point: "لوحة الأبطال الأوائل",
          leader: "لوحة المتصدرين",
          stu_msg: "جميع الطلاب ومعلميهم مدرجون في القائمة هنا",
          stu_dets: "تفاصيل معلومات الطالب",
          label_add: "اضف غرفة صفية",
          classroom: "الغرفة الصفية",
          message: "اختر دورة من القائمة لاظهار الأنجازات و الاختبارات",
          viewreport: "مشاهدة التقرير",
          student_name: "اسم الطالب",
          teacher_name: "اسم المعلم",
          points_student: "النقاط",
          desc:
            "أدر الغرف الصفية الخاصة بك. إضافة غرفة صفية بعدد من الطلاب، الصف ودورات Hello Code.",
          select_teacher: "إختر معلماً",
          reports: "التقارير",
          main_reports: "التقرير العام وتقارير الغرف الصفية.",
          report_down: "تحميل",
          down_reports: " تحميل تقرير العام",
          det_reports: "تحميل تقرير مفصل",
          class_reports: "تقارير  الغرف الصفية",
          general_reports: "تحميل تقرير المدرسة",
          message:
            "تأكد مما يلي: ان وقت البدء او الانتهاء ليس اكبر من اليوم  ،وقت البدء اقل من وقت الانتهاء ",
          To: "إلى",
          From: "من",
          teacher_name: "اسم المعلم/ة : ",
          header: {
            tab_title1: "الغرف الصفية",
            tab_title2: "تقييم الدروس",
            tab_title3: " تقييم الكودات",
            tab_title4: "كتابة الكود",
            tab_title6: "ساحة اللعب",
            tab_title5: "لنلعب معاً",
            search: "بحث عن اسم الفصل",
          },
          card: {
            grade: "الصف",
            Students: "الطلاب",
            current_course: "الدرس الحالية",
            completions: "الإكمالات",
            green_btn: "أظهر التفاصيل",
            gray_btn: "أرشفة",
          },
          add_classrooms_btn: "أضف غرفة صفية",
          lesson_stones: " الدروس, ",
          challenge_stones: " التحديات, ",
          projectsـsubmissions: " المشاريع.",
          add_classroom_modal: {
            modal_title: "أضف غرفة صفية!",
            classroom_title: "عنوان الغرفة الصفية",
            name: "العنوان",
            grade: "الصف",
            number_of_seats: "عدد المقاعد",
            course: "المادة",
            start: "البداية",
            end: "النهاية",
            grade_message: "يرجى اختيار الصف",
            course_message: "يرجى اختيار الدوره",
            course_equals: "وقت البداية يجب أن لا يكون نفس وقت الانتهاء",
            time_greater: "وقت الانتهاء يجب أن يكون بعد وقت البداية",
            required: "حقل جداول الفصول الدراسية مطلوب",
            select_message: "*اختر الأيام الخاصة بغرفتك الصفية*",
            add_btn: "أضف غرفة صفية",
            grade_placeholder: "اختر واحدة",
            course_placeholder: "حدد الخيار",
            days: {
              sunday: "الأحد",
              monday: "الاثنين",
              tuesday: "الثلاثاء",
              wednesday: "الأربعاء",
              thursday: "الخميس",
              friday: "الجمعة",
              saturday: "السبت",
            },
          },
          no_top_five:
            "بسبب غياب الطلاب في الوقت الحالي، لا تعرض لائحة قائمة المدرسة أي طلاب متفوقين.",
          no_titan_students:
            "بسبب غياب الطلاب في الوقت الحالي، لا تعرض لائحة قائمة المدرسة أي طلاب متفوقين بلقب الـ 'Titans'.",
        },
        days: {
          sunday: "الأحد",
          monday: "الاثنين",
          tuesday: "الثلاثاء",
          wednesday: "الأربعاء",
          thursday: "الخميس",
          friday: "الجمعة",
          saturday: "السبت",
        },
        course: {
          DoneModalText:
            "لقد أكملت هذه الدورة بنجاح! نراكم في الفصل الدراسي القادم.",
        },
        teacher_ide: {
          ide: "برمج هنا",
          code: "شاهد الحل",
          code_solutionـlesson: "حل الدرس",
          code_solutionـchallenge: "حل المشروع",
          message: "لا يوجد حلول الكودات لهذه الدوره",
          challenge_solution: "حلول التحديات",
          lesson_solution: "حلول الدروس",
          lesson_question: " حلول اسئلة الدروس",
          see: "شاهد الاسئلة",
          no_question: "لا توجد أسئلة لهذا الدرس",
        },
        teacher_classroom_details: {
          lesson_number: "رقم الدرس",
          select_all_lessons: "اختيار جميع الدروس",
          selectall: "اختيار جميع الطالب",
          edit: "تعديل",
          save: "حفظ",
          logName: "اسم المستخدم",
          grade: "درجة",
          answer: "حلول الأسئلة",
          assign_student_modal: {
            message: "لقد وصلت إلى الحد الأقصى لعدد الطلاب",
          },
          total_students_assigned: "مجموع الطلاب المعينين",
          curent_course: "الدورة الحالية",
          days: {
            Sunday: "الأحد",
            Monday: "الإثنين",
            Tuesday: "الثلاثاء",
            Wednesday: "الأربعاء",
            Thursday: "الخميس",
            Friday: "الجمعة",
            Saturday: "السبت",
          },
          current_schedule: "الجدول الحالي",
          edit_details_btn: "عدل التفاصيل",
          edit_Schedule: "عدل الجدول",
          cancel_btn: "إلغاء",
          whats_btn: "حفظ التغييرات",
          start_btn: "البداية",
          end_btn: "النهاية",
          assigned_students: "الطلاب المعينين",
          teacher_guid: "ارشاد المعلم",
          show_video: "شاهد الفيديو",
          lessons_videos: "فيديوهات الدروس",
          no_lesson_to_reset: "لا يوجد دروس تم انهائها",
          no_lessons_to_finish: "يجب عليك فتح الدروس قبل انهائهم",
          reset_lessons_for_student: "اعادة الاسئلة لكل الطلاب",
          finish_lessons_for_student: "انهاء الدروس لكل الطلاب",
          finish_lessons: "انهاء الدروس",
          unlock_lesson_for_students: "فتح الدروس للطلاب",
          reset_questions: "اعادة الاسئلة",
          no_challenges_to_reset: "لا يوجد تحديات تم انهائها",
          no_projects_to_reset: "لا يوجد مشاريع تم انهائها",
          reset_challenges_for_student: "اعادة التحديات للطلاب",
          reset_challenges_single_student: "اعادة التحديات للطالب",
          no_lesson: "لا توجد تحديات لإعادة تعيينها",
          reset_challenges: "اعادة التحديات",
          challenge_title: "اسم التحدي",
          unlock_lessons: "فتح الدرس",
          lock_lessons: "اغلاق الدرس",
          completeLastLessonTr: "انهاء الدرس الاخير",
          stones_number: "رقم الحجر",
          locked: "مقفل",
          unlocked: "غير مقفل",
          completed: "مكتمل",
          status: "الحالة",
          lesson_title: "اسم الدرس",
          login_name: "اسم الدخول",
          generate: "انشاء",
          current_lesson: "الدرس الحالي",
          skills_score: "درجة المهارات",
          std_name: "اسم الطالب",
          completions_submissions: "الإكمالات/التقديمات",
          actions: "الأفعال",
          add_new_student_btn: "إنشاء طالب جديد",
          assign_student: "تعيين الطلاب",
          remove_selected_btn: "أزل المحدد",
          add_student_modal: {
            modal_title: "أضف طالب جديد!",
            student_account_limit: "حد حسابات الطلاب:",
            first_name: "الاسم الاول",
            last_name: "اسم العائلة",
            year_of_birth: "سنة الميلاد",
            select_year: "يرجى تحديد سنة الميلاد",
            login_name: "اسم الدخول",
            password: "كلمة السر",
            confirm_password: "تأكيد كلمة السر",
            add_student_btn: "إضافة طلاب",
            Unassigned_Students: "الطلاب الغير مضافين",
          },
          remove_student_modal: {
            message:
              "هل أنت متأكد من أنك تريد إزالة الطلاب المحددين من الغرفة الصفية؟",
            yes_btn: "نعم",
            cancel_btn: "إلغاء",
            remove_title: "ازالة الطلاب",
          },
          reset_lessons_modal: {
            message:
              "هل أنت متأكد من أنك تريد إعادة الاسئلة للطلاب المحددين من الغرفة الصفية ؟",
            yes_btn: "نعم",
            cancel_btn: "إلغاء",
            reset_lessons: " إعادة الاسئلة",
            reset_detales: "إعادة || تفاصيل",
          },
          approval_student_modal: {
            applause_sent: "تمت الموافقة على البرنامج",
            approve_under_title: "لا تتردد في ترك تعليق",
            approve_point_msg: "اعطاء نقاط على المشروع من ١٠٠ الى ٥٠٠",
            leave_comment_btn: "اترك تعليق",
            required_msg: "هذه الخانة مطلوبة",
            disapprove_title: "تم ارسال الرد",
            message: "إختر تعليقك المناسب",
            message_a: "	عمل رائع أحسنت :)",
            message_b: "نتيجة متقنة ممتاز :)",
            message_c: "	أحسنت أيها المبرمج :) ",
            message_d: "نتيجة جميلة، استمر بالعمل الرائع :)",
            message_e:
              "عمل جميل، ولكن تأكد من مطابقة هدف المشروع في المرات القادمة :)",
            message_f: "	أبدعت عمل جميل ومتقن :)",
            message_dis_a:
              "	عزيزي المبرمج، نحن نؤمن بقدرتك على تحقيق هدف المشروع! استمر بالعمل على برنامجك :)",
            message_dis_b:
              "	لا مشكلة بوجود بعض الأخطاء! صحح الأخطاء في برنامجك ومن ثم تابع العمل عليه :)",
            message_dis_c:
              "أحسنت أيها المبرمج لقد اقتربت من تحقيق الهدف! تابع العمل على برنامجك :)",
            message_dis_d:
              "	نحن نؤمن بأنك قادر على حل هذا التحدي! تحقق من الهدف.. فكر ومن ثم حاول مرة أخرى :) ",
          },
        },
        tabs: {
          lessons: " الدروس",
          challenges: "التحديات",
          projects: "المشاريع",
          see_comments: "شاهد جميع التعليقات",
          no_completion_courses: "يرجى إكمال الكورس للحصول على شهادتك.",
          get_certification: "الحصول على شهادة",
          view_certification: "عرض الشهادة",
          comment: "نص التعليق",
          comments_date: "تاريخ التعليق",
          project_name: "اسم المشروع",
          project_comment: "التعليقات",
          share: "مشاركة",
          ProjectـStatus: "الحاله",
          Selected_Status: "اختر حاله المشروع",
          see_more: "شاهد المزيد",
          no_comment: "لا يوجد تعليق",
        },
        lesson_assessment: {
          not_selected: "اختر دورة و درس لإظهار المعلومات",
          Assesments: "تقييمات التقدم",
          challenges: " التحديات",
          choose_a_lesson: "اختر درس لاظهار التحديات",
          another_lesson: "اختر درس آخر",
          lessonss: "الدروس",
          title: "تقييم الدروس",
          lessons: "▼ الدروس",
          select_classroom: "اختر الغرفة الصفية",
          select_lesson: "اختر الدرس",
          data_table: {
            less_dets: "تفاصيل الدرس",
            school_name: "اسم المدرسة",
            last_login: "اخر تسجيل دخول",
            activity_level: "مستوى النشاط",
            active: "نشط",
            profile: "الملف الشخصي",
            username_col: "اسم المستخدم",
            classroom_name_col: "اسم الغرفة الصفية",
            teacher_name_col: "اسم المعلم",
            course_name_col: " اسم الدرس",
            number_students_classroom: "عدد الطلاب في الغرفة الصفية",
            grade_name_col: "اسم الصف",
            lesson_title_col: "عنوان الدرس",
            assessment_result_col: "نتيجة التقييم",
            student_profile: "صفحة الطالب",
            child_info: "معلومات الطالب",
            child_progress: "تقدم الطفل",
            certificate: "الشهادات",
            achievements: "إنجازات",
            selected_course: "اختر الكورس",
            search: "بحث",
            show_label: "عرض",
            entries_label: "إدخال",
            entries_labels: "إدخالات",
            rows: "صفوف",
            entries_to: "الى",
            entries_of: "من",
            entries_shown: "عرض",
            next: "التالي",
            previous: "السابق",
            zero_entries: "عرض 0 إدخالات",
            no_data: "لا توجد بيانات متاحة في الجدول",
            student_name_col: "اسم الطالب",
            placeholder: "اسم المستخدم واسم الطالب",
            undefined: "غير مضاف",
            resubmit: "أعيد إرسالها في",
            no_class: "لا توجد دروس مكتملة حتى الآن",
            student_achievements: "إنجازات الطفل",
            rate: "تقييمات الطالب",
            projs: "المشاريع",
            overview: "نظرة عامة",
          },
        },
        "submissions-and-reviews": {
          title: "تقييم الكودات",
          lessons: " الدروس ",
          challenges: " التحديات ",
          projects: " المشاريع ",
          cod_ass: "تقييم الكود",
          code_ass_message: " الاطلاع علي كود الطلاب وتقييمه. ",
          code_pro_message:
            "أدوات تقييم هلوكود المتطورة لمراقبة تقدم الطلاب وأدائهم أثناء تعلمهم البرمجة.",
          export_excel_btn: "تحميل ملف اكسل",
          data_table: {
            project_type: "نوع المشروع",
            username_col: "اسم المستخدم",
            classroom_name_col: "اسم الغرفة الصفية",
            grade_name_col: "اسم الصف",
            lesson_title_col: "عنوان الدرس",
            submitted_at: "تم تحديثه",
            created_at: "وقت التقديم",
            created: "وقت الإنشاء",
            updated_at: "وقت التحديث",
            status_col: "حالة التقديم",
            project_name_col: "اسم المشروع",
            search: "بحث",
            show_label: "عرض",
            entries_label: "إدخالات",
            entries_shown: "حصل على  مجموعه",
            next: "التالي",
            previous: "السابق",
            zero_entries: "عرض 0 إدخالات",
            no_data: "لا توجد بيانات متاحة في الجدول",
          },
        },
        school_teachers: {
          header: {
            tab_title1: "المعلمون",
            tab_title2: "الغرف الصفية",
            tab_title3: "الطلاب",
          },
          schools_dash: "المدارس",
          description_text_schoo: "ابق على اطلاع دائم بأداء مدارسك.",
          down_all_rep: "تحميل تقرير جميع المدارس",
          search_placeholder_schools: "البحث عن مدرسة",
          title: "المعلمون",
          desc: "أدر المعلمين في مدرستك",
          description_text:
            "سيتم عرض جميع المعلمين الذين قمت بإدراجهم أو مشاركتهم أو إنشائهم هنا   .",
          current_cl: "الغرف الصفية الحالية ",
          classrooms: "غرف صفية",
          skills_report: "تقرير المهارات",
          current_std: "الطلاب الحاليين",
          student: "طلاب",
          view_detalis: "عرض التفاصيل",
          search_placeholder: "ابحث عن معلم",
          delete_teacher: "حذف حساب المعلم",
          errorSearchMsg: "0 نتائج لهذا الاسم في معلميك",
          btn_down: "التحميل",
          overview_stu: "بطاقة الطالب العامة",
          project_stu: "بطاقة مشاريع الطالب",
          general_stu: "التقرير العام للطالب",
          down_btn: "التحميل",
          change_psaa: "تغيير كلمة سر المعلم",
          cards: {
            PDFdownload: "تنزيل PDF",
            Exceldownload: "تنزيل Excel",
            reports: "التقارير",
            certificate: "شهادات",
            stu_overView: "معلومات الطالب",
            stu_projects: "مشاريع الطالب",
            stu_reports: "تقرير الطالب",
            teacher_name: "اسم المعلم",
            login_name: "اسم الدخول",
            account_status: "حالة الحساب",
            classrooms: "الغرف الصفية",
            see_all: "إظهار الكل",
            see_course: "دروس المعلم",
            see_statistics: "إحصائية المعلم",
            see_info: "جميع المعلومات",
            see_class: "الغرف الصغية",
            see_statistics_class: " إحصائيات الغرف  ",
            see_info_class: "جميع المعلومات",
            no_class: "لا توجد غرف صفية",
            courses: "المواد",
            total_students: "مجموع الطلاب",
            date_created: "تاريخ الإنشاء",
            last_login: "آخر تسجيل دخول",
            disable_account: "تعطيل الحساب",
            reset_password: "إعادة ضبط كلمة السر",
            enable_account: "تفعيل الحساب",
            total_course_projects: "عدد مشاريع ",
            total_course_projects_pending: "قيد الانتظار",
            total_course_projects_aprroved: " المقبول",
            total_course_projects_disapproved: "غير المقبول",
            total_playground_projects: "عدد مشاريع  ",
            total_playground_pending: "قيد الانتظار",
            total_playground_approved: "المقبول",
            total_playground_disapproved: " غير المقبول",
            total_points: "مجموع النقاط",
            weekly_points: "النقاط الاسبوعية",
            question_score: "مجموع الأسئلة الصحيحة",
            skill_score: "مجموع المهارات المكتسبة",
            courses: "كورسات",
            current_course: "الكورس الحالي",
            locked_course: "كورس مغلق",
            sure_locked_message: "هل انت متـأكد من انك تريد ان  تفتح",
            sure_locked_message2: "هل انت متـأكد من انك تريد ان  تغلق",
            sure_locked_courses: "كورس",
            yes_lock: "نعم اغلق",
            yes_unlock: "نعم افتح",
            cancel: "اغلاق",
            lock_classroom: "هل انت متأكد من انك تريد اغلاق ",
            unlock_classroom: "هل انت متأكد من انك تريد فتح",
            all_students: "لكل الطلاب في هذه الغرفة الصفية",
            lock_course: "اغلق الكورس",
            unlock_course: "افتح الكورس",
            no_skills: "هذا الطالب ليس لديه اي مهارات",
          },
          add_teachers: "+ أضف معلم",
          add_teaher_modal: {
            title: "إضافة معلم جديد",
            teacher_account_limit: "الحد الأقصى لحساب المعلم",
            student_accounts_limit: "الحد الأقصى لحساب الطالب",
            username: "اسم المستخدم",
            name: "اسم المعلم ",
            last_name: "الاسم الأخير",
            password: "كلمة السر",
            confirm_password: "تأكيد كلمة السر",
            email_address: " البريد الإلكتروني",
            email_address_b12: " البريد الإلكتروني b12",
            phone_number: "رقم الهاتف",
            add_teacher: "إنشاء و إرسال دعوة",
            cancel: "إلغاء",
            min_characters: "الحد الأدنى لعدد الرموز هو",
            passwords_must: "يجب أن تكون كلمات السر متطابقة.",
            please_provide: "يرجى إدخال عنوان بريد إلكتروني فعال",
            empty: "",
          },
          reset_modal: {
            title: "إعادة ضبط كلمة السر",
            new_pass: "كلمة السر الجديدة",
            enter_pass: "أدخل كلمة السر",
            reset_btn: "إعادة ضبط",
            reset_challenges: "اعادة التحديات",
            cancel: "إلغاء",
            min_characters: "الحد الأدنى لعدد الرموز هو",
            placeholder: "أدخل كلمة السر",
            reset_password: "ضبط  كلمة السر",
            check_students: "لا يوجد طلاب",
          },
          enable_disable_modal: {
            title: "هل أنت متأكد؟",
            desc_enable: "هل أنت متأكد من أنك تريد تفعيل حساب المعلم",
            desc_dis: "هل أنت متأكد من أنك تريد تعطيل حساب المعلم",
            disable_account: "تعطيل الحساب",
            enable_account: "تفعيل الحساب",
            yes: "نعم ",
            no: "لا",
          },
          teacher_details: {
            title: "الغرف الصفية",
            grade: "المستوى",
            cancel: "إغلاق",
            Classroom_name: "الغرفة الصفية",
            current_course: "الدورة الحالية",
            move_classroom: "نقل الغرفة الصفية",
            zero_classrooms: "لا يوجد غرف صفية لدى هذا المعلم",
          },
          assign_teacher: {
            title: "قم بإختيار المعلم الذي تريد نقل الغرفة الصفية إليه",
            statment: "قائمة المعلمين",
            move_room: "نقل الغرفة الصفية",
            close_room: "إغلاق",
          },
          teacher_profile_table: {
            teachers: "المعلمون",
            teacher_Name: "اسم المعلم",
            teacher_status: "فعال",
            teacher_status_red: "غير فعال",
            teacher_students: "الطلاب",
            teacher_courses: "الدورات",
            teacher_namecourses: "اسم الدورة",
            teacher_lastlogin: "آخر ظهور",
            teacher_email: "البريد الإلكتروني",
            teacher_dont_have_email: "المعلم لا يمتلك بريد الكتروني",
            teacher_classrooms: "الغرف الصفية",
            course_information: "معلومات الدورة",
            classrooms_information: "معلومات الغرفة الصفية",
            classroom_name: "اسم الغرفة الصفية",
            classroom_status: "الصف",
            courses_projects: "مشاريع الدورة",
            playground_projects: "مشاريع ساحة اللعب",
            totalpoint: "أفضل خمس طلاب",
            TopfiveStu: "أفضل خمس طلاب",
            total: "مجموع النقاط",
            teacher_playgroundNum: "عدد مشاريع ساحة اللعب",
            teacher_classroomsNum: "عدد مشاريع الغرف الصفية",
            teacher_coursesNum: "عدد مشاريع الدورة",
            teacher_classroomsStatusA: "تمت الموافقة عليه",
            teacher_classroomsStatusP: "قيد النظر",
            teacher_classroomsStatusD: "لم تتم الموافقة عليه",
            teacher_selector: "اختر الغرفة الصفية",
            teacher_disAccount: "تعطيل الحساب",
            approved_pro: "موافق عليه",
            Rejected_pro: "مرفوض",
            no_top_five_class:
              "لا يوجد طلاب متفوقون لهذه الدورة في الوقت الحالي",
            teacher_certifiacte: "الشهادات",
            generate_certifiacte: "إصدار",
            download: "تحميل",
            Close: "إغلاق",
            preview: "عرض",
            no_certi: "ليس لديك اي شهادات بعد",
          },
        },
        parent: {
          header: {
            tab_title1: "أطفالي",
            tab_title2: "العضوية",
            tab_title3: "اتصل بنا",
            tab_title4: "الاشتراكات",
            tab_title5: "لم تقم بإضافة الأطفال حتى الآن",
            tab_title6: "أطلق العنان لإبداع أطفالك وسجل الآن!",
            tab_title7: "إضافة حساب طفل",
            tab_title8:
              "هنا يمكنك رؤية إجمالي النقاط التي تكسبها أثناء رحلة التعلم على HelloCode من البداية. يتم تحديث إنجازك في كل مرة تكسب فيها المزيد من النقاط! ثابر على العمل الجيد!",
            tab_title9:
              "مبرمجنا الصغير ، يمكنك دائمًا العثور على نقاطك اليومية هنا ، حيث في كل مرة تكسب فيها نقاطًا ، ستتم إضافتها هنا يوميًا. ولكن ستتم إعادة تصفيره كل يوم أحد من كل أسبوع الساعة 12:00 صباحًا.",
            tab_title10:
              "نظرًا لأن التكنولوجيا مدمجة في كل جانب من جوانب حياتنا تقريبًا ، فإن التعرف عليها أصبح أكثر أهمية من أي وقت مضى. بالنسبة للأطفال ، تجعل منصة البرمجة الخاصة بنا اكتساب المعرفة التي ستفيدهم جيدًا طوال حياتهم أمرًا مريحًا وممتعًا. يمكنك الاعتماد على أساليبنا الموثوقة لمساعدتهم على تطوير قدراتهم وتنميتها باستخدام أجهزة الكمبيوتر.",
            tab_title11: "من نحن؟",
            refund: "استرداد 100٪ من المبلغ في نفس اليوم",
          },
          manage_my: {
            title: "إدارة حسابات أطفالي",
            desc: "أضف أطفالك إلى HelloCode® ليستمتعوا بتعلم البرمجة.",
            card: {
              login_as: "تسجيل الدخول كطالب",
              is_in_trial: "في الفترة التجريبية ، 5 دروس مجانية",
              account_status: "حالة الحساب",
              active_course: "الدورات الفعالة",
              active: "فعال",
              inactive: "غير فعال",
              completed_courses: "الدورات المكملة",
              completed_lessons: "الدروس المكملة",
              no_courses: "لم يتم إكمال دورات بعد",
              no_lessons: "لم يتم اكمل دروس بعد",
              subscription_plan: "خطط الاشتراك",
              subscription_expiry: "انتهاء الاشتراك",
              disable_account: "تعطيل الحساب",
              enable_account: "تفعيل الحساب",
              click_here: "اضغط هنا",
              reset_password: "إعادة ضبط كلمة السر",
              see_all: "إظهار الكل",
              subscription_expired: " انتهت صلاحية الاشتراك",
              subscription_active: "الاشتراك فعال",
            },
            reset_modal: {
              title: "إعادة ضبط كلمة السر",
              new_pass: "كلمة السر الجديدة",
              enter_pass: "أدخل كلمة السر",
              reset_btn: "إعادة تعيين",
              cancel: "إلغاء",
              min_characters: "الحد الأدنى لعدد الرموز هو",
              placeholder: "أدخل كلمة السر",
            },
            enable_disable_modal: {
              title: "هل أنت متأكد؟",
              desc_enable: "هل أنت متأكد من أنك تريد تفعيل حساب المبرمج",
              desc_dis: "هل أنت متأكد من أنك تريد تعطيل حساب المبرمج",
              yes: "نعم ",
              no: "لا",
            },
            add_child: "أضف الطفل.",
            edit_info: "تعديل المعلومات",
            active: "فعال",
            parent_profilt: "حسابي",
            add_child_modal: {
              title: "إضافة حساب طفل",
              message:
                "سيستمتع طفلك بفترة تجريبية لمدة  شهر وسيتمكن من الدخول إلى أول ثلاث دروس مجاناً. بإمكانك شراء حساب كامل من صفحة العضوية.",
              child_name: "اسم الطفل",
              first_name: "الإسم الأول",
              last_name: "اسم ولي الأمر",
              login_name: "اسم الدخول",
              confirm_password: "تأكيد كلمة السر",
              password: "كلمه السر",
              email_address: "عنوان بريد إلكتروني",
              year_birth: "سنة الميلاد",
              parent_address: "عنوان البريد الإلكتروني لولي الأمر",
              need_help: "تحتاج مساعدة",
              min_characters: "الحد الأدني لعدد الرموز هو",
              password_identical_msg: "يجب أن تكون كلمات السر متطابقة.",
              add_kid: "أضف طفل",
              provide_valid_email: "يرجى إرسال عنوان بريد إلكتروني فعال",
              select_valid_birthyear: "يرجى تحديد عمر الطفل",
              select_age: "اختر عمرك",
            },
            updateInfo: "للحصول على تجربة أفضل ، يرجى ملء المعلومات أدناه",
            //   update_title:"ْتحديث المعلومات"
          },
          membership: {
            title: "تفاصيل العضوية",
            desc: "أدر تفاصيل ومعلومات الدفع الخاصة بحسابات أطفالك",
            table: {
              child_username: "اسم المستخدم للطفل",
              subscription_plan: "خطة الاشتراك",
              price: "السعر",
              status: "الحالة",
              subscription_expiry: "انتهاء الاشتراك",
              renew_subscription: "تجديد الاشتراك",
              cancel_subscription: "إلغاء الاشتراك",
            },
            cancel_modal: {
              title: "إلغاء الاشتراكات",
              desc1: "لن يتم تجديد حسابات أطفالك تلقائياً.",
              desc2:
                "سيظل بإمكان الأطفال تسجيل الدخول حتى تنتهي صلاحية اشتراكهم الحالي.",
              child_account: "حساب المبرمج",
              subscription_plan: "خطة الاشتراك",
              subscription_expiry: "انتهاء الاشتراك",
              subscription_status: "حالة الاشتراك",
              subscription_cancel: "إلغاء الاشتراك",
            },
          },
          renewSubscription: {
            stepone:
              "التعليم لا حدود له! كن عضواً فعالاً في زيادة مبرمجي المستقبل واختر عدد الأطفال الخاص بك",
            continuesteo1: "التالي",
            subscription_renewal: "تجديد الاشتراك",
            desc: "حدد الحساب الذي تريد ترقيته.",
            child_username: "اسم المستخدم للطفل",
            username: "اسم المستخدم",
            upgrade: " تفعيل الحساب",
            current_subscription_expiry: "انتهاء الاشتراك الحالي",
            new_subscription_expiry: "تاريخ انتهاء الاشتراك الجديد",
            total_price: "السعر الكلي",
            next: "التالى",
            need_help: "تحتاج مساعدة",
            message_green:
              "سيتم الخصم من بطاقة الائتمان الخاصة بك. تحقق من السعر  الكلي.",
            on: "نعم",
            off: "لا",
            select_child: "ترقية حساب المبرمج",
            subscription_plan: "خطة الاشتراك",
            card_information: "معلومات البطاقه",
            plan: "إختر طريقة الدفع",
            full_assisted: "شامل التعليم المساند",
            assisted: " اضافة التعليم المساند",
            features: "المزايا",
            month: "شهر",
            future_courses: "كل الكورسات المستقبليه",
            hello_code: "هلوكود",
            select: "اختيار",
            assisted_learning:
              "يقوم معلم معتمد من هلو وورلد كيدز بتقييم مشاريع طفلك و إعطاء ملاحظات و توجيهات مباشرة لمساعدة الطفل في التعلم.",
            saving: "%*40 وفّر ",
            code: "قم بإدخال كود الخصم الخاص بك",
            discount: "الخصم",
            childNumber: "عدد الأبناء المختارين ",
            coupon_assisted: "تكلفة التعليم المساعد ",
            subtotal: "رسوم الاشتراك",
            apply: "طبّق الخصم",
            coupon_title: "كوبون الخصم",
            new_price: "السعر الجديد",
            stock: "تمت إظافته",
            payment: "خيارات الدفع الخاصة بي",
            assisted_message: "خدمة التعليم المساعد غير مشمولة في الخصم",
            discount_message: "هذا الخصم يطبق على رسوم الاشتراك فقط",
            kid_disc: "احصل على خصم العائلة عند تسجیل أكثر من طفل",
            course_disc: "اطلق العنان لإبداعك واحصل على خصم يصل إلى",
            more_disc: "على أكثر من كورس لدى منصة Hello code",
            fifteen_percentage: "خصم",
          },
          subscription_renewal: {
            title: "تجديد الاشتراك",
            desc: "يرجى إدخال معلومات بطاقتك الائتمانية لإكمال عملية الشراء.",
            name_on_card: "الاسم على البطاقة",
            credit_card_number: "رقم بطاقه الائتمان",
            card_cvv: "البطاقة CVV",
            exp_Date: "تاريخ انتهاء السنه",
            exp_mounth: "تاريخ انتهاء الشهر",
            by_clicking:
              "بالنقر هنا ، فإنك تقر بأنك قد قرأت شروط الخدمة الخاصة بنا ووافقت عليها.",
            reccomended: "القيمة الأفضل",
            terms_of_service: "شروط الخدمة.",
            renew_btn: "تجديد الاشتراك",
            submit: "ارسال",
            back: "السابق",
            please_select: "يرجى اختيار واحدة",
            min_characters: "الحد الأدنى لعدد الرموز هو",
            total_price: "السعر الكلي",
          },
          parent_info: {
            new_kid: "طفل جديد",
            link_kid: "ربط حساب المبرمج",
            current_lessons: "الدورة الحالية",
            last_activity: "آخر ظهور",
            expiry: "تاريخ الانتهاء",
            free: "مجانا",
            update: "تحديث",
            plan: "الخطة",
            login_as: "تسجيل الدخول الى",
            more_actions: "المزيد",
            disable: "تعطيل الحساب",
            edit_info: "تعديل المعلومات",
            update_plan: "تعديل الخطة",
            currently_learning:
              "ماذا يتعلم طفلك في الوقت الحالي اختر الدورة لرؤية ",
            current_course: "الدرس الحالي",
            lesson_name: "اسم الدرس",
            completed_course: "الدروس المكتملة",
            coursess: "الدورات",
            Projects: "المشاريع",
            current_project: "المشروع الحالي",
            project_name: "اسم المشروع",
            completed_projects: "المشاريع المكتملة",
            basic_info: "المعلومات",
            Badges: "القلادات",
            course_badge: "شارات الدورات",
            bigenner: "شارة مبتدأ",
            expert_badge: "شارة متقدم",
            hwk: "شارة هلوكود",
            other_badges: "شارات اخرى",
            parent_area: "منطقة الوالدين",
            hello_Parent: "مرحبا ايها الوالد",
            contoll_Parent:
              "يمكنكم متابعة أداء أطفالكم ومراقبة نشاطاتهم على منصة هلوكود من خلال هذه الصفحة.",
            update_plan: "قم بتحديث خطة حسابك الآن",
            lessons: "الدروس",
            select: "اختر الدورة ",
            no_project: "لنبدأ في صناعة بعض المشاريع",
            no_lesson: "لنبدأ في تعلم البرمجة",
          },
        },
        assessment_result: {
          lesson_title: " عنوان الدرس",
          number_of_questions: "عدد الأسئلة",
          skills_rate: "علامة المهارات",
          questions_rate: "علامة الأسئلة",
          title: "نتيجة التقييم",
          lesson: "درس",
          student: "طالب",
          back: "رجوع",
          question_text: "نص السؤال",
          student_answer: "إجابة الطالب",
          correct_answer: "إجابة صحيحة",
          no_rate: "لا يوجد نتيجة",
          back_to_the_course: " للعودة الى الدرس",
          assessment_results: " لرؤية نتيجة التقييم الخاصة بك بالتفصيل ",
          skills: "لرؤية مهاراتك مرة أخرى ، من فضلك أخبر معلمك",
          click_here: "اضغط هنا",
        },

        submition: {
          approve: "أوافق",
          disapprove: " رفض",
          student: "طالب",
          submission_type: "نوع التقديم",
          submission_status: "الحالة",
        },
        landing: {
          home_title: "مسابقة هلوكود الدولية للمبرمجين الصغار 2020",
          home_title_1: "مسابقة هلوكود الدولية",
          destinations_1:
            "تستهدف مسابقة هلوكود الدولية للمبرمجين الصغار 2020 الأطفال من عمر 7 إلى 15 سنة حيث تهدف إلى تعلميهم أساسيات البرمجة باستخدام لغة سموذي عبر منصة",
          destinations_2:
            "تتضمن المسابقة عدة مراحل كما يلي: مرحلة الاشتراك تليها مرحلة التعلم ومن ثم تقام مجموعة من التصفيات التي تشمل مسابقات ودية تشويقية بين منافسي البلد نفسه ليتم تأهيل الفائزين للمسابقة الدولية الكبرى",
          containter_content:
            "تتوزع جوائز مسابقة هلوكود  الدولية الكبرى كما يلي: ",
          containter_content_1:
            "الجائزة للفائز بالمركز الأول : 5000 دولار امريكي ",
          containter_content_2:
            "الجائزة للفائز بالمركز الثاني : 3000 دولار امريكي ",
          containter_content_3:
            "الجائزة للفائز بالمركز الثالث : 1000 دولار امريكي ",
          containter_content_4:
            " قيمة الاشتراك في المسابقة هي 50 دولار تشمل حصول الطفل على حساب في منصة ",
          containter_content_grants_4:
            " قيمة الاشتراك في المسابقة هي 25 دولار تشمل حصول الطفل على حساب في منصة ",
          testimonials:
            "حيث ستفعل حسابات الأطفال لتمكنهم من البدء برحلة التعلم الذاتي للبرمجة باستخدام لغة سموذي، يحتوي كورس سموذي على 20 درس عبارة عن مجموعة من الحلقات الكرتونية التعليمية ومجموعة من التحديات، يكتسب الطفل مجموعة من النقاط خلال رحلته التعليمية (يعد مجموع النقاط مهماً حيث إنه أحد المحاور التي يتم تأهيل الطفل استناداً عليها).",
          container_register: "هل أنت جاهز للفوز بال 5000 دولار ؟",
          container_register_1: "سجل الآن",
          container_register_2: "حاول مرة أخرى",
          container_register_4: "هل تريد أن تعرف أكثر ؟ ",
          container_register_5: "احجز موعد",
          container_register_6: "هل تريد تجربة دروس مجانية؟",
          container_register_7: "تجربة مجانية",
          container_register_8: "استغل الفرصة",
          container_register_9: "للأسف ، انتهت فترة التسجيل في المسابقة",
          com_intruction_1: " تنتهي فترة التعلم بتاريخ 15/1/2021",
          com_intruction_2: " مرحلة التصفيات الأولية بتاريخ 20/1/2021",
          com_intruction_3: "المسابقة الدولية بتاريخ 28/1/2021",
          com_intruction_4:
            " للاستفسار يرجى التواصل مع فريق هلو كود للدعم الفني وسيتم مساعدتك بأقرب وقت. 00962790488840",
          competition_title: " المسابقة الدولية ٢٠٢٠",
          hello: "هلوكود",
          text: "سجل ، تعلم ، نافس ، اربح",
          modal_1: "ماذا تنتظر !",
          modal_2: "بإمكانك الربح",
          community: "أكبر مجتمع عربي",
          learn: " لتعليم الأطفال البرمجة",
          school: "من البيت أو المدرسة",
          account: "هل تمتلك حساب على منصة هلوكود؟",
          teacher: " هل أنت معلّم أو مالك مدرسة؟",
          school_title: "أدخل مناهج البرمجة  إلى مدرستك",
          curriculam: "مناهج هلوكود",
          learning: "كيفية تعليم البرمجة في المدرسة",
          price: "احصل على عرض سعر",
          school_head: "أدخل مناهج البرمجة",
          school_sub_head: "إلى مدرستك",
          sample: "مثال",
          grade_1:
            "يبدأ الطالب رحلته في عالم التكنولوجيا بتعلّم مهارات الحاسوب الأساسية من خلال الدمج بين نهجيّ التعلم واللعب، حيث يتم تطبيق هذه المهارات باستخدام الألعاب المتوفرة على موقع هلوكود التعليمي. وسيبدأ الطفل بالعمل على برنامج Microsoft Word، وسيُركز المستوى على تطوير مهارات الطلاب في حل المشكلات والتفكير خارج الصندوق.",
          grade_2:
            "يبدأ الطالب في استكشاف أجزاء الحاسوب الداخلية وأجهزة التخزين وبإنشاء مشروعه الخاص على برنامج Microsoft PowerPoint حيث يقوم بإنشاء وتصميم عروض تقديمية جذابة، كما يتضمن هذا المستوى مجموعة من الألعاب التي تنمي مهارات التفكير وحل المشكلات عند الطفل.",
          grade_3:
            "يتعرف الطالب على مصطلح البيانات وكيفية معالجتها وعلى مفهوم الإنترنت (الشبكة العالمية) وكل ما يتعلق بها، والتعامل بحرفية مع برنامج Microsoft Excel والبدء باستخدامه لإدخال ومعالجة البيانات، كما يقدم هذا المستوى مجموعة ألعاب ذات مستوى أعلى لتنمية مهارات الطفل في التفكير والتحليل.",
          grade_4:
            "يبدأ الطالب في هذا المستوى بالتعرف على أساسيات البرمجة باستخدام لغة سموذي، وسيتعلم مجموعة من الأوامر البرمجية التي تمكنه من إضافة أشكال هندسية بسيطة وتغيير ألوانها وتحريكها عن طريق تعلم الإحداثيات والتعامل معها. سيكون الطالب في هذا المستوى قادراً على إضافة الوسائط (الصور والأصوات) لبرامجه باستخدام مكتبة هلوكود.",
          grade_5:
            "سيتمكن الطالب في هذا المستوى من كتابة برامج مرنة ومنظمة باستخدام المتغيرات والدوال (Functions)، وسيتعرف على أنواع البيانات المختلفة وقواعد تسمية المتغيرات وطرق التعامل معها. كما يتطرق هذا المستوى لأحد أهم المفاهيم في البرمجة وهو الأحداث، حيث ستيعلم الطالب كيفية برمجة الأحداث الخاصة بلوحة المفاتيح والفأرة باستخدام لغة سموذي.",
          grade_6:
            "يأخذ هذا المستوى الطالب لمفاهيم جديدة في عالم البرمجة مثل الجمل الشرطية وجمل التكرار والمصفوفات، حيث سيقوم بحل مجموعة من التحديات البرمجية لتوظيف المهارات والمفاهيم البرمجية التي تعلمها ولتعزيز مهارتي التفكير والتحليل لديه.",
          grade_7:
            "يتعرف الطالب في هذه المرحلة على ماهية المواقع الإلكترونية وصفحات الويب، وكيف يمكن إنشائها باستخدام لغة (HTML) وتنسيقها باستخدام لغة (CSS)، وبرمجة عمل عناصر صفحات الويب باستخدام لغة برمجة خاصة تدعى (JavaScript). سيتطرق الطالب لعدة مفاهيم في لغة (JavaScript) أهمها كيف يمكنه التعامل مع عناصر صفحة الويب المبنية باستخدام لغة (HTML) عن طريق الأكواد.",
          grade_8:
            "تأخذ هذه المرحلة الطالب لمستوى أعلى من الاحترافية في عالم البرمجة، حيث يطبق الأساسيات التي تعلمها في المستويات السابقة باستخدام لغة برمجة ذات مستوى عالي تدعى لغة بايثون، كما يكتشف مفاهيم برمجية جديدة مثل المصفوفات وأنواع جديدة من الـ (Functions) لبناء تطبيقات ويب مختلفة.",
          title_1: "هلوكود المستوى الأول - الصف الأول الابتدائي ",
          title_2: " هلوكود المستوى الثاني - الصف الثاني الابتدائي",
          title_3: "هلوكود المستوى الثالث - الصف الثالث الابتدائي",
          title_4: "هلوكود المستوى الرابع - الصف الرابع الابتدائي ",
          title_5: "هلوكود المستوى الخامس - الصف الخامس الابتدائي ",
          title_6: "هلوكود المستوى السادس – الصف السادس الابتدائي ",
          title_7: "هلوكود المستوى السابع - الصف السابع والثامن الابتدائي",
          title_8: "هلوكود المستوى الثامن - الصف التاسع والعاشر الابتدائي",
          what_we_learn: "ما الذي نقدمه للمدارس؟",
          teacher_learning: "	تدريب المعلمين ",
          teacher_guid: "	دليل المعلم ",
          school_visit: "	الزيارات المدرسية ",
          school_guid: "	المتابعة التقنية والفنية",
          teacher_learning_desc:
            "يتم التنسيق مع إدارة المدرسة لتحديد الموعد الأنسب لمقابلة وتدريب كادر المعلمين على كيفية استخدام المنصة والإستفادة من الميزات التي تسهل على المعلم القيام بكافة أعماله. ",
          teacher_guid_desc:
            "يحتوي دليل المعلم على خطوات تطبيق المنهاج، ويعتبر كملف مساعد لتعريف المعلم بالطريقة الأمثل لإيصال الفكرة للطلاب بشكل واضح. ",
          school_visit_desc:
            "يقوم عضو من فريق شركة هلو وورلد كيدز بتنسيق مواعيد لزيارة المدرسة وحضور الحصص وجاهياً للإشراف وإرشاد المعلم للوصول للكفاءة المطلوبة. يحصل كل معلم على زيارة أو زيارتين لكل مستوى تعليمي طوال الفصل الدراسي. ",
          school_guid_desc:
            "يقوم فريق المتابعة والدعم الفني بالمتابعة وتقديم الدعم المستمر طوال السنة الدراسية لضمان أفضل النتائج.",
          show_hellocode: "إستعرض منصة هلوكود",
          contact:
            "لمزيد من المعلومات وللحصول على عرض سعر، يرجى التواصل مع قسم المبيعات من خلال:",
          email: "البريد الإلكتروني:",
          whatsApp: "أو عن طريق الواتساب: ",
          thanks_message:
            "نسعد بلقائكم ولقاء معلميكم لتقديم عرض توضيحي لمنصة هلوكود ومناهجها التعليمية",
          demo: "طلب موعد لحضور عرض توضيحي",
          event_sent_thanks: "شكرا لك!",
          event_sent:
            "سيتم التواصل معك من قبل فريقنا في قسم المبيعات لتحديد موعد العرض التوضيحي. ",
        },
        eFAWATEERcom: {
          title:
            "ادفع لمسابقة هلو كود الدولية من هلو وورلد كيدز من خلال اي فواتيركم بكل سهولة",
          title_1: "اونلاين من خلال:",
          title_2: " تطبيق او صفحة حسابك البنكي",
          title_3: "محافظ الموبايل الإلكترونية",
          title_4: "تطبيق أو موقع اي فواتيركم",
          title_5: "بخطوات بسيطة:",
          title_6: "اختار فئة المفوتر: تعليم",
          title_7: "اختار اسم المفوتر: هلو وورلد كيدز",
          title_8: "اختار نوع و فئة الخدمة: مسابقة هلو كود الدولية",
          title_13: "ادخل رقم الاشتراك: و هو الرقم الموبايل",
          title_9: "أو ادفع كاش من خلال:",
          title_10: "جميع بنوك المملكة",
          title_11: "مكاتب البريد الأردني",
          title_12:
            "وكلاء إي فواتيركم متل محلات الصرافة المعتمدة، بامكانك معرفة أقرب وكيل اليك عن طريق خريطة وكلائنا",
        },
        competition: {
          step_1: "الخطوة الأولى",
          step_2: "الخطوة الثانية",
          step_3: "الخطوة الثالثة",
          basic: "معلومات المشارك",
          plan: " حزمة المسابقة",
          payment: "طرق الدفع",
          select: "الرجاء اختيار المزود",
          course: "المقرر التعليمي",
          thank: "شكراً جزيلاً",
          thank_you: "لقد تم تسجيلكم بنجاح",
          thank_you_1:
            "شكراَ لتسجيلك بمسابقة هلو كود الدولية للمبرمجين الصغار ٢٠٢٠",
          thank_you_2:
            "تم تفعيل الحساب ليتمكن الطفل من البدء برحلة التعلم الذاتي للبرمجة باستخدام لغة سموذي، يحتوي كورس سموذي على 20 درس حيث يشمل مجموعة من الحلقات الكرتونية التعليمية ومجموعة من التحديات. يكتسب الطفل النقاط خلال رحلته التعليمية ويعد مجموع النقاط و المشاريع المميزة الموجودة في ساحة اللعب من اهم المحاور التي يتم تأهيل الطفل استناداً عليها",
          thank_you_3: "تم ارسال معلومات الحساب إلى بريدك الالكتروني",
          details: "التفاصيل",
          details_1: "واجهتك مشكلة ؟",
          share: "مشاركة",
          invite: "لدعوة أصدقائك",
          email: "support@helloworldkids.org : البريد الالكتروني",
          whatsup: "https://wa.me/962790488840 : واتساب ",
          direct: "اتصال مباشر : 00962790488840",
          chat: "https://www.hellocode.me/ : خدمة الشات ",
          contact: "تواصل معنا",
          error: "نعتذر ،لقد حصل خطأ في عملية الدفع!",
          error_1:
            "شكراَ لك لاهتمامك بالتسجيل في مسابقة هلو كود الدولية للمبرمجين الصغار ٢٠٢٠",
          error_2:
            "يرجى المحاولة مرة اخرى. بإمكانك اختيار طريقة الدفع المناسبة لك",
          country: "الدولة",
          provider: "مزود الخدمة",
        },
        hellocode_v2: {
          home_title: "مجتمع البرمجة للأطفال",
          sub_title: "تجربة تعليمية فريدة صممت خصيصاً لتحفيز إبداع أطفالكم",
          register: " افتح حسابًا الآن، انّه مجّاني",
          text_inner: "تنمية مهارات التفكير لديهم.",
          lesson: " تحسين مهاراتهم الأكاديمية.",
          project: " تطوير مهارات التواصل لديهم.",
          courses: "دورات هلوكود",
          offer: "ما تقدمه هلوكود",
          journey:
            "ابدأ رحلة تعليمية ممتعة بواسطة سلسلة من الدروس والألعاب التي أنشأها فريق متخصص لمساعدة أطفالك على إتقان البرمجة.",
          all: "جميع الدورات",
          basic: "(٣) دورات الحاسوب للمبتدئين",
          smoothy: "(٦) دورة سموذي البرمجية",
          advance: "(١) دورات برمجة تطبيقات الويب ",
          trusted: "خدماتنا موثوقة من قِبل",
          python: "(1)بايثون",
        },
        projectOftheMonth: {
          main_title: "مشروع هذا الشهر",
          nameofProject: "مشروع رائد الفضاء",
          descrProject:
            "تحلم إيمان بأن تصبح رائدة فضاء، لذا قامت بصناعة قصتها عن الفضاء باستخدام البرمجة.",
          summery_project: "نظرة عامة على المشروع",
          para_one:
            "حاولت إيمان من خلال مشروعها تخيل الرحلة التي طالما رغبت في القيام بها الى الفضاء.لقد طبقت معرفتها البرمجية لكتابة 783 سطراً من الأوامر البرمجية المنظمة بشكل احترافي. تخيلت ثم حللت ثم خططت ثم نفذت مشروعها المذهل. لقد أضاف اهتمامها بالتفاصيل، كإظهار دخان المكوك الفضائي،  لمسة جمالية للمشروع.",
          para_two:
            "نحن فخورون جدًا بإيمان لأنها حولت خيالها إلى واقع باستخدام البرمجة.",
        },
        parent_v2: {
          subscription_plan: "خطة الاشتراك",
          plan_name: "هل تشعر بالفضول",
          plan_description: "ميزات هذه الحزمة",
          plan_feautes_one: "الاستمتاع بميزات المنصة",
          plan_feautes_two: " ثلاثة دروس برمجية مجانية",
          plan_feautes_three: "تعليم أساسيات البرمجة",
          plan_feautes_four: "إنشاء المشاريع البرمجية",
          plan_feautes_five: "تقارير لأداء الأطفال",
          current_plan: "الدورة الحالية",
          course_plan: "الاشترك بدورة",
          course: "اختر المستوى",
          plan_title: "دورات هلوكود",
          update_plan: "حزم الإشتراك",
          update: "اختر حزمة الاشتراك المناسبة لطفلك وأطلق العنان لإبداعه.",
          details: "تفاصيل حزمة الإشتراك",
          kid_name: "أسماء الأطفال:",
          update_for: "تجديد الإشتراك لِ ",
          choose: "اختر اسم الطفل ",
          course_one: "الاستمتاع بميزات المنصة",
          course_two: " تصليح المشاريع وتقييمها",
          course_three: "مصادر تعلم متنوعة",
          course_four: "شهادات برمجية لكل الدورات",
          course_five: "منافسات مع أطفال مبرمجين",
          course_name: "اختر المستوى ",
          recomended: "You are jumping too much!",
          message:
            "You are choosing a course that expoert users are expected to take, we suggest your kid to start learning from our begginers course first.",
          track: "اختر الدورة",
          track_name: "الدورات البرمجية",
          credit: "بطاقات الائتمان أو البطاقات المدفوعة مسبقاً",
          credit_text:
            "يمكنك الدفع مباشرة من خلال بطاقتك البنكية وسيتم تفعيل اشتراك طفلك مباشرة",
          paypal: "بي بال",
          paypal_text:
            "يمكنك الدفع من خلال حساب بي بال وسيتم تفعيل اشتراك طفلك مباشرة",
          payment: "معلومات الدفع",
          change: "تغيير",
          detail: "تأكيد",
          package: "تفاصيل الحزمة",
          pay: "إدفع الآن",
          child_name: "اختر اسم الطفل ",
          child_track: "إختر الدورة البرمجية",
          child_course: "إختر المستوى المناسب",
          child_terms:
            "والتأكد من  قراءة شروط الاستخدام و الموافقة عليها لإكمال عملية التسجيل",
          mobile: "الدفع عن طريق الهاتف",
          balance:
            "يمكنك الدفع من خلال رقم الهاتف وسيتم تفعيل اشتراك طفلك مباشرة",
          attention_msg:
            "الدورة التي اخترتها مناسبة للأطفال الذين تتراوح أعمارهم بين 5 و 7 سنوات، حيث سيتعلم الأطفال في هذه الدورة كيفية التعامل مع أجهزة الحاسوب ومهاراتها الأساسية.",
          text_msg: "تنبيه",
        },
        parentHeader: {
          kidsTab: "الأطفال",
          membershipTab: "الإشتراكات",
          accountInfo: "معلومات الحساب",
          logout: "تسجيل الخروج",
          dashboardParent: "حساب ولي الأمر",
        },
        teacherHeader: {
          dashboardParent: "حساب المعلم",
          Classroom: "الغرف الصفية",
          progress: "تقييم الدروس",
          code: "تقييم الكود",
        },
        schoolHeader: {
          dashboardschool: "حساب المدرسة",
          Techers: "المعلمون",
          students: "الطلاب",
          teacherheader: "المعلمون",
          studentheader: "الطلاب",
          code: "تقييم الكودات",
        },
        assessment: {
          answer: "جواب السؤال",
        },
        parentAccountInfo: {
          accountInfo: "معلومات الحساب",
          basicInfo: "المعلومات الأساسية",
          kids: "الأطفال",
          students: "الطلاب",
          basicInformation: "المعلومات الأساسية",
          name: "الإسم",
          edit: "تعديل",
          email: "الإيميل",
          phoneNumber: "رقم الهاتف",
          country: "الدولة",
          changePassword: "تغيير كلمة المرور",
          oldPassword: "كلمة المرور الحالية",
          oldPassPlaceholder: "أدخل كلمة المرور الحالية",
          newPassword: "كلمة المرور الجديدة",
          newPassPlaceholder: "أدخل كلمة المرور الجديدة",
          saveChanges: "حفظ التغييرات",
          title: "تفاصيل ولي الأمر",
          teacherTitle: "تفاصيل المعلم",
          subtitle: "معلوماتك",
          username: "اسم المستخدم",
          phone: "رقم الهاتف",
          cancel: "إلغاء",
          nameRequired: "هذا الحقل مطلوب ، الرجاء إدخال اسمك",
          min_chars: "الحد الأدنى لعدد الرموز هو",
          max_chars: "الحد الأعلى لعدد الرموز هو",
          usernameRequired: "هذا الحقل مطلوب ، الرجاء إدخال اسم المستخدم",
          emailRequired: "هذا الحقل مطلوب ، الرجاء إدخال البريد الإلكتروني",
          valid_email: "يرجى إدخال عنوان بريد إلكتروني صحيح",
          formatMsg:
            " _ يمكن لاسم المستخدم أن يحتوي على الأحرف أو الأرقام أو النقطة أو - أو ",
          primaryWord: "أساسي",
          notAllowedSpacing: "لا يجوز أن تبدأ أو تنتهي كلمة المرور بفراغ",
          parent: "مشاركة التقرير",
          certi: "الشهادات",
        },
        tableKidInfo: {
          tableTitle: "قائمة الأطفال",
          tableStudentTitle: "قائمة الطلاب",
          downloadList: "تحميل التقرير",
          downloadStudentList: "تحميل معلومات الطلاب",
          title: "تفاصيل الطفل",
          title_student: "تفاصيل الطالب",
          subtitle: "معلومات عن طفلك",
          subtitle_student: " معلومات الطالب",
          studentName: "اسم الطفل",
          userName: "اسم المستخدم",
          dateCreated: "تاريخ الإنشاء",
          lastActivity: "آخر نشاط",
          overallMarks: "مجموع العلامات",
          name: "الإسم",
          generate: "إنشاء اسم المستخدم",
          password: "كلمة المرور",
          passPlaceholder: "إنشاء كلمة مرور لطفلك",
          packagePlan: "خطة الإشتراك",
          updatePlan: "تعديل خطة اللإشتراك",
          saveChanges: "حفظ التغييرات",
          cancel: "إلغاء",
          moreDetails: "المزيد من التفاصيل",
          passwordRequired: "هذا الحقل مطلوب ، الرجاء إدخال الرقم السري",
        },
        noKidsModal: {
          msg: "عذرا ، لم تقم بإضافة أي حساب أطفال",
          btnMsg: "إضافة طفل",
          msg_email:
            "يرجى إضافة بريدك الإلكتروني لاستلام إيصال الشراء وآخر التحديثات على خدماتنا ومنتجاتنا",
          btnMsg_email: "أضف بريدك الإلكتروني",
          email: "نحن نفتقد بريدك الإلكتروني",
          btnMsg_phone: "أضف رقم هاتفك",
          msg_phone:
            "يرجى إضافة رقم هاتفك لاستلام إيصال الشراء وآخر التحديثات على خدماتنا ومنتجاتنا",
          phone: "نحن نفتقد رقم هاتفك",
        },
        student_profile: {
          certficate: "شهادات",
          edit: "تعديل",
          basic_info: "المعلومات الأساسية",
          name: "الإسم",
          cancel: "إلغاء",
          save: "حفظ",
          emoji_header: "مكتبة الرموز التعبيرية",
          emoji: "الرموز التعبيرية",
          upload_image: "تحميل صورة",
          user_name: "اسم االمستخدم",
          b_day: "عيد الميلاد",
          school: "المدرسة",
          parent: "الوالد",
          link_your_parent: "قم بدعوة ولي أمرك الآن",
          plan: "الخطة",
          p_msg: "لا يمكن تحديث الخطط إلا من قبل الوالدين.",
          expiry: "انتهاء الخطة",
          delete_acc: "تعطيل الحساب",
          download: "تحميل",
          previous: "السابق",
          next: "التالي",
          all_poimts: "النقاط الإجمالية",
          earend_points: "النقاط الإجمالية",
          weekly_points: "النقاط الأسبوعية",
          prog_summary: "رحلة التقدم",
          certificates: "الشهادات",
          challenges: "التحديات",
          projects: "المشاريع",
          badge: "القلادات",
          badge_exp:
            "يمكنك الفوز بهذه القلادات في كل مرة تنهي فيها دورة بجميع مستوياتها.",
          trophies_exp:
            "يمكنك الفوز بهذه الكؤوس بعد الإنتهاء من تصميم المشاريع البرمجية.",
          point_one: "كأس بطل المشروع، بعد تصميم (10) مشاريع.",
          point_two: "كأس المبرمج الإبداعي، بعد تصميم (30) مشروع.",
          point_three: "الكأس الترميز المبتكر، بعد تصميم (100) مشروع.",
          Trophies: "الكؤوس",
          acc_info: "معلومات الحساب",
          basic_info_mob: "معلومات",
          Summary: "ملخص",
          kids_prog: "تقدم الطفل",
          details: "تفاصيل",
          select_course: "اختر دورة",
          completed_lessons: "الدروس المكتملة",
          lesson_tiltle: "عنوان الدرس",
          asses_results: "نتائج التقييم",
          code: "كود",
          code_review: "مراجعة الكود",
          challenge_pro: " مشاريع التحديات",
          pro_name: "اسم المشروع",
          pro_comment: "تعليق المشروع",
          status: "حالة المشروع",
          share: "مشاركة",
          playground: "مشاريع ساحة اللعب",
          lessons_details: "تفاصيل الدروس",
          project_details: "تفاصيل المشاريع",
          playground_details: "تفاصيل ساحة اللعب",
          challanges_details: "تفاصيل التحديات",
          challenges: "التحديات",
          projects: "المشاريع",
          accountInfo: "معلومات الحساب",
          editmsg: "عدل معلوماتك الشخصية",
          edit_info: "تعديل المعلومات",
          save: "حفظ",
          cancel: "اغلاق",
          list_of_certis: "قائمة شهادات الطالب",
          dones: "انتهيت",
          list_of_pros: "قائمة مشاريع الطالب",
          list_of_chall: "قائمة تحديات الطالب",
          email_parent: " إيميل ولي الأمر",
          title_invite: "دعوة ولي الأمر",
          phone_num: "رقم الهاتف ",
          error_message: "تجاوزت الحد الاعلى المسموح فيها الرسائل",
          main_invite:
            "أضف رقم هاتف ولي أمرك وسنرسل إليهم دعوة للانضمام إليك وتحديث خطتك الدراسية",
          btn_invite: "إرسال الدعوة",
          text_mess: "تم إرسال البريد الالكتروني بنجاح",
          lessons_name: "اسم الدرس",
          Assessment_result: "نتيجة التقييم",
          challange_name: "اسم التحدي",
          project_name: "اسم المشروع",
          teacher: "المعلم/ة",
          t_msg: "خطة المدرسة",
          line: "عدد أسطر الكود",
          activ_tab: "النشاط",
          prog_tab: "التقدم",
          nocertificates: "لايوجد شهادات حتى الآن",
          nochallenge: "لا يوجد تحديات حتى الآن ",
          noproject: "لايوجد مشاريع حتى الآن",
          Resources: "مصادر",
          title_res: " العنوان",
          Res: "المصدر",
          down: "تحميل الملف",
          type: "نوع الملف",
        },
        kidHeader: {
          exam: "الإمتحان",
          Playground: "ساحة اللعب",
          myWorldTab: "عالمي",
          communityTab: "تواصل اجتماعي",
          notificationTab: "الإشعارات",
          allNotifications: "اذهب الى كل الإشعارات",
          unread: "حدد كغير مقروء",
          read: "حدد كمقروء",
          accountInfo: "معلومات الحساب",
          logout: "تسجيل الخروج",
          dashboardkid: "حساب المبرمج ",
          dashboardstudent: "حساب الطالب",
        },
        studentWorld: {
          myWorld: "عالمي",
          hello: "مرحبا",
          subTitle: "تابع تقدمك وابدأ رحلة التعلم الخاصة بك",
          basic: "الحاسوب",
          smoothy: "سموذي",
          advanced: "تطبيقات الويب",
          playCourse: "العب",
          lockMsg: "تحتاج إلى إكمال الدورة السابقة لتتمكن من لعب هذه الدورة",
          python: "بايثون",
          info: "  قم بإكمال الكورس السابق حتى تتمكن من دخول",
        },
        lessonsList: {
          courses: "الدورات",
          details: "تفاصيل",
          accomplishments: "الإنجازات",
          graduationCertificate: "شهادة إكمال الدورة",
          juniorProgramming: "من هلو ورلد كيدز",
          basicProgramming: "البرمجة الأساسية",
          advancedProgramming: "البرمجة المتقدمة",
          earned: "حصل",
          availableLessons: "الدروس المتاحة",
          availableNow: "المتاحة الآن",
          needPlanUpdate: "بحاجة إلى تحديث الخطة",
          invite: "دعوة ولي الأمر",
          done: "إنهاء",
          completed: "مكتمل",
          finished: "تم الانتهاء",
          repeat: "أعد",
          startLesson: "ابدأ الدرس",
        },
        tableKidHistory: {
          student_name: "اسم الطالب",
          plan_name: "اسم الخطة",
          course_name: "اسم الدورة",
          amount: "القيمة",
          purchased_at: "تم شراؤها في",
          payment_method: "طريقة الدفع",
          purchases_history: "تفاصيل الإشتراكات",
          membershipTableTitle: "قائمة الإشتراكات",
        },
        smoothyIde: {
          title: "محرر سموذي",
          description:
            "يمكنك كتابة كود سموذي هنا. حيث يمكنك استكشاف البرمجة. لا تتردد في إنشاء برامجك الخاصة ، بالطريقة التي تريدها.",
          title_web: "محرر الويب",
          title_python: "محرر البايثون",
          description_web:
            "يمكنك كتابة كود الويب هنا. حيث يمكنك استكشاف البرمجة. لا تتردد في إنشاء برامجك الخاصة ، بالطريقة التي تريدها.",
          description_python:
            "يمكنك كتابة كود البايثون هنا. حيث يمكنك استكشاف البرمجة. لا تتردد في إنشاء برامجك الخاصة ، بالطريقة التي تريدها.",
          myProjects: "مشاريعي",
          hello: "مرحبًا",
          soundLibrary: "مكتبة الصوت",
          imageLibrary: "مكتبة الصور",
          fullScreen: "تكبير الشاشة",
          saveProject: "احفظ المشروع",
          daily_submission: "المشاريع المرسلة",
          run: "شغل البرنامج",
          stop: "اوقف البرنامج",
          submit: "إرسال",
          code: "كتابة البرنامج",
          output: "نتيجة البرنامج",
          projectGoal: "هدف المشروع",
          projectLibraryTitle: "المشاريع المحفوظة",
          startCoding: "أبدأ البرمجة",
          next: "التالي",
          addNewProject: "إضافة مشروع جديد",
          placeholderProjectTitle: "اسم المشروع",
          addproject: "إضافة مشروع جديد",
          playgroundProjects: "مشاريع ساحة اللعب",
          coursesProjects: "مشاريع التحديات",
          welcomeModalTitle: "عزيزي المبرمج، نحن بانتظار مشاريعك الرائعة! ",
          welcomeModalText:
            "يُمكنك إرسال ثلاثة مشاريع يومياً، أرسل أفضل المشاريع لديك لزيادة نقاطك.",
          welcomeModalSubText: "تأكد من عدم إرسال المشاريع غير المكتملة.  ",
          submitModalText: "هل أنت متأكد بأنك ستقوم بإرسال هذا المشروع؟",
          submitModalSubText: "سوف يتم تصحيح مشروعك خلال اسبوع",
          confirmBtn: "نعم",
          cancelBtn: "لا",
          submitModalTitle: "إرسال المشروع",
          goalModalTitle: "هدف المشروع",
          my_project: "مشروعي",
          share_code: "شارك الكود",
          share_code_msg: "يجب عليك إختيار مشروع مقدم من أجل مشاركة الكود",
        },
        new_classrooms: {
          search: "  البحث عن غرفة صفية",
          head_title: "الغرف الصفية",
          main_text:
            "سيتم عرض جميع الغرف الصفية الذين قمت بإدراجهم أو مشاركتهم أو إنشائهم هنا.",
          title_card: "لم تقم بإضافة أي‌  ‌‍‌غرف صفية‌‍‌ ‌بعد‌‍‌",
          text_card:
            "سيتم عرض جميع غرفك الصفية هنا. بمجرد إضافة غرفة صفية، ستتاح لك الفرصة لإضافة الطلاب",
          add_classroom: "أضف غرفتك الصفية الأولى الآن",
          main_title: "إضافة غرفة صفية جديدة",
          btn_classroom: "+   غرفة صفية جديدة",
          text_main: "الطلاب في هذه الغرفة الصفية.",
          classroom_name: "اسم الغرفة الصفية ",
          Grade: "المرحلة الدراسية",
          Course: "الدورة",
          classroom_seats: "عدد المقاعد",
          btn_create: "إنشاء غرفة صفية",
          btn_cancel: "إلغاء",
          Edit: "تعديل الغرفة الصفية",
          btn_edit: "حفظ التعديلات",
          del_Classroom: "حذف الغرفة الصفية",
          title_time: "تحديد الجدول",
          sub_text: "اختر اليوم والوقت الذي يناسبك",
          day: "الأحد",
          first_name: "الاسم الأول",
          last_name: "اسم العائلة",
          grade_level: "المرحلة الدراسية",
          user_name: "اسم المستخدم",
          password: "كلمة المرور",
          email: "البريد الالكتروني",
          email_address_b12: "البريد الالكتروني B12",
          confirmation: "تأكيد كلمة المرور",
          add_student: "إضافة اسم الطالب",
          student_title: "إضافة طالب جديد",
          text_student: "أنت تضيف طالبًا إلى هذه الغرفة الصفية",
          current_course: "الدورة الحالية",
          current_students: "الطلاب الحاليون",
          current_student: "الطالب الحالي",
          Students: "من الطلاب",
          Student: "الطالب",
          dele_classroom: "حذف الغرفة الصفية",
          See_deta: "عرض المزيد من المعلومات",
          grade: "المستوى",
          one: "الصف الاول",
          two: "الصف الثاني",
          thre: "الصف الثالث",
          four: "الصف الرابع",
          five: "الصف الخامس",
          six: "الصف السادس",
          seven: "الصف السابع",
          eight: "الصف الثامن",
          nine: "الصف التاسع",
          ten: "الصف العاشر",
        },
        rest_question: {
          text_heading: "إعادة ضبط الأسئلة للطلاب",
          text_main:
            "أنت على وشك إعادة ضبط الأسئلة للطلاب. إعادة ضبط الأسئلة ستمنحهم الفرصة لحل الأسئلة مرة أخرى وجمع المزيد من النقاط.",
          rest_btn: "إعادة ضبط الأسئلة",
          cancel_btn: "إلغاء",
          text_question:
            "هل أنت متأكد أنك تريد إعادة الأسئلة لجميع الطلاب في الغرفة الصفية؟",
        },
        remove_student: {
          main_text: "حذف الطالب",
          student_removed:
            "هل أنت متأكد من رغبتك في حذف هذا الطالب من الغرفة الصفية؟",
          text_heading: "الطالب المراد حذفه",
          btn_dele: "حذف الطالب الآن",
          cancel_btn: "إلغاء",
          text_question:
            " هل أنت متأكد أنك تريد حذف هذا الطالب  من الغرفة الصفية؟",
          text_questions:
            " هل أنت متأكد أنك تريد حذف هؤلاء الطلاب من الغرفة الصفية؟",
        },
        exportfile: {
          text_file: "تحميل أسماء الطلاب من القائمة",
          main_file:
            "قم بتحميل ملف (XL.) الخاص بك أو  ملف (.CSV) الذي يحتوي على أسماء الطلاب وسنقوم بإنشاء اسم مستخدم لكل منهم.",
          labelfile: "قائمة الطلاب",
          btn_import: "حمّل الآن",
          btn_cancel: "إلغاء",
          message_error:
            "5 ميغابايت كحد أقصى، يرجى التأكد من وجود الأسماء في خلية واحدة وعدم تكرارها.",
        },
        table_student: {
          cancel: "إلغاء",
          approve: "موافق",
          messlockcommunity: "هل أنت متأكد أنك تريد اغلاق المجتمع لطلاب؟",
          messunlockcommunity:
            "هل أنت متأكد أنك تريد فتح التواصل الاجتماعي لطلاب؟  ",
          unlockcommunity: "فتح التواصل الاجتماعي",
          lockcommunity: "اغلاق التواصل الاجتماعي",
          cert_completion: "إصدار شهادات ",
          attention_msg: "الطالب لم ينه أي درس بعد",
          selected: "اختيار",
          btn_unlock: "فتح الدروس",
          btn_reset: "إعادة التحديات",
          btn_lesson: "إنهاء الدروس",
          btn_question: "إعادة الأسئلة",
          add_text: "إضافة طالب جديد",
          assi_text: "سيتم إضافة طالب جديد إلى هذه الغرفة الصفية",
          add_student: "إضافة",
          assi_student: "قم باختيار أي طالب وأضفه إلى هذه الغرفة الصفية.",
          detai: "تفاصيل",
          name_student: "اسم الطالب",
          username_student: "اسم المستخدم",
          score: "درجة المهارات",
          all_points: "مجموع النقاط",
          search: "البحث عن اسماء الطلاب",
          all: "الجميع",
          assign_exist: "اختر الطالب",
          add_student: "إضافة طالب جديد",
          assign: "قم باختيار أي طالب وأضفه إلى هذه الغرفة الصفية.",
          student: "سيتم إضافة طالب جديد إلى هذه الغرفة الصفية",
          reset: "تغيير كلمة السر",
          dele: "حذف من الغرفة الصفية",
          edit_Sname: "تعديل اسم الطالب",
          edit_Username: "تعديل اسم المستخدم",
          down_report: "تحميل الملف",
          report_tab: "التقارير",
          report_des: "إنشاء تقارير لجميع الطلاب في الغرفة الصفية",
          assign_class: "نقل الطالب",
          extra_tab: "مصادر إضافية",
          down: "التنزيل",
          skills_degree: "درجة المهارات",
          total_score: "مجموع النقاط",
        },
        assign_stu: {
          currunt_class: "الغرفة الحالية",
          okay_btn: "نقل الطلاب",
          cancel_btn: "إلغاء",
          choose: "إختيار الغرفة الصفية",
          transfer_class: "نقل الطلاب الى غرفة صفية أخرى",
          get_cer: "إصدار الشهادات",
          message_genrate: "تم إنشاء الشهادة بنجاح",
        },
        finish_lesson: {
          main_text: "إنهاء الدروس للطلاب",
          text_heading:
            "أنت على وشك إنهاء الدروس للطلاب، وبذلك ستمكنهم من البدء بالدرس التالي.",
          btn_dele: "إنهاء الدروس ",
          cancel_btn: "إلغاء",
          okay_btn: "موافق",
          text_question:
            "هل أنت متأكد أنك تريد إنهاء الدرس  لهؤلاء الطلاب في الغرفة الصفية؟",
          text_questions:
            "هل أنت متأكد أنك تريد إنهاء الدروس لهؤلاء الطلاب في الغرفة الصفية؟",
        },
        teacher_guide: {
          is_correct: "الإجابة الصحيحة",
          noResource: "لايوجد مصادر إضافية",
          noLesson: "لايوجد خطة للدروس",
          noQuestion: "لايوجد أسئلة",
          Question: "سؤال",
          Lesson: "الدرس",
          Lessonsvideo: "فيديو الدروس ",
          ChallengeSolutions: "حلول التحديات",
          LessonSolutions: "حلول الدروس",
          QuestionSolutions: "حلول الأسئلة",
          ExtraResources: "مصادر اضافية",
          lesson_plan: "خطة الدرس",
          title: "العنوان",
          download: "تحميل الملف",
          question_bank: "بنك الأسئلة",
        },
        reset_challenges: {
          title_heading: "إعادة ضبط التحديات للطلاب",
          text_heading:
            "أنت على وشك إعادة ضبط التحديات للطلاب. إعادة ضبط التحديات ستمنحهم الفرصة لحل التحديات مرة أخرى.",
          btn_reset: "إعادة ضبط التحديات",
          btn_cancel: "إلغاء",
          text_question:
            "هل أنت متأكد أنك تريد إعادة التحدي /(التحديات) لهذا الطالب ؟",
          text_questions:
            "هل أنت متأكد أنك تريد إعادة التحدي /(التحديات) لهؤلاء الطلاب؟",
        },
        assign_student: {
          main_text: "تعيين الطلاب إلى الغرفة الصفية",
          heading_text:
            "هنا جميع الطلاب الذين يمكنك تعيينهم لهذا الفصل. يمكنك إضافة طلاب جدد في أي وقت.",
          btn_assign: "حفظ التعديلات",
          btn_cancel: "إلغاء",
        },
        resetPassword: {
          btn_reset: "تغيير كلمة المرور",
          new_password: "كلمة المرور الجديدة",
          main_text: "تغيير كلمة المرور",
          head_text: "هل أنت متأكد من رغبتك في تغيير كلمة المرور لهذا الطالب؟",
          head: "هل أنت متأكد من رغبتك في تغيير كلمة المرور لهذا المعلم؟",
        },
        unlocked: {
          title_heading: "فتح الدروس للطلاب",
          text_heading:
            "أنت على وشك فتح الدروس للطلاب. سيؤدي ذلك إلى فتح درس محدد لهم.",
          text_heading_two: "هل انت متأكد من اكمال الدرس السابق؟",
          text_heading_three:
            "هل أنت متأكد من تغيير حالة الدرس لغير مكتمل؟ سيتم إعادة الدرس لحالته السابقة",
          text_heading_four: "هل أنت متأكد من اكمال الدرس الاخير؟",
          btn_reset: "فتح الدروس",
          btn_cancel: "إلغاء",
          btn_yes: "نعم",
        },
        classroom_details: {
          flex_text: "الغرفة الصفية",
          classroom_text: "اسم الفصل الدراسي",
          program_name: "البرمجة المتقدمة",
          classroom_name: "اسم غرفة الصف سطر واحد",
          small_text: "مقاعد متوفرة | الدرجة الثالثة",
          basic_info: "المعلومات الأساسية",
          edit: "تعديل",
          main_name: "الاسم",
          text_name: "سم الفصل",
          GRADE: "الصف",
          active_course: "الدورة الحالية",
          course_name: "اسم الدورة التدريبية",
          numOfseats: "الطلاب",
          available_seats: "المقاعد المتوفرة",
          Schedule: "جدول المواعيد",
          set_time: "ضبط الوقت",
          Techers_Guide: "مصادر المعلم",
          Student_Guide: "دليل الطالب",
          Add_student: "أضف طالب جديد",
          text_student: "قم بتسجيل طالب جديد لهذا الغرفة الصفّية ",
          btn_add: "إضافة",
          export_file: "استيراد من القائمة",
          export_text: "قم برفع قائمة الطلاب إلى هذه الغرفة الصفية",
          btn_export: "استيراد القائمة",
          finish: "إنهاء",
          select: "قم باختيار الملف",
        },
        teacher_account: {
          enrolled: "الدورات المسجلة",
          join: "تاريخ الدخول",
          active: "آخر نشاط",
          remove_student: "حذف الطالب",
        },
        games_Shared: {
          firsrt_game: "لعبة الكتابة 1",
          secound_game: "لعبة الكتابة 2",
          third_game: "لعبة الكتابة 3",
          fourth_game: "لعبة الماوس ",
          gaming_welcome: "أهلا بك، هيا بنا لنبدأ اللعب",
          play: "العب",
        },
        Examanition: {
          firstname: "الاسم الأول",
          Middlename: "اسم الأب",
          lastname: "اسم العائلة",
          birth: "تاريخ الولادة",
          language: "لغة الاختبار",
          phone: "رقم الهاتف ",
          email: "البريد الإلكتروني",
          city: "المدينة",
          country: "الدولة",
          date: "سنة/شهر/يوم",
          alert_check:
            "تأكد من ملء معلومات المرشح الصحيحة ؛ لن تتمكن من تغيير البيانات بمجرد إرسال النموذج.",
          next_btn: "التالي",
          per_btn: "السابق",
          course: "المستويات",
          exam: "الإمتحانات",
          Completed: "مكتمل",
          in_progress: "قيد التعلم",
          cs_ex: "الدورات والامتحانات",
          personal_info: "المعلومات الشخصية",
          review_submit: "مراجعة وإرسال",
          third_step:
            "لقد شارفت على الانتهاء! يرجى التحقق من المعلومات الخاصة بك أدناه.",
          exam_name: "اسم الإمتحان",
          full_name: "الإسم الكامل",
          submit: "ارسال",
          submit_modal: "هل أنت متأكد أنك تريد إرسال النموذج الخاص بك؟",
          cant: "لا يمكنك تحديث بياناتك بمجرد إرسال النموذج.",
          yes: "أجل, ارسال",
          no: "تأكد مرة أخرى",
          success: "لقد سجلت في ",
          successfully: "بنجاح.",
          confirmation:
            "ستتلقى قريبًا رسالة تأكيد بالبريد الإلكتروني تحتوي على المعلومات التالية:",
          eligible_id: "معرّف الأهلية ونافذة زمنية للتسجيل.",
          auth: "خطاب تفويض يحتوي على معلومات المرشح.",
          link: "رابط لجدولة الإمتحان.",
          advice: "يُنصح المستخدم بجدولة الاختبار قبل انتهاء فترة أهليته",
          good_luck: "حظًا طيبًا!",
          en: "اللغة الانجليزية",
          ar: "اللغة العربية",
          choose: "أختيار اللغة",
          enable:
            "عليك انهاء هذه الدورات و الامتحانات لتتمكن من التقدم للإمتحان",
          enableCourse: "عليك انهاء هذه الدورات لتتمكن من التقدم للإمتحان",
          examanition: "التسجيل في الامتحانات",
          your_exams: "سجل في امتحاناتك و اختبر قدراتك",
          incoplrted: "لم تقم بإنهاء اي دورة بعد",
          click: "الرجاء الضغط ",
          here: "هنا",
          to_complete: "لإنهاء دوراتك",
          get_back: "عد الى عالمي",
          soon: "هذا الامتحان غير متاح حالياً سوف يتم طرحه قريباً",
        },
        Exam_date: {
          main_text: "سيتم الإعلان عن جدول جلسات الامتحان قريبًا",
        },
        about_exam: {
          contact:
            "للتسجيل في الامتحان ، يرجى التواصل مع معلمك. يمكنك إرسالها بالبريد الإلكتروني مباشرة باستخدام عنوان البريد الإلكتروني الذي قدمته المدرسة.",
          thank: "شكرا لتعاونكم",
          main_heading: "برنامج امتيازات الشهادات",
          para_text:
            "صُمم برنامج الامتيازات الخاص بشهادات هلو وورلد كيدز (HCP) لتوفير فرص تنافسية للمواهب البرمجية من جميع أنحاء العالم لضمان نجاحهم في المستقبل.",
          sm_text: "يُقدم برنامج الامتيازات مستويان من المزايا:",
          scholar_title: "منحة هلو وورلد كيدز للبرمجة",
          scholar_expalin:
            "هي فرصة للحصول على منحة دراسية سنوية تُغطي الرسوم الجامعية لمدة عام واحد لأعلى المتفوقين.",
          partial_title: "منح جامعية كاملة أو جزئية",
          partial_explain:
            "هي فرصة للحصول على منح كاملة أو جزئية للمتعلمين الصغار الموهبين الذين يرغبون في متابعة تعليمهم العالي في المجالات التقنية من خلال الجامعات الشريكة في برنامج الامتيازات.",
          network_title: "توفر شبكة شركائنا المحترفين للمواهب الشابة:",
          point_one:
            "منح جامعية و منح الكليات لمتابعة التعليم العالي في المجالات التقنية.",
          point_two: "برامج زمالة مصممة لتنمية مهارات التواصل وريادة الأعمال.",
          point_three:
            "برامج تدريب عملي لدعم التطور التكنولوجي والتقني للمتعلمين الصغار.",
          specialization_cer: "مزايا الشهادات المتخصصة",
          rule_one:
            "يحق للمتعلمين الصغار الذين حصلوا على واحدة من الشهادات المتخصصة، المشاركة في برامج تدريب احترافية مقدمة من شبكة شركائنا.        ",
          rule_two:
            "نحرص على تقديم دورات تدريبية في مختلف المجالات التقنية وغير التقنية مثل الشبكات، والذكاء الاصطناعي، والروبوتات، ومهارات الاتصال، ومهارات الخطابة والتحدث، وإتقان اللغة الإنجليزية، وغيرها العديد من الدورات.",
        },
        rules: {
          main_head: "شروط الأهلية",
          main_text:
            ":متعلمي هلوكود الصغار مؤهلون للتسجيل في الامتحانات إذا استوفوا الشروط التالية",
          circle_age: "العمر بين سن 8 و 18 سنة",
          circle_completed: "إتمام الامتحانات بالتسلسل",
          circle_course: "أكمل الدورة التدريبية المتعلقة بالامتحان",
          sm_text: "(بشكل فردي أو من خلال المدرسة)",
        },
        exam_home: {
          exam_title: " برنامج شهادات هلو وورلد كيدز",
          HCP: "(HCP)",
          exam_openingStatment:
            "يعدّ برنامج شهادات هلو وورلد كيدز (HCP)، البرنامج الأول من نوعه الذي يُقدّم امتحانات وشهادات معترف بها دوليًا للمتعلمين الصغار من عمر 8 سنوات إلى عُمر 18 عامًا ومع مجموعة كبيرة من الامتيازات، وتعتبر هذه الشهادات إثبات على كفاءة المتعلمين الصغار في البرمجة ومجالات التكنولوجيا الأخرى.",
          Hello_certificate: "شهادة هلو ماستر",
          Hello_certi_details:
            "هلو ماستر هي أول شهادة من شهادات برنامج (HCP)، تُصدرها شركة هلو وورلد كيدز للمتعلمين الصغار الذين يجتازون امتحانات صممت خصيصًا لقياس كفاءتهم في البرمجة ودرجة إتقانهم لمهارات القرن الواحد والعشرين المتعلقة بالبرمجة.",
          certificate_stat: "تتكون شهادة هلو ماستر من ثلاث شهادات متخصصة:",
          hello_smoothy: "شهادة هلو سموذي® (HSY)",
          smoothy_details:
            "تتكون هذه الشهادة من ثلاثة امتحانات صممت خصيصًا لتقييم كفاءة المتعلمين الصغار في أساسيات البرمجة باستخدام لغة سموذي® البرمجية.",
          smoothy_exam1: "هلوكود سموذي المبتدئ",
          smoothy_exam2: " هلوكود سموذي المتوسط ",
          smoothy_exam3: "هلوكود سموذي المتقدم",
          hello_web: "شهادة هلو ويب (HWeb)",
          web_details:
            "تتكون هذه الشهادة من امتحانين صُمما خصيصًا لتقييم كفاءة المتعلمين الصغار في تطوي:ر صفحات الويب، لا سيما في لغة (HTML)، (CSS)، ولغة (JavaScript).",
          web_exam1: " هلوكود ويب ١",
          web_exam2: "هلوكود ويب ٢",
          hello_python: "شهادة هلو بايثون (HPY)",
          python_details:
            "تتكون هذه الشهادة من امتحانين صُمما خصيصًا لتقييم كفاءة المتعلمين الصغار في تعلم البرمجة بلغة بايثون.",
          python_exam1: "امتحان هلو بايثون المستوى الأول (HPL 1)",
          python_exam2: "امتحان هلو بايثون المستوى الثاني (HPL 2)",
          exam_btn: "سجل للامتحان الآن",
        },

        communityComponents: {
          school: "المدارس",
          admin: "الرجوع",
          readmore: "إقرأ المزيد",
          community: "تواصل اجتماعي",
          create_post: " منشور جديد",
          hellocode_world: "عالم هلو كود",
          greeting_main_message: "استكشف، برمج، شارك: نكون فريقًا معًا",
          contributions_kids: "منشورات الطلاب",
          Unfriend: "الغاء الصداقة",
          postText:
            "هذا هو طول المنشور الذي يمكن أن ينتقل / يبدأ من هذه النقطة ويصل حتى هذه النقطة ، ضع أكبر قدر ممكن من السطور",
          hide_posts: "إخفاء المنشور",
          edit_post: "تعديل المنشور",
          see_post: "شاهد المنشور",
          date_of_publishing: "قبل ساعتين",
          text_student_name: "اسم الطالب",
          See_all: "شاهد كل المنشورات",
          mob_students: "أبرز الطلاب",
          mob_top_posts: "أبرز المنشورات",
          Moball: "الكل",
          friend_tag: "صديق",
          level: "المستوى",
          Questions: "أسئلة",
          Ideas: "أفكار",
          engage: "شارك في المجتمع",
          anyWay: "فكر ، اكتب  وشارك!",
          top_coontributors: "أبرز المبرمجين",
          post_creation: "اكتب منشور",
          ask: "لديك سؤال؟ اسأل واستكشف!",
          ask_description: "شارك أسئلتك مع أصدقائك المبرمجين",
          idea: "حفل الأفكار . شارك أفكارك؟",
          idea_description: "انشر إبداعاتك والهم أصدقاءك",
          celebrate: "وقت الإنجازات . احتفل",
          celebration_description: "شارك المتعة وإحتفل بإنجازاتك ",
          whats_ur_question: "اسأل سؤال في البرمجة!",
          whats_ur_idea: "لديك فكرة مميزة لتشاركها ؟ اكتب أفكارك هنا",
          back: "رجوع",
          cancel: "اغلاق",
          Publish: "نشر",
          what_ur_celebrate: "ماالإنجاز الذي تودّ مشاركته والاحتفال به",
          Certificates: "الشهادات",
          Trophies: "الكؤوس",
          Badges: "الشارات",
          next: "التالي",
          choose_certificate: "إختر شهادة",
          recent_certificate: "أحدث شهادات",
          other_certificate: "شهادات أُخرى",
          choose_throphy: "إختر كأس",
          recent_trophy: "أحدث كؤوس",
          other_trophy: "كؤوس أُخرى",
          choose_badge: "إختر شارة",
          recent_badge: "شارات حديثة",
          other_badge: "شارات أُخرى",
          say_something: "ماذا تريد أن تقول عن إنجازك؟",
          celebrate_laststep: "إحتفل",
          badgeName: "*اسم الشارة او اي كان الإنجاز*",
          back_to_home: "العودة الى الصفحة الرئيسية",
          sucssess_modal_message: "لقد تم نشر منشورك بنجاح",
          correct_answer: "🎉 🎉 الإجابة الصحيحة ",
          commentbox:
            "أحسنت يا صديقي يا لها من فكرة رائعة 🥰💞, و بالنسبة لمنشورك السابق اظن انك بحاجة مساعدة في سموذي إسأل معلمك",
          top: "الأفضل",
          newest: "الأجدد",
          write_comment: "أُكتب تعليقًا",
          submit: "انشر",
          World: "عالمي",
          undefined_modal: "هل أنت متأكد من إلغاء الصداقة ؟",
          yes: "نعم",
          no: "لا",
          no_choose: "إختر إجابة أُخرى",
          question_sure: "هل أنت متأكد أنك تريد حذف هذا الصديق؟",
          deletefriend: "الغاء الصداقة",
          add_friend: "هل أنت متأكد أنك  تريد إضافة هذا الصديق؟",
          addfriend: "إضافة صديق",
          decline_friend: "هل أنت متأكد أنك تريد رفض طلب الصداقة؟",
          declinefriend: "رفض صديق",
          accept_friend: "هل أنت متأكد أنك تريد قبول طلب الصداقة؟",
          accpetfriend: " قبول طلب الصداقة",
          cancel_btn: "تراجع",
          selectProject: "شارك مشروعك",
          ShareCode: "مشاركة الكود",
          selectCourse: "اختار الكورس",
          next: "التالي",
          noresult: ".لا يوجد نتائج لبحثك",
          community_profile: {
            delecomment: "حذف التعليق",
            editcomment: "تعديل التعليق",
            student_name: "اسم الطالب",
            Level: "المستوى",
            progress: "التقدم الصفي",
            activity: "الفعاليات",
            all: "الكل",
            ques: "الاسئلة",
            idea: "الافكار",
            celeb: "الاحتفالات",
            date: "تاريخ الانشاء",
            hide: "اخفاء المنشور",
            unfriend: "الغاء الصداقة",
            points: "اجمالي النقاط",
            badges: "القلادات",
            badge_name: "اسم القلادة",
            proj: "المشاريع",
            chall: "التحديات",
            back: "الرجوع",
            hideden: "المنشورات المخفية",
            hide_stat: "لا يوجد منشورات مخفية حتى الان !",
            no_posts: "لم تشارك أي منشور للآن.",
            no_posts_friends: "لم يقم صديقك بنشر أي منشورات بعد.",
            add_posts: "إبدأ بمشاركة أفكارك، اسأل أسئلتك أو احتفل بإنجازاتك",
            cr_post: "انشئ منشورك الاول",
            request_reciver: "طلبات الصداقة",
            request_sender: " عرض الطلبات المرسلة",
            zero_celeb_posts: "ليس لديك اي من منشورات احتفالات بالانجازات",
            zero_ques_posts: "ليس لديك اي من منشورات اسئلة",
            zero_idea_posts: "ليس لديك اي من منشورات مشاركة الافكار",
            accept: "قبول طلب الصداقة",
            decline: "رفض طلب الصداقة",
            norequest: "لا يوجد أي طلب  صداقة",
            nofriend: "قم بإضافة أصدقاء الآن",
            nopeople: "لايوجد أصدقاء حتى الآن",
            friend: "الإصدقاء",
            unhide: "اعادة المنشور",
            pending: "قيد الانتظار",
            add_theFreind: "يجب عليك اضافة صديقك لمشاهدة فعالياته",
            more: "مشاهدة المزيد",
            less: "مشاهدة اقل",
            accept: "قبول",
            decline: "رفض",
            requesmessage: "يريد ان يكون صديقك",
            notfi: "الإشعارات",
            commentreply: ".علق على رسالتك",
            createpost: "تم إنشاء منشور بواسطة",
            acceptmessage: "تم قبول طلب الصداقة",
            zero_ques_friend: "ليس لدى صديقك اي من منشورات احتفالات بالانجازات",
            zero_celeb_friend: "ليس لدى صديقك اي من منشورات اسئلة",
            zero_idea_friend: "ليس لدى صديقك اي من منشورات مشاركة الافكار",
            no_notfication: "لا يوجد إشعارات",
            likecomment: "أعجب في تعليقك",
            likepost: "أعجب في منشورك",
            markasread: "مقروء",
            notify_question: "أجب على السؤال 😁✅",
            notify_celeb: "إحتفل مع صديقك 🥳🎉",
            notify_idea: "شارك أفكارك 🤔💭",
            your_correct_answer: " قام باختيار إجابتك كالإجابة الصحيحة",
          },
          friendsCommunity: {
            all: "كل الاصدقاء",
            zero_friends:
              "ليس لديك أصدقاء في مجتمعك في الوقت الحالي ، إليك بعض المبرمجين الذين قد ترغب في إضافتهم.",
            std_name: "اسم الطالب",
            level: "المستوى",
            mut: "الاصدقاء المشتركين",
            add: "اضافة صديق",
            people: "اشخاص قد تعرفهم",
            profile: "عرض الصفحة الشخصية",
            unfriend: "الغاء الصداقة",
            friend: "صديق",
            req_sent: "إلغاء الطلب",
            acc: "قبول الصداقة",
            rej: "رفض",
          },
          yes: "نعم",
          no: "لا",
          edit: "تعديل",
          sucssess_delete_message: "تم حذف منشورك بنجاح",
          sucssess_delete_comment: "تم حذف تعليقك بنجاح",
          delete_comment: "هل انت متأكد أنك تريد حذف هذا التعليق؟",
          sucssess_edit_message: "تم تعديل منشورك بنجاح",
          sure_delete: "هل انت متأكد أنك تريد حذف هذا المنشور؟.",
          hide_post: "هل انت متأكد أنك تريد اخفاء هذا المنشور؟",
          hide: "إخفاء المنشور",
          allComments: "الكل",
          profile: "الصفحة الشخصية",
          home: "الرئيسية",
          friends: "أصدقائي",
          comment_message: "تم إنشاء تعليقك بنجاح",
          correct_message: "هل أنت متأكد من أن هذه هي الإجابة الصحيحة لسؤالك؟",
          choose_correct: "اختر الإجابة الصحيحة",
          correct_button: "الإجابة الصحيحة",
          see_more_comments: "شاهد المزيد من التعليقات",
          see_less_comments: "شاهد تعليقات أقل",
          correct_chosen: "تم إختيار الإجابة الصحيحة",
          on_notification: "تفعيل الاشعارات",
          off_notification: "تعطيل الاشعارات",
          havent_chosen_yet: "لم تقم بإختيار الإجابة الصحيحة بعد",
          comments: "التعليقات",
          no_certificates: "احصل على شهادة واحتفل بإنجازاتك.",
          no_badges: "لم تكسب أي شارات بعد ، اكسبها واحتفل مع أصدقائك 🥳",
          no_throphies: "لم تكسب أي كؤوس بعد ، اكسبها واحتفل مع أصدقائك 🥳",
          no_comments:
            "لا توجد تعليقات حتى الآن ، قم بتغيير ذلك عن طريق ترك تعليق بأفكارك.🤔",
          no_answers: "لا توجد أي أجوبة حتى الان, حاول أن تجاوب 🤓",
          no_congrats: "لا توجد اي مباركات حتى الان, قل شيئًا لطيفًا🎉🤗",
          noResults:
            "نعتذر, ولكننا لم نتمكن من العثور على أي نتائج تطابق بحثك. يرجى المحاولة مرة أخرى باستخدام كلمات مختلفة.😓",
          is_not_friendC: "إضافة صديق",
          request_tag: "تم ارسال الطلب",
          no_correct_answer: "لم يختر الطالب الإجابة الصحيحة بعد",
          confirm_tag: "قبول",
          delete_tag: "رفض",
          close_modal: "إغلاق",
          deleteComment: "حذف التعليق",
          editComment: "تعديل التعليق",
          restoringMessage:
            " جميع منشوراتك المخفية تظهر هنا ، يمكنك استعادة أي منشور تريده",
          communityCourse: "الكورس",
          communityClassroom: "الغرفة الصفية",
          communityFriends: "الأصدقاء",
          communityRegion: "المنطقة",
          communityWorld: "عام",
          communitySchool: "المدرسة",
          likes_modal: "الإعجابات",
          liked_by: "أُعجِب من قبل :",
          no_likes_yet: "هذا المنشور لا يحتوي على إعجابات بعد 😓",
          communityFriendsRes:
            "قم بإضافة أصدقاء برمجة جدد ! أبحث الآن عن صديق البرمجة الجديد",
          communityRegionRes: "لم ينشر اي احد من منطقتك اي منشور بعد 😁",
          communityWorldRes: "لم ينشر اي احد بالعالم اي منشور بعد 😁",
          communitySchoolRes: "لم ينشر اي احد من مدرستك اي منشور بعد 😁",
        },
        Perks: {
          title: "إمتيازات",
          main_title: "إمتيازات شهادة سموذي المستوى الأول",
          Discount: "خصم 50%",
          text:
            "Eureka Academy هي مؤسسة تكنولوجية تركز على ضمان حصول الشباب على بداية جيدة في سعيهم لاكتساب المعرفة بالعالم التكنولوجي.",
        },
        memoryGame: {
          memory_game: "لعبة الذاكرة",
          try_again: "حاول مرة أخرى 😥",
          good_job: "عمل جيد 😊",
          great_job: "عمل رائع 😊",
          amazing_job: "عمل مدهش 🤩",
          time: "لقد أنهيت اللعبة في ",
          second: "ثانية 🎆",
          no_stars: "لم تكسب أي نجوم",
          quit: "إنهاء اللعبة",
          again: "العب مرة أخرى",
          welcome: "مرحبًا بك في لعبة تقليب بطاقات الذاكرة! 🎆",
          Goal: "الهدف",
          goal_msg: "اعثر على أزواج متطابقة من البطاقات.",
          how: "كيفية اللعب ؟ 🤔",
          step1: "انقر على أي بطاقتين لقلبهما.",
          step2: "تذكر الصور الموجودة على كل بطاقة.",
          step3: "إذا تطابقت البطاقتان، ستبقى مقلوبتين، وستحصل على نقطة.",
          step4:
            "إذا لم تتطابق البطاقتان، ستعودان للوضع الأصلي، ويمكنك المحاولة مرة أخرى.",
          step5:
            "استمر في قلب البطاقات والبحث عن التطابقات حتى تتم مطابقة جميع الأزواج.",
          enjoy: "استمتع باللعب وحاول قلب جميع البطاقات قبل إنتهاء الوقت! 😊",
          Start: "ابدأ",
          and: "و",
          moves: "حركة 🤖",
        },
        puzzlegame: {
          title: "لعبة الأحجية",
          step_1: "الهدف: حرك المربعات لترتيبها بشكل صحيح وكشف الصورة.",
          step_2: "عناصر التحكم: اسحب المربعات أو اسحبها لتمريرها ومحاذاتها.",
          step_3:
            "  رتب كل المربعات بشكل صحيح لإظهار الصورة والانتقال إلى الدرس التالي ؛ يجب أن تكتمل اللعبة بشكل صحيح.",
          back: "الرجوع",
          next: "البدء",
          submit: "انهاء",
          try: "محاولة مرة أخرى",
          pass: "لقد اجتزت هذه اللعبة!",
          cong: "تهانينا!",
          title_mess: "تعمل فقط على جهاز لاب توب",
        },
        draganddrop: {
          total_moves: "عدد مرات التحريك",
          title: " لعبة السحب والإفلات",
          stepone:
            "الهدف: مطابقة الصور مع الكلمات أعلاه داخل الصناديق الصحيحة.",
          steptwo:
            "التحكم: اضغط على زر الفأرة واسحب الصورة  ثم أفلت الزر لوضع الصورة داخل الصندوق الصحيح.",
          stepthree:
            "الإكمال: تنتهي اللعبة عند وضع جميع الصور داخل الصناديق. للانتقال للدرس التالي، يجب أن توضع الصور داخل الصناديق الصحيحة.",
          // stepfour:"المطابقة: قم بسحب وإسقاط الكائنات إلى الأهداف المقابلة لها.",
          // stepfive:"الإكمال: ينتهي عند وضع جميع الكائنات بشكل صحيح أو تحقيق الأهداف.",
          start_btn: " البدء",
          back_btn: "الرجوع",
          level_name: "المرحلة",
          play: "العب",
          game_name: "السحب والإفلات",
          back_step: "الرجوع",
          next_step: "التالي",
          try:
            "لا تقلق ، الخسارة تعني أنك تقترب خطوة واحدة من الفوز في المرة القادمة!",
          try_again: "حاول  مرة أخرى",
          total: "مجموع النقاط",
          well_done: "أحسنت!",
          complete: "مكتمله",
          submit: " الانتهاء",
        },
        Pricing: {
          title: " استمتعوا بخصم 15% مع تسجيل الأخوة  في Hellocode.me!",
          title2: "استمتعوا بخصم10% عند اختيار أكثر من كورس في Hellocode.me",
          per_user: "لكل كورس",
          start: "سجل",
          from: "بدءا من",
          Popular: "شائع",
          Basicone: "سموذي المبتدئ –المستوى الأول",
          Basictwo: "سموذي المبتدئ –المستوى الثاني",
          interone: "سموذي ‌ المتوسط - المستوى‌ ‌الأول",
          intertwo: "سموذي ‌ المتوسط - المستوى‌ ‌الثاني",
          advanceone: "سموذي ‌ المتقدم - المستوى‌ ‌الأول",
          advancetwo: "سموذي ‌ المتقدم - المستوى‌ ‌الثاني",
          juniorone: "جونيور - 1",
          juniortwo: "جونيور - 2",
          juniorthree: "جونيور - 3",
          cert: "شهادة لكل مستوى",
          web: "تطوير صفحات الويب - المستوى الأول",
          python: "بايثون - المستوى‌ ‌الأول",
          tip_skill:
            "7.2 دولار لكل دورة / لكل مستخدم عند شراء الدورة لأكثر من طفل أو 8 دولارات لكل دورة / لكل مستخدم",
          tip_smoothy:
            "أو 31.5 دولار لكل دورة / لكل مستخدم عند شراء الدورة لأكثر من طفل أو 35 دولار لكل دورة / لكل مستخدم",
          tip_web:
            "أو 40.5 دولارًا لكل دورة / لكل مستخدم عند شراء الدورة لأكثر من طفل. أو 45 دولارًا لكل دورة / لكل مستخدم",
          tip_python:
            "أو 49.5 دولار لكل دورة / لكل مستخدم عند شراء الدورة لأكثر من طفل أو 55 دولار لكل دورة / لكل مستخدم",
          smoothy_track:
            "تمنح دورة سموذي الأطفال المهارة ليصبحوا أبطال برمجة! سيتقن الأطفال المبادئ الأساسية للبرمجة من خلال مقاطع كرتونية مشوّقة وقصيرة ومشاريع تفاعلية وتحديات مليئة بالإبداع. ",
          web_track:
            "سيتعلّم الطلّاب مهارة تصميم الويب من خلال إنشاء صفحات الويب باستخدام HTML,CSS, JavaScript.",
          python_track:
            "تقدّم دورة بايثون للطلبة لغة تقنية رائدة وحديثة من خلال رحلة ممتعة وبسيطة .",
          computer_track:
            "تقدّم دورة الحاسوب المليئة بالمرح مقدّمة حول أساسيات الحاسوب في بيئة تعليمية آمنة وجذّابة. ",
          title_smoothy: "دورة سموذي",
          title_web: "دورة تطوير الويب",
          title_skill: "دورة الحاسوب للمبتدئين",
          title_python: "دورة بايثون",
          see_details: "مشاهدة التفاصيل",
        },
      },
    },
    en: {
      message: {
        general: {
          required_email: "Email is required",
          stop: "Under Maintanance",
          sorry: "Sorry for the inconvenience. ",
          call: "Contact US",
          warence:
            "Our website will be undergoing maintenance on Saturday from 5 am to 3 pm. We appreciate your patience and understanding.",
          correct: "Correct",
          wrong: "Wrong",
          min_chars: "There must be at least ",
          characters: "characters",
          max_chars: "Max Characters is",
          between_chars: "Must be between",
          provide_valid_email: "Please enter a valid email address",
          provide_valid_phone: "Please enter a valid phone number",
          select_valid_birthyear: "Please select year of birth",
          captcha_label:
            "But before you submit, here is a small challenge to get you started:",
          correctـanswer: "Correct",
          password_identical_msg: "Passwords must be identical.",
          options_selected: "options selected",
          dont_show: "Don't show this again",
          team: "By Hello World Kids Team",
          title: "Proven Path To Coding Confidence and Learning",
          sub_title: "Self-paced learning for all ages & experience levels",
          note: "A child expands their creativity when they learn how to code",
          special_chars: "The name must not contain symbols",
          all_feilds: "Please fill in the required fields",
          city: "Please enter the city in English",
          MiddleName: "Please enter the middlename in English",
          FirstName: "Please enter the firstname in English",
          lastName: "Please enter the  lastname in English",
        },

        Community: {
          postplaceholder: "What's on your mind?",
          Comments: "Comments",
          Comment: "Comment",
          Likes: " Likes",
          Like: "Like",
          commentPlaceHolder: "Write  a comment",
          Edit: "Edit",
          Remove: "Remove",
          posts: "posts",
        },
        kidsSafe: {
          content: "The Safe and Fun Environment your Kids Need ",
          sub_title:
            "while learning how to build new technologies through a unique coding curriculum",
          register: "Register for FREE",
          card_title: "Engaging Creativity",
          place_title: "Secure and Safe Platform",
          play_title: "Certified Curriculum",
          title_game: "Game-Based Learning",
          card_text:
            "Let their creativity run free and be reflected in coding projects",
          des_place:
            "Kids can build their own world and ideas in a safe and fun space",
          des_play:
            "Each coding course completed by the kids  will have a certificate ",
          des_game:
            "To ensure that kids are having the most fun while learning",
        },
        amazingkidssection: {
          title_heading:
            "Witness the Creativity of HelloCode Little Programmers!",
          text_heading:
            "Take a glimpse at some of the amazing projects created by kids using the HelloCode platform.",
          text_btn: "View our curriculum",
          course_title: "SMOOTHY PROGRAMMING",
          project_title: "The Pyramids",
          project_des:
            "Reflecting one of the world’s wonders in a beautiful display designed with an advanced coding language.",
          name_and_grade: " Ahmad Amer - 3rd grade",
          advanced_programming: "SMOOTHY PROGRAMMING",
          project_advanced: "Tic-tac-toe",
          des_advanced:
            "A simple everyday children game, but turned into a sophisticated programming project.",
          name_and_gradeSc: " Ibrahim Ahmad - 4th grade",
          course_hwk: "SMOOTHY PROGRAMMING",
          project_hwk: "The Math Train",
          des_hwk:
            "A simple programming project at first glance,but it shows a remarkable understanding of mathematics.",
          name_and_3rdgrade: " Maha Ahmad - 5th grades",
        },

        schoolSection: {
          shared_title: "HelloCode for All",
          parent_title: "For Parents & Kids",
          teacher_title:
            "HelloCode teaches your kids coding in fun, simple, and enjoyable way.",
          school_text:
            "Start building a new generation of creative and analytical thinkers",
          text_inner: "Witness the development of their character.",
          text_view: "Watch their creativity and achievements.",
          text_control: "Enjoy the progress of their growth.",
          parent_register: "Register for FREE",
          school_title: "For Schools",
          teacher_title:
            "Turn your kid into a technology expert with our fun and dynamic courses.",
          create_class: "Empower your students' with decisive life skills.",
          assign: "Increase their observation and problem-solving abilities.",
          Add_multiplething:
            "Prepare them for a technology-driven future with essential knowledge.",
          school_btn: "Request a Demo ",
        },
        testimonialsection: {
          sub_title: "ProudOF",
          sub_lines: "LINES OF WRITTEN CODE",
          num_code: "4,500,000 ",
          btn: "Write the next line",
          nameTestimonial1: "Haya Qareen",
          ageTestimonial1: "8 years old",
          textTestimonial1:
            "I love HelloCode because it helped me build my own application which aims to help the poor. Next, I will build another application to fix mobiles and iPads, because my iPad screen keeps on glitching.",
          nameTestimonial2: "Dina Abdul Majeed",
          ageTestimonial2: "Founder & CEO at 360Moms",
          textTestimonial2:
            "My 8 years old son really enjoyed learning coding through Hello World Kids. The lovely characters make it super fun! The big plus is that the more they practice and get. coding right the more points they get,I like playing a game.",
        },
        footersection: {
          about_text: "A World of Possibilities.",
          contact_heading: "Contact Us",
          footer_phone_number: "+962790488840",
          links_heading: "Useful links",
          Courses: "Courses",
          ForSchools: "For Schools",
          SupportCenter: "Support Center",
          Termsofuse: "Terms of use",
          privacy: "privacy",
          form_heading: "Our Newsletter",
          text_form:
            "Subscribe to our newsletter to get the latest updates on our services and products.",
          email_placeholder: "Your Email address",
          input_btn: "Get In !",
          copyright_text: "CopyRights Hello World Kids",
          social_text: "Follow us",
          location:
            "Makkah Al-Mukarramah Street Building No. 33 Floor – 5, Amman , Jordan",
        },
        coursesSection: {
          title_heading: "Unique Programming Courses for All Ages.",
          text_heading:
            "Kids’ talents and creativity will shine with these diverse and interactive courses . These powerful and expert-led courses are the first step towards building your kids' future.",
          text_btn: "See All Courses",
          course_title: "SmoothY Coding Courses",
          description_title: "SmoothY Coding Courses",
          description_text:
            "In these fun and unique programming courses, kids will first learn coding basics, and then they will start  developing applications and games and build stories in a world of their own.",
          description_smoothy:
            "Kids will start their technological journey with the knowledge and skills required to interact with computers. They will learn by playing challenging thinking games that improve their thinking and problem-solving skills.",
          title_smoothy: "Computer skills Courses",
          course_smoothy: "Computer skills Courses",
          course_advance: "Web Development Courses",
          description_advance: "Web Development Courses ",
          text_advance:
            "This course will teach kids how to build and design websites that contain different elements and program them using advanced programming languages such as JavaScript, HTML, and CSS.",
          learnMore: "learnMoreAboutOurCourses",
        },

        course: {
          DoneModalText:
            "You have successfully completed this level!see you in the next level.",
        },
        boostProductivitySection: {
          main_title: "Unleash your Creativity",
          main_text:
            "Enjoy our Interactive platform and unique programming courses while using any device.",
          upperCardDText: "Full of Exciting Features",
          lowerCardDText:
            "HelloCode is full of powerful features such as classroom management and automatic assessment.",
          Responsiveweb: "Responsive Web Display",
          Responsive_text:
            "Our platform looks good on all devices! A responsive web design that adjust on different screens.",
          loadedfeat: "Regular forever",
          features_des:
            "Continuous development for teachers’ and students’ powerful features. ",
          request_btn: "Request A Demo ",
          register_btn: "Request A Demo",
          features_update: "Regular Updates",
          text_update:
            "Your well-oiled machine doesn’t have to break down due to build processes.",
          process:
            "  Your well-oiled doesn’t have to down due to complex processes, or lack of time to enforce consistency.",
        },
        safeQuestion: {
          title: "Answer the safe question",
          btn: "Finish",
          answer: "write thw answer",
          messages: "Question or answer is wrong",
        },
        cycileSection: {
          text: "Built for Educators",
          Register: "Classroom Management",
          request_text:
            "Utilize a wide variety of tools to help you run classrooms easily .",
          see_text: "Ask us how!",
          Addteacher: "Progress Monitoring",
          text_addteacher:
            "Evaluate student learning on a regular basis and teacher’s progress .",
          Assignclassess: "Automatic Assessment",
          Assign_teacher: "An aided grading tool for all  types of exercises.",
          AddStudent: "Coding Environment",
          text_addstudent:
            "With our built in IDE, students can enjoy coding at any time ",
        },
        contribution: {
          linesofcode: "Lines of codes have been written by young kids",
          numofschool:
            "Schools trust HelloCode and its’ courses while educating their students",
          numofstudent:
            "Students have enrolled in HelloCode from different schools",
          numofclasses:
            "Teachers have been creating many classes at different levels",
        },
        schoolsQuotes: {
          main_title: "Hear it from other Schools.",
          teacher_name: "Hanan Khaleefa",
          school_name: "Al-Mayer",
          quotes:
            "I like HelloCode because it helped students understand math in a better way. They use X-axis and Y-axis to draw shapes as Redo and Greeno exactly taught them.",
          secondteacher_name: " Ahmed Al-Tamary",
          secondschool_name: "Al-Mayer",
          second_quotes:
            "Coding became my favourite hobby. I like to spend time with my students on HelloCode to create apps and coding projects in an easy and fun environment.",
          request_demo: "Request A Demo",
        },
        helloCodeHeros: {
          text_main: "!Hello Code Heroes",
          name_student: "Mira Al Bakri ",
          des_student:
            "Smart and talented, she is the first one to create 3D projects on HelloCode. She aspires to be a  programmer in the future. ",
          student_school: "AlRadwan Schools ",
          secondStudent: "Jad Al-Ammari",
          seconddes_student:
            "Coding helped him in mathematics, and he’s developing his skills to become a programmer in the future.",
          secondschool: "Baptist Schools",
          thirdrdStudent: "Issam Wa’el Sitan ",
          thirddes_Student:
            "“Creative, intelligent, always thinking out of the box, and has a bright future”; this is how his teachers described him.",
          third_school: "AlRadwan Schools",
          fourthStudent: "Eid Gazi",
          fourthdes_Student:
            "One of the most talented young programmers, with well written lines of code a strong ability to innovate.",
          fourth_school: "International Independent Schools",
          fifthStudent: "Leen Al-Khoderi ",
          fifthdes_Student:
            "Intelligent and one of the youngest programmers on HelloCode, with dreams to become a professional programmer. ",
          fifth_school: "Ahliyyah Schools",
          btn_demo: "Request A Demo",
        },
        skillsSection: {
          main_text: "Students’ Skills ",
          Idea_title: "Thinking",
          des_Idea:
            "Through our courses, students will develop their thinking skills.",
          empathy_title: "Problem-Solving",
          des_empathy:
            "Programming increases students' ability to notice problems.",
          plan_title: "Communication",
          des_plan:
            "Students' communication skills will improve as they learn.",
          Communication: "Planning",
          des_commun:
            "With project-based learning, students will learn to lead with deadlines.",
          Creative_title: "Creativity",
          des_Creative:
            "Students will mirror reality and create their own worlds.",
          coding_title: "Coding, obviously!",
          des_coding:
            "With HelloCode, students will start writing, and analyzing codes.",
          btn_demo: "Request A Demo ",
        },
        thirdSectionHome: {
          titlePage: "SmoothY Language!",
          Paragraph:
            "SmoothY is a fun and unique programming language developed especially for our little programmers to serve as a bridge and enable them to learn professional programming languages easily. ",
          card_title: "Simple and Easy",
          title_pazzel: "Personalized for Kids",
          title_game: "Programming Professionals",
          card_para:
            "Kids can use SmoothY to develop applications and games or to simply build creative stories.",
          pazzel_para:
            "SmoothY simplifies programming for kids through a fun and easy-to-grasp medium.",
          game_para:
            "Competence with SmoothY is your kid’s first step to becoming a professional programmer!",
          text_btn: "Request A demo",
          btn_reg: "Register a Free Account ",
        },
        topSectionA: {
          Revol: "Start Teaching",
          main_title: "the Language of the Future.",
          main_text:
            "A unique learning environment with a fun and easy approach using online games to teach programming and improve students' thinking and problem-solving skills.",
          feature_one: "Innovative lessons and interactive games",
          feature_two: "Monitoring students' progress regularly and easily",
          feature_three:
            "A bundle of educational resources (videos, guides, etc.).",
          demo_book: " Book A demo",
          meeting:
            "Discover HelloCode and its amazing features by booking a quick demo. Find out how our platform can improve your educational process.",
          org_name: "Organization Name",
          email_school: "School Email",
          mobile: "Phone Number",
          req_submit: "Submit request",
          req_demo: "Request A Demo",
          Trusted: "Our Clients",
          close: "cancel",
          success_message:
            "A representative from our sales team will get in touch with you soon",
        },

        registerFree: {
          main_title: "It’s your Turn.",
          main_text:
            "Start your programming experience and learn how to unleash your creativity and turn your dreams into a reality.",
          btn_register: "Register for FREE",
        },
        createPassword: {
          save_pass: "رائع، الآن يمكنك تسجيل الدخول ",
        },

        AsneakPeakatourcourses: {
          main_title: "A Sneak Peek at our Courses",
          main_text: "We have more courses under ",
          second_mainText: "our belt, enjoy these nuggets below.",
          card_text: "Computer skills Courses",
          card_html: "SmoothY Coding Courses",
          text_smoothy: "Web Development Courses ",
          text_python: " Python Coding  Courses",
          title_card: "Computer skills Courses ",
          // second_titleCard:'Courses',
          title_html: "SmoothY Coding Courses ",
          // second_titlehtml:'Courses.',
          title_smoothy: "Web Development Courses  ",
          // second_titlesmoothy:"Courses",
          title_python: "python Coding Courses  ",
          text_card:
            "Students will start their technological journey with the knowledge and skills required to interact with computers. ",
          text_smoo:
            "Kids will first learn coding basics, then start developing applications, games, and build stories in a world of their own.",
          text_web:
            "Kids will learn how to build and design websites with different elements and styels using advanced coding languages. ",
          text_html:
            "Kids will learn how to build and design websites with different elements using advanced coding languages. ",
          smoothy_card:
            "In these fun and unique programming courses, kids will first learn coding basics, then start developing applications, games.",
          btn_vido: "Play video",
        },
        projectOftheMonth: {
          main_title: "PROJECT OF THE MONTH",
          nameofProject: "Astronaut in Space",
          descrProject:
            "Eman dreams of becoming an astronaut, so she tells her space story through programming.",
          summery_project: "Project Overview",
          para_one:
            "Through her project, Eman tried to imagine the trip she's always wanted to take up to space. She used all her knowledge to write 783 professionally organized and written code lines. She imagined, analyzed,planned, and then executed her amazing story. ",
          para_two:
            "Attention to detail, such as the space shuttle smoke, added aesthetic value to the project. We are so proud of Eman because she used programming to reflect her imagination into a reality on her computer screen.",
        },

        addkid: {
          text: "You have not added any kid yet",
          main_text:
            "Add your kids now so they can start a unique learning experience",
          btn_add: "Add your kids now",
          btn_exist: "Link an existing Kid Account",
          main_title: "Add your Kid",
          create_btn: "Create Account",
          cancle: "Cancel",
          thank: "Thank You!",
          text_mess:
            "Your kid’s account has been created successfully. Your kid is in for a great experience.",
          done_btn: "I am done Here",
          btn_link: "Link  Account",
          main_link:
            "Use the username and password of your kid's account on HelloCode in order to link their account to yours.",
          title_link: "Link a Kid Account",
          full_name: "Fullname",
          user_name: "Username",
          password: "password",
          generate: "Generate Username",
          birthday: "Age",
          vali_password: "Min characters is 6",
          goodname: "Min characters is 3",
          userlinked:
            "Username or password is wrong, or this child already has parent",
        },
        offer_hellocode: {
          the_offer: "What HelloCode Offers?",
          Reward: "Accredited certificates for the courses.",
          time: "The perfect activity for your kids.",
          creative: " A fun and unique teaching method.",
          calcu: "Developing thinking and creative skills.",
          course_title: "HelloCode Courses ",
          course_one: "Computer skills Courses  ",
          course_two: "SmoothY Coding Courses ",
          course_three: "Web Development Courses   ",
          Course_one:
            "Kids will start their technological journey with the knowledge and skills required to interact with computers.",
          Course_two:
            "In these unique programming courses, kids will learn coding basics, and then they will start developing applications and games.",
          Course_three:
            "This course will teach kids how to build and design websites with different elements and styels using advanced coding .",
          Frequently: "Frequently Asked Questions",
          FAQs: "FAQs",
          main_Question: "what is assisted learning?",
          Q_one: "How do kids learn to programming on HelloCode?",
          Q_two: "What is the 'Assisted Learning' feature?",
          Q_three: "What are the appropriate ages for registration?",
          // Sub_title:"Subtitle",
          // Second_title:"Subtitle",
          main_para:
            "A certified tutor from HelloWorldKids will check and mark your child’s projects and give guidance through personal feedback.",
          para_one:
            "HelloCode offers your kids a unique programming experience by providing an easy and fun educational method, specifically designed to stimulate their creativity, develop their thinking and academic skills, and enhance their communication skills.",
          para_two:
            "With this feature, a certified teacher from Hello World Kids evaluates your kids' projects and gives them direct feedback and guidance. The price for this feature is (10 $) per course.",
          para_three:
            "HelloCode platform is suitable for the age group from 6 to 15 years.",
        },
        plan_hellocode: {
          main_text: "Congratulations!",
          text_main:
            "You have successfully registered your kid and the receipt has been sent to your email",
          text:
            "Do not forget to support and encourage your kid to unleash his creativity.",
          sub_text:
            "Your kid can start his learning journey now. Lessons available under this course.",
          video_text: "VIDEO",
          lesson_title: "Lesson Name",
          second_video: "VIDEO",
          second_lesson: "Lesson Name",
          third_video: "VIDEO",
          third_lesson: "Lesson Name",
          btn_back: "Back to dashbaord",
          heading_title: "Update plan",
          explain_text: "Update your plan and get access to more courses",
        },
        rgChild: {
          sm_text: "Back",
          KidsRegisteration: "Kids’ Registration",
          main_text: " You will have immediate access to HelloCode courses",
          Register_text: "Register",
          Register_Child: "Kids Registeration",
          card_title:
            "So many fun games and courses are waiting for you at HelloCode.",
          card_text:
            "Hi there, nice to meet you. What’s your name? We need this to create a username for your account.",
          full_name: "Fullname",
          name: "UserName",
          Generateusername: "Generate Username",
          member_text: "Already a member?",
          sign_text: "Sign In",
          register_btn: "Continue to Birthday",
          try: "Try Another one",
          usertaken: "Username already taken",
          goodname: "Woha, You’re good to go",
          strong_pass: "Create strong password",
          pass_text:
            "Add a password you will remember. It will be our little secret.",
          lab_pass: "Password",
          Account_free: "Create FREE Account now",
          good_password: "Woha, You’re good to go.",
          save_pass: "Now save it some where safe so you can remember it.",
          not_enough: "Not Enough",
          write_more: "Give it more charchters",
          almost_good: "Almost there.",
          yearofbirth: "How old are you?",
          mess_text: " Change it ",
          password_btn: "Continue to Password",
          parent_registration: "Parent Registeration",
          accsess: "You will have immediate access to HelloCode courses",
          select_safe_question: "Choose safe question",
          no_chara:
            "username can only include letters, numbers, and one of -,_,or . but no special characters",
          courses_det: "Courses Details",
          courses: "Courses",
          ensure:
            "The value received is what matters, not the amount! Choose the number of courses you want to give to your special kid.",
          sale: "Discount Coupon is applied",
          alreadyBought: "You have already bought all courses for this kid",
        },

        demo: {
          request: "Request A Demo",
        },
        register: {
          num: "4.5 Million",
          lines: "Lines of codes written by kids ",
          Time: "Spend time while learning a significant life skill.",
          Reward: "Receive certificates for the coding courses.",
          creative: "Creative and fun learning methods.",
          packges: "Show your creativity and bring your ideas to life.",
          discount: "25% Discount Coupon is applied",
          twoType: "Register as parent or kid",
          Free: "It’s FREE. No credit card needed",
          who: "I'm a Kid",
          Iwant: "I want to have fun and learn coding",
          Who_is: "I'm a Parent",
          Ineed: "I want a great experience for my kids",
          register_btn: "Register  A FREE Account",
          Ihaveaccount: "Already a member?",
          SignIn: "Login",
          strong_password: "Create a strong password",
          remember_password:
            "Add a password you will remember. Yeah exactly, that one you use the most",
          hello_parent: "Hello, Parent",
          great_exp: "Your kid is in for a great experience",
          emai_address: "Email Address",
          phone_insted: "Use Phone Number Instead",
          email_insted: "Use Email Instead",
          free_acc: "Register in a free account",
          get_in_with: "Or Continue With",
          email_confirmation: "Confirm your email address",
          email_confirmationMsg: "We have sent a code to ",
          email_confirmationMsgPt2:
            "please confirm so we can proceed with your account creation",
          not_getting_code: "Not getting any code?",
          or: "or",
          contact_support: "Contact Support",
          change_email: "Change Email",
          resend: "Resend another code after",
          seconds: "Seconds",
          resendCode: "Resend Code",
          resend_email: "Resend email",
          verify: "verify",
          otp: "OTP Confirmation",
          confirm: "Confirm your Phone number",
          Register_Parent: " Parents Registeration",
          change_phone: "Change phone",
          no_chara:
            "username can only include letters, numbers, and one of -,_,or . but no special characters",
        },

        questions_ide: {
          hello: "Hello, Good luck.",
          correct: "Correct, Now lets move to next lesson.",
          incorrect: "Oops!! incorrect answer, Now lets move to next lesson.",
          correct_final: "Great! Correct answer.",
          incorrect_final:
            "You are almost there! Let's move to another question.",
          question_number: "Question Number",
          congrats: "Congratulations",
          next_btn: "Next",
          check_my_answer: "Check My Answer",
          notChoseAnswer: "Please choose an answer",
          notFilledAnswer: "Please make sure to fill out all fields.",
          titleAnswer: "Alert!",
          acceptAnswer: "Accept",
          lets_try_another_one: "let's try another one",
          submit_btn: "Submit",
          checked:
            "Please make sure to select at least one child,read and agree on the terms and conditions first.",
          drag_and_drop:
            "Drag and drop the expected answers below into the most relevant boxes.",
          error_message:
            "please drop all element and make shure you have one answer for each question.",
        },
        notifications: {
          approved: "Approved",
          pending: "Pending",
          disapproved: "Disapproved",
          error_pending: "There are no pending projects yet",
          error_approved: "There are no approved projects yet",
          error_disapproved: "There are no disapproved projects yet",
          no: "No",
          yes: "Yes",

          click_to_review_code: "Click to review your code",
        },
        games: {
          maze_instruction: "Move the pointer from the arrow to the treasure.",
          maze_instruction2: "Don't let the pointer touch the blocks.",
          maze_instruction_modal:
            "Move the pointer through the tunnel to the treasure.",
          lose_maze: "Ops! The pointer touched the blocks.  Play Again.",
          win_maze: "You did it!",
          typing_instruction_modal:
            "Type the letters and numbers that appear on the screen from your keyboard.",
          typing_instruction: "Try to score more than 10 within 1 minute!",
          typing_instruction1:
            "Press CapsLock or Shift with key to get Capital letter or special characters",
          typing_lose: "Your score is less than 10! Play Again.",
          typing_win: "You did it!",
          typing_score: "Score",
          typing_time: "Time left",
          presentation_instruction: "Presentation",
          word_instruction: "Microsoft word",
          excel_instruction: "Microsoft Excel",
          paint_challenge_instruction: "Draw using the pencil tool",
          paint_challenge_two_instruction: "Draw using the brush tool",
          paint_challenge_three_instruction: "Add shapes to your drawing",
          paint_challenge_four_instruction: "Add text to your drawing",
          done: "Done",
          start: "start",
          coloring_instruction_modal:
            "Color the drawing. Do not forget the shared border rule!",
          coloring_instruction: "Color a shape. ",
          coloring_instruction2:
            "Remember! The shapes with shared border cannot have the same color.",
          coloring_win: "You did it!",
          coloring_lose: "The coloring is incorrect! Play again.",
          color: "Color",
          Block: "Block",
          choose_color: "Please choose a color:",
          address_instruction_modal: "Color the magical table blocks.",
          address_instruction:
            "Check the information table to find the magical table blocks color",
          address_lose: "The coloring is incorrect! Play again",
          address_win: "You did it!",
          sudoko_instruction_modal:
            "Drag and drop the shapes to fill the empty blocks. <br> Remember! Don’t drop the same shape twice in a column or row",
          play_btn: "Play",
          table_info: "The information Table",
          magic_table: "The magical Table",
        },
        video: {
          watch_story: "Watch our story",
        },
        footer: {
          terms: "Terms of Service",
          privacy: "Privacy Policy",
          copy_right: "2021 © Copyrights Hello World Kids",
          contact_us: "Contact Us",
        },
        student_course_details: {
          spinModal: {
            spin: "Spin The Wheel!",
            redoEasy: "Easy",
            greenoHard: "Hard",
          },
          premium_modal: {
            title: "Upgrade your account",
            text1: "Unleash the super programmer inside you!",
            text2: "To upgrade your account please ask your Parent to login",
            text3: "to the parent account or to register a parent account",
            text4: "More Interesting lessons and projects are waiting for you",
            login: "login",
          },
          info_modal: {
            title1: "Super!",
            text2:
              "Now send your child’s login details via WhatsApp, or you can login with your child’s account from here.",
            text3: "Share via WhatsApp ",
            text4: "Continue with my programmer account",
          },
          offer_modal: {
            title1: "Subscribe!",
            text2: "Continue free",
          },
          project_modal: {
            text: "Challenge projects",
            text_1: "choose your project",
          },
          well_done_modal: {
            text:
              "You have successfully completed this level! time to move to the next one!",
            text_school:
              "You have successfully completed this level! see you in the next level",
            text_connect: "Request your next level",
            Certificate: "Congrats! Wait for Your Certificate",
            Certificate_text:
              "Please fill in the below fields your name in the English language, in order to print it on your certificate.",
            Certificate_note:
              "Note: Your name will be fixed on all the certificates",
            generate: "generate",
          },
          stones: {
            lesson: "Lesson",
            game: "Game",
            challenge: "Challenge",
            code: "Code",
            review: "Review my code",
            no_code: "There is no code to review",
            graduationProject: "Graduation project",
            project: "Project",
          },
          btns: {
            start: "Start",
            completed: "Completed",
            soon: "Soon",
            next: "Next",
            locked: "Locked",
            finish: "Finished",
          },
        },
        ide: {
          course: "Course: ",
          lesson: "Lesson: ",
          comments: "Comments",
          good_job: "Good Job!",
          think_again: "Think again",
          btn_yes: "Yes",
          hello_modal1:
            "Dear programmer, we are very excited to see your wonderful projects! ",
          hello_modal2:
            "You can submit up to three projects per day. Make sure to submit your best projects to increase your points.",
          hello_modal3: "Make sure that you submit your completed project. ",
          hello_modal4: "You have submitted 0 projects. ",
          hello_modal5: "Are you sure you want to submit this project?  ",
          hello_modal6:
            "You have submitted your three projects for today, save your project and submit it tomorrow.",
          hello_modal7: "Your project will be corrected within a week",
          btn_no: "No",
          use_hint:
            "Are you sure you want to use hint! it will decrease your points by 10",
          waiting: "Waiting...",
          help_me: "Help me",
          sound_lib: "Sound library",
          my_projects: "My projects",
          save_project: "Save project",
          see_more: "See more",
          Sound_library: "Sound library",
          Image_library: "Image library",
          playground_Saved_Projects: "playground Saved projects !",
          teacher_project: "Teacher Projects",
          Add_new_project: "Add new project",
          PlaygroundـProjects: "Playground Projects",
          CoursesـProjects: "Courses Projects",
          playground_course_title: "Course project",
          playground_note_refresh:
            "Note: if you can't write anything on IDE, please refresh the page",
          playground_course_desc:
            "Remember to show the project goal. Let's continue coding. You can do it!",
          playground_course_desc1:
            "You can earn more points by creating special projects in the playground.",
          playground_title: "Welcome to HelloCode playground!",
          teacherIde_title: "Hello teacher you can write Smoothy code here ",
          playground_desc:
            " It's where you can explore coding.Feel free to create your own programs, just the way you want.",
          playground_desc_share:
            "Create your own programs, just the way you want.",
          show_Project_goal: "Show Project Goal",
          img_lib: "Image library",
          text_copied: "copied",
          click_copied: "click copy to copy image url",
          text_copy: "Copy path",
          video: "video",
          back: "back",
          loading: "loading ...",
          run: "Run",
          next: "Next",
          cancel: "Cancel",
          social_title_modal: "You can share your project via",
          full_screen: "Full screen",
          daily_submission: " Daily Submission ",
          share: "Share",
          empty_notifications: "There are no notifications yet",
          greeno_tutorial: {
            hello_message: "Hello",
            points_left: "You can write Smoothy code here",
            point1: "You can press settings button to show home...",
            point2: "You can press buttons inside settings to ....",
            point3:
              "You can access the images library by pressing the images book button",
            point4: "You can access sounds",
            point5: "Press the video button to watch the lesson video again",
            point6: "Whenever you need help, you can press help me button",
            point7:
              "You can share your project with your friends on social media",
            point8: "You can make your code output display in full screen",
            congrats: "🎉 Congrats! you can move on to the next episode 🎉",
            mistake: "It is Ok to make mistakes, and it's great to fix them",
          },
          mobile_text:
            "Writing code is a one-of-a-kind experience where you can use all your 10 fingers to type!",
          mobile_backe_drop:
            "For a little programmer like yourself, you have to switch to a PC or a laptop to live the utmost experience of SmoothY’s programming language.",
          mobile_btton: "Yes, I understand",
          code: "Your Code",
          output: "Output",
        },
        student_reg: {
          child_progress: "Child progress",
          tab_header: "Become an innovator!",
          tab_title: "Student",
          title: "Student Information",
          skill: "Skills",
          classroom_info: "Classroom Information",
          course_info: "Course Information",
          username_label: "Child Username",
          password_label: "Child Password",

          parent_email: "Parent Email",
          email: "Student Email",
          birth_year_label: "Year of birth",
          submit_btn: "submit",
          join_btn: "Join now",
          challenges: "Course Projects",
          lessons: "Playground Projects",
          student_rate: "Students Rates",
          Projects: "Projects",
          overview: "Student Information",
        },
        student_header: {
          playWithUs: "Play With Us",
          my_world: "My World",
          notifications: "notifications",
          playground: "Playground",
          smoothy_ide: "Smoothy IDE",
          web_development: "Web IDE",
          python_development: "Python IDE",
          contact_us: "Contact Us",
          logout: "logout",
          soon: "Soon...",
        },
        parent_reg: {
          tab_header: "Unleash their creativity",
          tab_title: "Parent",
          title: "Parent Information",
          username_label: "Username",
          password_label: "Password",
          update: "UPDATE",
          confirm_password_label: "Confirm Password",
          email: "Email Address",
          first_name_label: "First Name",
          last_name_label: "Last Name",
          phone_number_label: "Phone Number",
          sign_up_btn: "Register",
          join_btn: "Join now",
          login: "Login To Your Child’s Account",
          title1:
            "Are you sure you want to login to your child’s account? This will sign you out of the parent’s account.",
          continue: "Continue",
          have_account: "Don't have HelloCode account?  ",
          skip_ide: "Want to skip IDE?",
          account: "Already have HelloCode account?  ",
          join: " Log in.",
        },
        school_reg: {
          tab_header: "Unleash their creativity",
          tab_title: "School",
          form1: {
            title: "School Information",
            school_name_label: "School Name",
            abbreviation_label: "Abbreviation",
            website_label: "Website",
            email: "Email Address",
            city_label: "City",
            country_label: "Country",
            full_address_label: "Full Address",
            phone_number_label: "Phone Number",
            language_label: "Preferred Language",
            language_option1: "English",
            language_option2: "Arabic",
            next_btn: "Next",
            join_btn: "Join now",
            skip_btn: "Go to questions",
            next: "Next ",
            prev: "My World",
            school_title: "School registration",
            school_para:
              "Please ensure that all required information is on the school sheet",
          },
          form2: {
            title: "School Admin Information",
            username_label: "Username",
            password_label: "Password",
            confirm_password_label: "Confirm Password",
            email: "Email Address",
            first_name_label: "First Name",
            last_name_label: "Last Name",
            phone_number_label: "Phone Number",
            back_btn: "Back",
            submit_request_btn: "Submit Request",
            join_btn: "Join now",
            school_title: "School registration",
            school_para:
              "Please ensure that all required information is on the school sheet",
          },
        },
        loginPage: {
          parent_username: "Parent Username",
          parent_password: "Parent Password",
          title: "Become an innovator!",
          username: "Username",
          password: "Password",
          forget_password: "Forgot Your Password?",
          remember: "Remember Me",
          login_btn: "Login",
          login_as_parent: "Login As Parent",
          welcomeBack: "Welcome ",
          userInput: "User Name, or Email",
          passwordInput: "Password",
          forgetPassword: "Forget password ?",
          noAccountYet: "Don't have an account yet? ",
          notMemberYet: "Not yet a member?",
          signIn: "Login",
          register: "Register",
          empty: "Empty",
          keepMe: "keep me signed in",
          letGet: "Let’s get coding",
          home: "Home",
          placeholderPassword: "Enter your password",
          placeholderUsername: "Enter your username",
          placeholderEmail: "Enter your email address or username",
          userName: "Username",
          emailInstead: "Use Email Address or Username Instead",
          email: "Email Address",
          mobileInstead: "Use Mobile Number Instead",
          mobile: "Mobile Number",
          usernameInstead: "Use Username Instead",
          continue_with: "Or Continue With",
          free_re: "Register for free",
          master: "To the HelloMaster Sign-in page!",
          exam:
            "Use your kid’s username and password to sign in and register for the HelloMaster exams",
        },
        recover_page: {
          title: "Password Recovery",
          recoverTitle: "Recover password",
          signIn: "Login",
          home: "Home",
          dontWorry: "Don’t worry, we will make it quick",
          accessInfo: "Your Access Info",
          back: "Back",
          userInput: "User Name, Email, or Phone Number",
          empty: "Empty",
          recoverNow: "Recover Now",
          ifKid: "If you are a kid, please ",
          contactParent: "Contact Parent",
        },
        create_new_password_page: {
          titleBoard: "Create new password",
          subTitle:
            "Add a password you will remember. It will be our little secret.",
          passwordInput: "Password",
          repeatPassword: "Repeat Password",
          notMatch: "Password does not match",
          completeBtn: "Complete",
        },
        email_sent_page: {
          titleBoard: "Email Sent",
          subTitle:
            "We have sent a recovery link to your email, please confirm so we can proceed with your password recovery.",
          notGettingLink:
            "Not getting any link? Please check your spam folder.",
          nothingYet: "Nothing yet?",
          contactSupport: "Contact Support",
          or: "OR",
          changeEmail: "Change Email",
        },
        code_sent_page: {
          titleBoard: "We want to verify your identity.",
          subTitle:
            "We have sent a code to your mobile number, please confirm so we can proceed with your password recovery.",
          notGetting: "Not getting any code?",
          checkSpam: "Please check your spam Messages.",
          changeNumber: "Change Number",
          otp: "OTP Confirmation",
        },
        recovery_completed_page: {
          titleBoard: "Password recovery is now completed.",
          subTitle: "You can now log in using your new password.",
          letIn: "Let Me In",
        },
        main_navbar: {
          btnSchool: "Go School",
          contact_us: "Contact Us",
          pricing: "Pricing",
          about_us: "Home",
          why_hellocode: "Why HelloCode?",
          help_center: "Help Center",
          Curriculum: "Our Curriculum",
          courses: "Courses",
          support: "Support",
          forSchools: "For Schools",
          forSchoolsSmall: "For Schools",
          forIndividuals: "For Individuals",
          arabic: "Arabic",
          Certification: "Certificates",
          social: "Social",
        },
        join_modal: {
          student: {
            title: "Student",
            text: "Learn to create with code, and build cool projects!",
          },

          parent: {
            title: "Parent",
            text:
              "Create accounts for your kids, and watch them creating great things with code!",
          },
          school_reg: {
            tab_header: "Unleash their creativity",
            tab_title: "School",
            form1: {
              title: "School Information",
              school_name_label: "School Name",
              abbreviation_label: "Abbreviation",
              website_label: "Website",
              email: "Email Address",
              city_label: "City",
              country_label: "Country",
              full_address_label: "Full Address",
              phone_number_label: "Phone Number",
              language_label: "Preferred Language",
              language_option1: "English",
              language_option2: "Arabic",
              next_btn: "Next",
              join_btn: "Join now",
              skip_btn: "Go to questions",
            },
            form2: {
              title: "School Admin Information",
              username_label: "Username",
              password_label: "Password",
              confirm_password_label: "Confirm Password",
              email: "Email Address",
              first_name_label: "First Name",
              last_name_label: "Last Name",
              phone_number_label: "Phone Number",
              back_btn: "Back",
              submit_request_btn: "Submit Request",
              join_btn: "Join now",
              new: "New Name",
              edit: "edit your name",
              alert: "please add a valid name",
            },
          },
          recover_page: {
            title: "Password Recovery",
            recoverTitle: "Recover password",
            signIn: "Login",
            home: "Home",
            dontWorry: "Don’t worry, we will make it quick",
            accessInfo: "Your Access Info",
            back: "Back",
            userInput: "User Name, Email, or Phone Number",
            empty: "Empty",
            recoverNow: "Recover Now",
            ifKid: "If you are a kid, please ",
            contactParent: "Contact Parent",
          },
          create_new_password_page: {
            titleBoard: "Create new password",
            subTitle:
              "Add a password you will remember, yeah, that one you use the most.",
            passwordInput: "Password",
            repeatPassword: "Repeat Password",
            notMatch: "Password Does not match",
            completeBtn: "Complete",
          },
          email_sent_page: {
            titleBoard: "Email Sent",
            subTitle:
              "We have sent a recovery link to your email, please confirm so we can proceed with your password recovery.",
            notGettingLink:
              "Not getting any link? Please check your spam folder.",
            nothingYet: "Nothing yet?",
            contactSupport: "Contact Support",
            or: "OR",
            changeEmail: "Change Email",
          },
          code_sent_page: {
            titleBoard: "We want to verify your identity.",
            subTitle:
              "We have sent a code to your mobile number, please confirm so we can proceed with your password recovery.",
            notGetting: "Not getting any code?",
            checkSpam: "Please check your spam Messages.",
            changeNumber: "Change Number",
            otp: "OTP Confirmation",
          },
          recovery_completed_page: {
            titleBoard: "Password recovery is now completed.",
            subTitle: "You can now log in using your new password.",
            letIn: "Let Me In",
          },
          main_navbar: {
            contact_us: "Contact Us",
            pricing: "Pricing",
            about_us: "Home",
            why_hellocode: "Why HelloCode?",
            help_center: "Help Center",
            Curriculum: "Our Curriculum",
            courses: "Courses",
            support: "Support",
            forSchools: "For Schools",
            forSchoolsSmall: "For Schools",
            forIndividuals: "For Individuals",
            arabic: "Arabic",
          },
          join_modal: {
            student: {
              title: "Student",
              text: "Learn to create with code, and build cool projects!",
            },
            parent: {
              title: "Parent",
              text:
                "Create accounts for your kids, and watch them creating great things with code!",
            },
            school: {
              title: "School",
              text:
                "Create accounts for your schools, and manage school clubs!",
            },
            create_account: "Create an Account!",
            have_account: "Already have an account",
          },
          leaderboard_modal: {
            rank: "# Rank",
            message: "No student in top 10",
            name: "Student Name",
            weekly_points: "Weekly Points",
            leaderboard_rank: "Top Ten",
            leaderboard: "Leaderboard",
          },
          homepage: {
            homepage_start_btn: "Start learning ",
            how_it_works_button: "See how it works!",
            top_title: "Inspiring innovation through learning coding. ",
            top_landing_title:
              "The best time to teach your kids how to program using smoothy language",
            landing_subscribe: "SUBSCRIBE  NOW",
            free_trial_start: "Free 30-Day Trial",
            testimonial_text:
              "My 8 year old son really enjoyed learning coding through Hello world.The lovely characters makes it super fun! The big plus is that the more they practice and get coding right the more points they get, it’s like playing a game.",
            testimonial_text_haya:
              "I love redo and greeno, because they will help me make my own App. My App will help poor people. Maybe I will make  another App to fix mobiles and iPads, because my iPad screen stops working sometimes",
            testimonial_name: "Dina Abdul Majeed",
            testimonial_name_haya: "Haya Qaraeen",
            testimonial_details: "Founder & CEO at 360Moms",
            join_button: "Register",
            signin_button: "Login",
            menuBtn: "Menu",
            btn_competition: "Register now and we will contact you",
            text1_competition:
              "Hello World Kids Competition for Young Programmers 2020",
            text2_competition: "The largest programming competition in Jordan",
            age_competition: "Ages 7-12 years",
            start_code: "New Year Sale - 20% OFF Lifetime Subscription",
            start: "Start",
            title: "Coding made fun for kids",
            coursal_title: "HelloCode ...... Coding",
            sub_title:
              "Fun way to learn programming, develop problem solving & critical thinking skills! Ages between 7 - 15 years old",
            button_title: "Get started for free",
            testimonials: "What our users say about us",
            title1:
              "HelloCode has been a life saver. My kids are learning something useful while also keeping to themselves, which has helped a lot during lockdown. We began the lessons together, but now they are able to work at them independently and they are really enjoying themselves.",
            title2:
              "I was attracted to HelloCode with the animations, but I never believed my kids would be able to learn to create their own in such a short space of time. I am really pleased to see their progress, and HelloCode has made it so easy. I would recommend it to all parents.",
            title3:
              "My son and I have a gaming night twice per week, but now we’ve squeezed in a third because HelloCode is educational. He’s learning all sorts of things I wish I had growing up and it’s great to see him enjoying himself.",
            title15:
              "Most online games claim to be educational but this is usually just an excuse. Not with HelloCode. My kids are always showing me the new things that they have built in the coding. They are really engaged and seem to be having a lot of fun.",
            title16:
              "This is a really great educational game. You get the first lessons free and can learn a lot right from the beginning. My kids love it and say it’s much better than homework.",
            title17:
              "HelloCode is a fantastic platform and an excellent way to involve us parents with our children’s education. Either they come home from school, or are already learning from home, and have a structured way to learn without putting too much pressure on us parents. We can learn with them and support them, or we can let them learn by themselves.",
            title18:
              "I am really enjoying learning coding alongside my daughter on the HelloCode platform. It provides a fun and interesting layout, with opportunities to build stories and more. She is learning to concentrate and think creatively, which has been really helpful during home schooling.",
            title19:
              "Coding is a skill which I believe will be a very valuable asset in the future, so I jumped at the chance to have my children learn from home. The platform offers an engaging and enjoyable experience to the kids, all the while giving us parents the option to monitor their progress and exposure. Thumbs up from me.",
            title20:
              "My Grandchildren have spent a lot of time with me during the quarantine and so I got them a subscription to HelloCode. They seem to really enjoy it, and it can be difficult to get them to come off the computer for their dinner sometimes. The local school endorses it and they are learning an important skill for the future, so I am very happy with it.",
            title21:
              "I have found the HelloCode program to be a really valuable learning tool and something that my kids enjoy. They can now spend their computer time in a responsible way.",
            title22:
              "As a junior school teacher, I use HelloCode as part of my weekly classes. The kids really love it and engage well with the characters. They show impressive progress and the platform allows me to assist any student falling behind. I recommend it to all my colleagues.",
            title23:
              "Very happy with my child's participation in the Hello Code platform, he is investing his time in learning programming science, which I am very aware of its importance He is replacing his electronic games with the Hello Code platform. Very happy with his participation, and we will always keep you updated",
            name: "Samar Yossif",
            name1: "Basmah salah",
            name2: "Ashraf soliman",
            name3: "Farah majed",
            name4: "Sousen rabiah",
            name5: "Shreen fadel",
            name6: "Daliah oun",
            name7: "Badar yaseen",
            name8: "Sabah mohammed",
            name9: "Kamal qasem",
            name10: "Waseeem fawaz",
            name11: "Mariam talal",
            title4:
              "Nine out of ten doctors recommend HelloCode over competing brands. Come inside, see for yourself, and massively level up your development skills in the process.",
            title5:
              "Learning to code is useful no matter what your career ambitions are.",
            title6:
              "Hi, we are always open for cooperation and suggestions,Receive product news and updates in your inbox.",
            title7: "Newsletter",
            title8: "Give us a call",
            title9: "Useful Links",
            title10: "Get Started",
            title11: "Newsletter",
            find_us: "Find us",
            email_us: "Mail us",
            title12: "Chat",
            title13: "Follow us",
            title14: "Latest News",
            title15:
              "we received your email thank you, this is a great way to stay in touch with the latest from HelloCode, including updates on our products, courses, links to cool projects by kids, and general information on introducing children to programming.",
            title18: "Skip to Questions",
            title_footer:
              "Subscribe to Our Newsletter to Get Latest Updates & Services",
            preview: "preview",
            grade_1: "Grade One",
            grade_2: "Grade Two",
            grade_3: "Grade Three",
            grade_4: "Grade Four",
            grade_5: "Grade Five",
            grade_6: "Grade Six",
            grade_7: "Grade Seven",
            curriculum_button: "Get your kids started",
            title_affiliate: "Affiliate Program",
            cards: {
              learn_card_title: "Learn",
              learn_card_body:
                "HelloCode teaches kids to code through our unique programming language: SmoothY! Our interactive experience is fun, allowing them to explore coding while expressing their love for learning like never before.",
              learning:
                "Learning coding has never been more fun and engaging for kids! HelloCode teaches this important skill through our unique platform and programming language: SmoothY! They will develop their creativity, logic, problem-solving and critical thinking skills, while playing at the same time.",
              express_card_title: "Express",
              express_card_body:
                "HelloCode offers kids the knowledge they need to build a world of their own. They will be able to build applications, games, or simply create attractive scenes that tell their own story.",
              innovate_card_title: "Innovate",
              innovate_card_body:
                "Now that the kids have the tools, it is the time to use them! HelloCode inspires their creativity to translate their ideas into a living reality. Help your kids to become developers of the future and set their imagination free!",
            },
            slider: {
              title1: "What is HelloCode?",
              slide1:
                "HelloCode is an interactive platform that teaches kids coding using a storytelling approach, based on daily life. It features unique characters, a special digital learning environment and a step-by-step tutorial which builds on previously learned skills. Most importantly, it is really fun!",
              title2: "Parents",
              slide2:
                "HelloCode teaches your kids coding in a fun, simple and enjoyable way. As a parent, you can access your child’s dashboard, watch as they progress and, of course, have complete control of their account.",
              title3: "Schools",
              slide3:
                "HelloCode is also available for schools, offering extra features that make group learning easy. Teachers can create virtual classrooms, follow up on student progress and make sure no one is left behind on any level.",
            },
            smoothy: {
              title: "SmoothY Language",
              text1:
                "SmoothY is a fun, unique programming language developed by Hello World Kids especially for our little ones.",
              text2:
                "Kids can use SmoothY to develop applications, games, or simply build attractive scenes and create stories in a world of their own.",
              text3:
                "SmoothY simplifies programming idioms and conventions for kids through a fun and easy-to-grasp medium, while maintaining the same logic and semantics of the most widely-used programming languages. Competence with SmoothY is the first step to becoming a professional programmer!",
            },
            inspiring: {
              text1: "Inspiring innovation",
              text2: "through learning coding.",
            },
            pricing: "Check Our Pricing Plans!",
          },
          whyhellocode: {
            slide1: {
              title: "Kids Safe",
              text:
                "Hello Code cares about kids' safety. While designing the platform, safety was always a priority. And we guarantee this through: A Design intended to be used by children, families, and schools.",
              point1: "Parental control over child's account.",
              point2:
                "Age-appropriate content, data integrity and security procedures.",
              point3: "Minimum data required from the kids.",
            },
            slide2: {
              title: "Engagement guaranteed  ",
              text:
                "Hello Code is an interactive platform, which provides a fun learning experience with real-life situations, to trigger the curiosity of your little kids through a lovable simple story-telling approach, which enriches the educational experience for kids, and extends their level of motivation.",
            },
            slide3: {
              title: "Academic-curriculum Based",
              text:
                "Hello Code is fully based on our own Hello World Kids' curriculum, which is a well-designed, structured curriculum that introduces the science of programming and the software industry in addition to Artificial Intelligence.",
            },
            slide4: {
              title: "Game Based Learning",
              text:
                "Hello Code has a fantasy element that engages kids in a learning activity through a storyline. Kids go through the game experience; unlocking levels, solving projects, earning stars and getting awards. At the same time, they are being involved in a complete educational experience.",
            },
          },
          school: {
            title: "School",
            text: "Create accounts for your schools, and manage school clubs!",
          },
          create_account: "Create an Account!",
          have_account: "Already have an account",
        },
        leaderboard_modal: {
          rank: "# Rank",
          message: "No student in top 10",
          name: "Student Name",
          weekly_points: "Weekly Points",
          leaderboard_rank: "Top Ten",
          leaderboard: "Leaderboard",
        },
        homepage: {
          homepage_start_btn: "Start learning ",
          how_it_works_button: "See how it works!",
          top_title: "Inspiring innovation through learning coding. ",
          top_landing_title:
            "The best time to teach your kids how to program using smoothy language",
          landing_subscribe: "SUBSCRIBE  NOW",
          free_trial_start: "Free 30-Day Trial",
          testimonial_text:
            "My 8 year old son really enjoyed learning coding through Hello world.The lovely characters makes it super fun! The big plus is that the more they practice and get coding right the more points they get, it’s like playing a game.",
          testimonial_text_haya:
            "I love redo and greeno, because they will help me make my own App. My App will help poor people. Maybe I will make  another App to fix mobiles and iPads, because my iPad screen stops working sometimes",
          testimonial_name: "Dina Abdul Majeed",
          testimonial_name_haya: "Haya Qaraeen",
          testimonial_details: "Founder & CEO at 360Moms",
          join_button: "Register",
          signin_button: "Login",
          menuBtn: "Menu",
          btn_competition: "Register now and we will contact you",
          text1_competition:
            "Hello World Kids Competition for Young Programmers 2020",
          text2_competition: "The largest programming competition in Jordan",
          age_competition: "Ages 7-12 years",
          start_code: "New Year Sale - 20% OFF Lifetime Subscription",
          start: "Start",
          title: "Coding made fun for kids",
          coursal_title: "HelloCode ...... Coding",
          sub_title:
            "Fun way to learn programming, develop problem solving & critical thinking skills! Ages between 7 - 15 years old",
          button_title: "Get started for free",
          testimonials: "What our users say about us",
          title1:
            "HelloCode has been a life saver. My kids are learning something useful while also keeping to themselves, which has helped a lot during lockdown. We began the lessons together, but now they are able to work at them independently and they are really enjoying themselves.",
          title2:
            "I was attracted to HelloCode with the animations, but I never believed my kids would be able to learn to create their own in such a short space of time. I am really pleased to see their progress, and HelloCode has made it so easy. I would recommend it to all parents.",
          title3:
            "My son and I have a gaming night twice per week, but now we’ve squeezed in a third because HelloCode is educational. He’s learning all sorts of things I wish I had growing up and it’s great to see him enjoying himself.",
          title15:
            "Most online games claim to be educational but this is usually just an excuse. Not with HelloCode. My kids are always showing me the new things that they have built in the coding. They are really engaged and seem to be having a lot of fun.",
          title16:
            "This is a really great educational game. You get the first lessons free and can learn a lot right from the beginning. My kids love it and say it’s much better than homework.",
          title17:
            "HelloCode is a fantastic platform and an excellent way to involve us parents with our children’s education. Either they come home from school, or are already learning from home, and have a structured way to learn without putting too much pressure on us parents. We can learn with them and support them, or we can let them learn by themselves.",
          title18:
            "I am really enjoying learning coding alongside my daughter on the HelloCode platform. It provides a fun and interesting layout, with opportunities to build stories and more. She is learning to concentrate and think creatively, which has been really helpful during home schooling.",
          title19:
            "Coding is a skill which I believe will be a very valuable asset in the future, so I jumped at the chance to have my children learn from home. The platform offers an engaging and enjoyable experience to the kids, all the while giving us parents the option to monitor their progress and exposure. Thumbs up from me.",
          title20:
            "My Grandchildren have spent a lot of time with me during the quarantine and so I got them a subscription to HelloCode. They seem to really enjoy it, and it can be difficult to get them to come off the computer for their dinner sometimes. The local school endorses it and they are learning an important skill for the future, so I am very happy with it.",
          title21:
            "I have found the HelloCode program to be a really valuable learning tool and something that my kids enjoy. They can now spend their computer time in a responsible way.",
          title22:
            "As a junior school teacher, I use HelloCode as part of my weekly classes. The kids really love it and engage well with the characters. They show impressive progress and the platform allows me to assist any student falling behind. I recommend it to all my colleagues.",
          title23:
            "Very happy with my child's participation in the Hello Code platform, he is investing his time in learning programming science, which I am very aware of its importance He is replacing his electronic games with the Hello Code platform. Very happy with his participation, and we will always keep you updated",
          name: "Samar Yossif",
          name1: "Basmah salah",
          name2: "Ashraf soliman",
          name3: "Farah majed",
          name4: "Sousen rabiah",
          name5: "Shreen fadel",
          name6: "Daliah oun",
          name7: "Badar yaseen",
          name8: "Sabah mohammed",
          name9: "Kamal qasem",
          name10: "Waseeem fawaz",
          name11: "Mariam talal",
          title4:
            "Nine out of ten doctors recommend HelloCode over competing brands. Come inside, see for yourself, and massively level up your development skills in the process.",
          title5:
            "Learning to code is useful no matter what your career ambitions are.",
          title6:
            "Hi, we are always open for cooperation and suggestions,Receive product news and updates in your inbox.",
          title7: "Newsletter",
          title8: "Give us a call",
          title9: "Useful Links",
          title10: "Get Started",
          title11: "Newsletter",
          find_us: "Find us",
          email_us: "Mail us",
          title12: "Chat",
          title13: "Follow us",
          title14: "Latest News",
          title15:
            "we received your email thank you, this is a great way to stay in touch with the latest from HelloCode, including updates on our products, courses, links to cool projects by kids, and general information on introducing children to programming.",
          title18: "Skip to Questions",
          title_footer:
            "Subscribe to Our Newsletter to Get Latest Updates & Services",
          preview: "preview",
          grade_1: "Grade One",
          grade_2: "Grade Two",
          grade_3: "Grade Three",
          grade_4: "Grade Four",
          grade_5: "Grade Five",
          grade_6: "Grade Six",
          grade_7: "Grade Seven",
          curriculum_button: "Get your kids started",
          title_affiliate: "Affiliate Program",
          cards: {
            learn_card_title: "Learn",
            learn_card_body:
              "HelloCode teaches kids to code through our unique programming language: SmoothY! Our interactive experience is fun, allowing them to explore coding while expressing their love for learning like never before.",
            learning:
              "Learning coding has never been more fun and engaging for kids! HelloCode teaches this important skill through our unique platform and programming language: SmoothY! They will develop their creativity, logic, problem-solving and critical thinking skills, while playing at the same time.",
            express_card_title: "Express",
            express_card_body:
              "HelloCode offers kids the knowledge they need to build a world of their own. They will be able to build applications, games, or simply create attractive scenes that tell their own story.",
            innovate_card_title: "Innovate",
            innovate_card_body:
              "Now that the kids have the tools, it is the time to use them! HelloCode inspires their creativity to translate their ideas into a living reality. Help your kids to become developers of the future and set their imagination free!",
          },
          slider: {
            title1: "What is HelloCode?",
            slide1:
              "HelloCode is an interactive platform that teaches kids coding using a storytelling approach, based on daily life. It features unique characters, a special digital learning environment and a step-by-step tutorial which builds on previously learned skills. Most importantly, it is really fun!",
            title2: "Parents",
            slide2:
              "HelloCode teaches your kids coding in a fun, simple and enjoyable way. As a parent, you can access your child’s dashboard, watch as they progress and, of course, have complete control of their account.",
            title3: "Schools",
            slide3:
              "HelloCode is also available for schools, offering extra features that make group learning easy. Teachers can create virtual classrooms, follow up on student progress and make sure no one is left behind on any level.",
          },
          smoothy: {
            title: "SmoothY Language",
            text1:
              "SmoothY is a fun, unique programming language developed by Hello World Kids especially for our little ones.",
            text2:
              "Kids can use SmoothY to develop applications, games, or simply build attractive scenes and create stories in a world of their own.",
            text3:
              "SmoothY simplifies programming idioms and conventions for kids through a fun and easy-to-grasp medium, while maintaining the same logic and semantics of the most widely-used programming languages. Competence with SmoothY is the first step to becoming a professional programmer!",
          },
          inspiring: {
            text1: "Inspiring innovation",
            text2: "through learning coding.",
          },
          pricing: "Check Our Pricing Plans!",
        },
        whyhellocode: {
          slide1: {
            title: "Kids Safe",
            text:
              "Hello Code cares about kids' safety. While designing the platform, safety was always a priority. And we guarantee this through: A Design intended to be used by children, families, and schools.",
            point1: "Parental control over child's account.",
            point2:
              "Age-appropriate content, data integrity and security procedures.",
            point3: "Minimum data required from the kids.",
          },
          slide2: {
            title: "Engagement guaranteed  ",
            text:
              "Hello Code is an interactive platform, which provides a fun learning experience with real-life situations, to trigger the curiosity of your little kids through a lovable simple story-telling approach, which enriches the educational experience for kids, and extends their level of motivation.",
          },
          slide3: {
            title: "Academic-curriculum Based",
            text:
              "Hello Code is fully based on our own Hello World Kids' curriculum, which is a well-designed, structured curriculum that introduces the science of programming and the software industry in addition to Artificial Intelligence.",
          },
          slide4: {
            title: "Game Based Learning",
            text:
              "Hello Code has a fantasy element that engages kids in a learning activity through a storyline. Kids go through the game experience; unlocking levels, solving projects, earning stars and getting awards. At the same time, they are being involved in a complete educational experience.",
          },
        },
        pricing: {
          title: "Our Subscription Packages",
          partner_title: "Our Partners",
          subheader:
            "Different Subscription Plans with Trail Period for three days.",
          buy_btn: "SUBSCRIBE NOW",
          free: "Free 30-Day Trial",
          basic: "BASIC",
          pre: "PREMIUM",
          opt: "OPTIMUM",
          best: "BEST VALUE",
          now: "SUBSCRIBE NOW AND GET 50% OFF",
          just_now: "Now",
        },
        offer: {
          title: "SPECIAL OFFER",
          text:
            "Subscribe now and get a 30% discount on all subscription packages ",
          time: "Use the coupon code :",
          mobile:
            "Note: For a unique learning experience on how to code, you should switch to a PC or a laptop. Enjoy programming with SmoothY right away!",
          discount:
            "NOTE:By leaving the page, your discount coupon will be lost.",
        },
        assessment: {
          answer: "Question answer",
        },
        connect: {
          contact_us: "Contact Us",
          form: {
            name: "Name",
            email: "Email",
            reason: "Reason",
            message: "Message",
            local_address: "Office Address : ",
            select_reason: "Please select a reason",
            option1: "New ideas to share with us",
            option2: "Report an issue/bug",
            option3: "Partnership",
            option4: "You are a teacher or a school",
            option5: "Request a new course",
            option6: "Other",
            min_chars: "Minimum Characters is",
            provide_valid_email: "Please enter a valid email address",
          },
          send_button: "Send",
          address_title: "Office Address ",
          po_box_title: "P.O. Box:",
          landline_number_title: "Contact Number ",
          address:
            "Makkah Al-Mukarramah Street Building No. 33 Floor – 5, Amman , Jordan",
          po_box: "230196",
          landline_number: "+962 790488840",
          whatsapp: "Number ",
          whatsapp_number: " +962 790488840",
        },
        teacher_classrooms: {
          general_report: "Download Report For All School",
          students: "Number of Students",
          teachers: "Number of Teachers",
          title: "Classrooms",
          students: "Number of Students",
          top_stu: "Top Weekly Five Students",
          total: "Total point",
          over_point: "Top Titans Leaderboard",
          leader: "leader board",
          stu_dets: "Student Details",
          stu_msg:
            "All students along with their teachers are listed down here",
          message:
            "Please select a course from the list to see your progress and assessment.",
          label_add: "Add Classroom ",
          classroom: "Classroom",
          reports: "Reports",
          main_reports: "General and Classrooms Reports.",
          report_down: "Download",
          down_reports: "Download General Report",
          det_reports: "Download Deatails Report",
          class_reports: "Classrooms Reports",
          general_reports: "Download School Report",
          student_name: "Student Name",
          teache_name: "Teacher name",
          points_student: "Points",
          message:
            "Make sure that the start or end date is not greater than today, the start date is less than the end date",
          To: "To",
          From: "From",
          desc:
            "Manage your classrooms. Adding a class room with number of students, grade and HelloCode courses!",
          select_teacher: "Select Teacher",
          teacher_name: "Teacher Name ",
          viewreport: "View Report",
          header: {
            tab_title1: "Classrooms",

            tab_title2: "Progress Assessment",
            tab_title3: "Code Assessment",
            tab_title4: "Code Editor",
            tab_title6: "Playground",
            tab_title5: "Let's play a game",
            search: "Search by class name",
          },
          card: {
            grade: "Grade",
            Students: "Students",
            current_course: "Current Lesson",
            completions: "Completion",
            green_btn: "View Details",
            gray_btn: "Archive",
          },
          add_classrooms_btn: "Add a Classroom.",
          lesson_stones: " lesson stones,",
          challenge_stones: " challenge stones,",
          projectsـsubmissions: " projects'submissions,",
          add_classroom_modal: {
            modal_title: "Add a Classroom!",
            name: "Name",
            classroom_title: "Classroom Title",
            grade: "Grade",
            number_of_seats: "Number of Seats",
            course: "Course",
            start: "Start",
            end: "End",
            select_message: "*select days for your classroom",
            grade_message: "Please select grade",
            course_message: "Please select course",
            course_equals: "Start time should not equal end time",
            time_greater: "End Time should be greater than Start Time",
            required: "The classroom schedules field is required",
            add_btn: "Add Classroom",
            grade_placeholder: "Select One",
            course_placeholder: "Select Option",
            days: {
              sunday: "Sunday",
              monday: "Monday",
              tuesday: "Tuesday",
              wednesday: "Wednesday",
              thursday: "Thursday",
              friday: "Friday",
              saturday: "Saturday",
            },
          },
          no_top_five:
            "Due to the absence of students at the moment, the school leaderboard doesn't show any top students.",
          no_titan_students:
            "Due to the absence of students at the moment, the school leaderboard doesn't show any top titans students.",
        },
        days: {
          sunday: "Sunday",
          monday: "Monday",
          tuesday: "Tuesday",
          wednesday: "Wednesday",
          thursday: "Thursday",
          friday: "Friday",
          saturday: "Saturday",
        },
        teacher_ide: {
          ide: "IDE",
          code: "See The Code",
          code_solution: "Code Solution",
          code_solutionـlesson: "lesson Solution",
          code_solutionـchallenge: "Challenge Solution For This Course",
          message: "There is no code solutions for this course",
          challenge_solution: "Challenges Solutions ",
          lesson_solution: "lessons Solutions ",
          lesson_question: "Lessons Questions Solutions",
          see: "See The Questions",
          no_question: "There Is no questions for this lesson",
        },
        teacher_classroom_details: {
          lesson_number: "Lesson number",
          select_all_lessons: "Select All Lessons",
          selectall: "Select All Students",
          edit: "Edit",
          save: "Save",
          logName: "Username",
          grade: "Grade",
          answer: "Question Solutions",
          total_students_assigned: "Total Students Assigned",
          curent_course: "Current Course",
          days: {
            Sunday: "Sunday",
            Monday: "Monday",
            Tuesday: "Tuesday",
            Wednesday: "Wednesday",
            Thursday: "Thursday",
            Friday: "Friday",
            Saturday: "Saturday",
          },
          assign_student_modal: {
            message: "You have reached the maximum number of student",
          },
          current_schedule: "Current Schedule",
          edit_details_btn: "Edit Details",
          edit_Schedule: "Edit Schedule",
          cancel_btn: "Cancel",
          whats_btn: "Save Changes",
          start_btn: "Start",
          end_btn: "End",
          assigned_students: "Assigned Students",
          teacher_guid: "Teacher Guide",
          lessons_videos: "Lessons Videos",
          show_video: "Show Video",
          unlock_lesson_for_students: "Unlock lessons for students",
          reset_lessons_for_student: "Reset Questions for all students",
          finish_lessons_for_student: "Finish lessons for all students",
          finish_lessons: "Finish lessons",
          no_lesson_to_reset: "There is no lessons completed",
          no_lessons_to_finish: "You should unlock lessons before finish them",
          reset_questions: "Reset questions",
          no_challenges_to_reset: "There are no completed Challenges",
          no_projects_to_reset: "There are no completed projects",
          reset_challenges_for_student: "Reset Challenges for students",
          reset_challenges_single_student: "Reset challenges for the student",
          no_lesson: "There are no challenges to reset",
          reset_challenges: "Reset Challenges",
          challenge_title: "Challenge title",
          unlock_lessons: "Unlock Lesson",
          lock_lessons: "Lock Lesson",
          completeLastLessonTr: "Complete Last Lesson",
          stones_number: "Stone number",
          status: "Status",
          locked: "Locked",
          unlocked: "Unlocked",
          completed: "Completed",
          lesson_title: "Lesson Title",
          login_name: "Login Name",
          current_lesson: "Current Lesson",
          generate: "Generate",
          skills_score: "Skill score",
          std_name: "Student Name",
          completions_submissions: "Completions / Submissions",
          actions: "Actions",
          add_new_student_btn: "Create New Student",
          assign_student: "Assign Students",
          remove_selected_btn: "Remove Selected",
          add_student_modal: {
            modal_title: "Add a New Student!",
            student_account_limit: "Student Accounts limit:",
            first_name: "First Name",
            last_name: "Last Name",
            year_of_birth: "Year of birth",
            select_year: "Please select year of birth",
            login_name: "Login Name",
            password: "Password",
            confirm_password: "Confirm Password",
            add_student_btn: "Add Students",
            Unassigned_Students: "Unassigned Students",
          },
          remove_student_modal: {
            message:
              "Are you sure you want to remove selected student(s) from class?",
            yes_btn: "Yes",
            cancel_btn: "Cancel",
            remove_title: "Remove Student(s)",
          },
          reset_lessons_modal: {
            message:
              "Are you sure you want to reset Questions for selected student(s) from class?",
            yes_btn: "Yes",
            cancel_btn: "Cancel",
            reset_lessons: "Reset Questions",
            reset_detales: "reset || details",
          },
          approval_student_modal: {
            applause_sent: "Applause Sent",
            approve_under_title: "Feel free to leave a comment",
            approve_point_msg: "Give the student project points (100-500)",
            leave_comment_btn: "Send Comment",
            required_msg: "This field is required",
            disapprove_title: "Review Sent!",
            message: "Select Your Comment",
            message_a: "Good job :D",
            message_b: "Great work, excellent ",
            message_c: "Perfect output, keep the good work :D ",
            message_d: "Excellent our little programmer :) ",
            message_e: "Nice output :D ",
            message_f:
              "Good job, make sure to match the challenge’s goal next time :)",
            message_dis_a:
              "Little programmer, we believe that you can solve this challenge! Keep working on your program :)",
            message_dis_b:
              "It is ok to make mistakes! Solve the errors in your program, then complete it :)",
            message_dis_c:
              "Excellent programmer, you are almost there! keep working on your program :D",
            message_dis_d:
              "We believe that you can do it! Check the challenge’s goal, think and try again :D",
          },
        },
        tabs: {
          lessons: "Completed Lessons ",
          challenges: "Challenges Projects",
          no_completion_courses:
            "Please complete a course to get your certificate.",
          get_certification: "Get Certificate",
          view_certification: "View Certification",
          projects: "Playground Projects",
          comment: "Comment",
          see_comments: "See all comments",
          comments_date: "Comment date",
          project_name: "Project Name ",
          project_comment: "Project Comment",
          share: "Share",
          ProjectـStatus: "Project Status",
          Selected_Status: "Selected Status",
          see_more: "see more",
          no_comment: " No comments ",
        },
        lesson_assessment: {
          Assesments: "Progress Assessments",
          not_selected: "Select a Course and Lesson to display data",
          choose_a_lesson: " Choose a lesson",
          lessonss: "lessons",
          another_lesson: "Choose another lesson",
          title: "Progress Assessment",
          challenges: " Challenges",
          lessons: "Lessons ▼",
          select_classroom: "Select Classroom",
          select_lesson: "Select lesson",
          data_table: {
            less_dets: "Lesson Details",
            school_name: "School Name",
            last_login: "Last Login",
            active: "Active",
            activity_level: "Activity Level",
            profile: "Profile",
            username_col: "Username",
            classroom_name_col: "Classroom Name",
            teacher_name_col: "Teacher Name",
            course_name_col: "Course Name",
            number_students_classroom: "Number of Students in Classroom",
            grade_name_col: "Grade Name",
            lesson_title_col: "Lesson Title",
            assessment_result_col: "Assessment Result",
            student_profile: "Student Profile",
            child_info: "Child information",
            child_progress: "Child progress",
            certificate: "Certificate",
            achievements: "Achievements",
            selected_course: "Select Course",
            search: "Search",
            show_label: "show",
            entries_label: "entries",
            entries_labels: "entries",
            rows: "rows",
            entries_to: "to",
            entries_of: "of",
            entries_shown: "Showing",
            next: "Next",
            previous: "Previous",
            zero_entries: "Showing 0 entries",
            no_data: "There are no completed lessons yet",
            student_name_col: "Student Name",
            placeholder: "Username and Student Name",
            undefined: "N/A",
            resubmit: "Resubmitted At",
            no_class: "There are no completed lessons yet",
            student_achievements: "Child Achievements",
            rate: "Students Rates",
            projs: "Projects",
            overview: "Overview",
          },
        },
        "submissions-and-reviews": {
          title: "Code Submissions",
          lessons: " Lessons ",
          challenges: " Challenges ",
          projects: " Projects ",
          cod_ass: "Code Assessment",
          code_ass_message: "View and assess students' submitted code.",
          code_pro_message:
            "HelloCode tools to monitor students' progress  and performance. ",
          export_excel_btn: " Download Excel Sheet",
          data_table: {
            project_type: "Project Type",
            username_col: "Username",
            classroom_name_col: "Classroom Name",
            grade_name_col: "Grade Name",
            lesson_title_col: "Lesson Title",
            submitted_at: "Resubmit",
            created_at: "Submitted At",
            created: "Created At",
            updated_at: "Updated At",
            status_col: "Status",
            project_name_col: "Project Name",
            search: "Search",
            show_label: "show",
            entries_label: "Entries",
            entries_shown: "Got a Total Of",
            next: "Next",
            previous: "Previous",
            zero_entries: "Showing 0 entries",
            no_data: "No data available in table",
          },
        },
        school_teachers: {
          header: {
            tab_title1: "Teachers",
            tab_title2: "Classrooms",
            tab_title3: "Students",
          },
          schools_dash: "Schools",
          description_text_schoo:
            "Stay up-to-date on your schools' performance.",
          down_all_rep: "Download All Schools Report",
          search_placeholder_schools: "Search School",
          btn_down: "Download",
          overview_stu: "Student Overview Card",
          project_stu: "Student Project Card",
          general_stu: "General Student Report",
          skills_report: "Skill Report",
          title: "Teachers",
          description_text:
            "All the teachers you listed, engaged in, or created will be listed here.",
          current_cl: "Current Classrooms",
          classrooms: "Classrooms",
          current_std: "Current Student",
          desc: "Manage teachers in your school",
          student: "Students",
          view_detalis: "View Detalis",
          search_placeholder: "Search for a teacher",
          delete_teacher: "Delete Teacher Account",
          errorSearchMsg: "0 Results for this name in your teachers",
          change_psaa: "Reset Teacher Password",
          cards: {
            PDFdownload: "Download as PDF",
            reports: "Reports",
            certificate: "Certificate",
            Exceldownload: "Download as Excel",
            teacher_name: "Teacher Name",
            stu_overView: "Student overview",
            stu_projects: "Student Projects",
            stu_reports: "Student report",
            login_name: "Login Name",
            account_status: "Account Status",
            classrooms: "classrooms",
            click_here: "click here",
            see_all: "see all",
            see_course: "see all courses",
            see_statistics: "teacher statistics",
            see_info: "see all information",
            see_class: "see all classrooms",
            see_statistics_class: "classrooms statistics",
            see_info_class: "see all information",
            no_class: "No classrooms",
            courses: "Courses",
            total_students: "Total Students",
            date_created: "Date Created",
            last_login: "Last Login",
            disable_account: "Disable Account",
            reset_password: "Reset Password",
            enable_account: "Enable Account",
            total_course_projects: "Number of course projects",
            total_course_projects_pending: " Pending",
            total_course_projects_aprroved: "Approved",
            total_course_projects_disapproved: " Disapproved",
            total_playground_projects: "Number of Playground projects",
            total_playground_pending: " Pending",
            total_playground_approved: "Approved",
            total_playground_disapproved: " Disapproved",
            question_score: "Total Score",
            skill_score: "Total Score",
            total_points: "Total Points",
            weekly_points: "Weekly Points",
            courses: "Courses",
            current_course: "CURRENT COURSE",
            locked_course: "LOCKED COURSE",
            sure_locked_message: "Are you sure you want to unlock",
            sure_locked_message2: "Are you sure you want to lock",
            sure_locked_courses: "course",
            yes_lock: "yes, lock",
            yes_unlock: "yes, unlock",
            cancel: "Cancle",
            lock_classroom: "Are you sure you want to lock",
            unlock_classroom: "Are you sure you want to unlock",
            all_students: "for all students in this classroom",
            lock_course: "Lock course",
            unlock_course: "Unlock course",
            no_skills: "This student does not have any skills",
          },
          add_teachers: "+ Add Teacher",
          add_teaher_modal: {
            title: "Add New Teacher",
            teacher_account_limit: "Teacher Accounts Limit",
            student_accounts_limit: "Student Accounts Limit",
            username: "Teacher Username",
            name: "Teacher Name",
            last_name: "Last Name",
            password: "Password",
            confirm_password: "Confirm Password",
            email_address: "Teacher Email",
            email_address_b12: "Teacher B12 Email",
            phone_number: "Phone Number",
            add_teacher: "Create & Send Invite",
            cancel: "Cancel",
            min_characters: "Min characters is",
            passwords_must: "Passwords must be identical.",
            please_provide: "Please enter a valid email address",
            empty: "Empty",
          },
          reset_modal: {
            title: "Reset Password",
            new_pass: "New Password",
            enter_pass: "Enter the password",
            reset_btn: "Reset",
            reset_challenges: "Reset Challenges",
            cancel: "Cancel",
            min_characters: "Min characters is",
            placeholder: "Enter the password",
            reset_password: "Reset Password",
            check_students: "No students",
          },
          enable_disable_modal: {
            title: "Are You Sure ?",
            desc_enable: "Are you sure you want to enable teacher account",
            desc_dis: "Are you sure you want to disable teacher account",
            disable_account: "Disable Account",
            enable_account: "Enable Account",
            yes: "Yes",
            no: "No",
          },
          teacher_details: {
            title: "Classrooms",
            grade: "Grade",
            cancel: "Close",
            Classroom_name: "Classroom Name",
            current_course: "Current Course",
            move_classroom: "Move Classroom",
            zero_classrooms: "There are no classrooms for this teacher",
          },
          assign_teacher: {
            title: "assign the teacher that you want to move the classroom to",
            statment: "Teachers List",
            move_room: "Move Classroom",
            close_room: "Close",
          },
          teacher_profile_table: {
            teachers: "Teachers",
            teacher_Name: "name of the teacher",
            teacher_status: "Active",
            teacher_status_red: "Inactive",
            teacher_students: "Students",
            teacher_courses: "Courses",
            teacher_email: "Contact Email",
            teacher_dont_have_email: "Teacher dosent have email yet",
            teacher_lastlogin: "Last Login",
            teacher_classrooms: "Classrooms",
            course_information: "Course Information",
            courses_projects: "Courses Projects",
            playground_projects: "Playground Projects",
            totalpoint: "Top Five Students",
            TopfiveStu: "Top Five Students",
            total: "Total Points",
            teacher_classroomsNum: "Number Of Classrooms Projects",
            teacher_coursesNum: "Number Of Courses Projects",
            teacher_playgroundNum: "Number Of Playground Projects",
            classrooms_information: "Classroom Information",
            classroom_name: "Classroom Name",
            classroom_status: "Grade",
            teacher_classroomsStatusA: "Approved",
            teacher_classroomsStatusP: "Pending",
            teacher_classroomsStatusD: "Disapproved",
            teacher_selector: "Select Classroom",
            teacher_namecourses: "Courses Name",
            teacher_disAccount: "Disable Account",
            approved_pro: "Approved",
            Rejected_pro: "Rejected",
            no_top_five_class:
              "There's no top students in this classroom at the moment.",
            teacher_certifiacte: "Certificates",
            generate_certifiacte: "Generate",
            download: "Download",
            Close: "Close",
            preview: "Preview",
            no_certi: "You dont have any Certifcates yet",
          },
        },
        parent: {
          header: {
            tab_title1: "My Children",
            tab_title2: "Membership",
            tab_title3: "Contact Us",
            tab_title4: "Subscriptions",
            tab_title5: "You have not added children yet",
            tab_title6: "Unleash your children creativity and register now!",
            tab_title7: "Add Child's Account",
            tab_title8:
              "Here you can see your total points that you gain during your learning journey on HelloCode from the beginning. Your achievement updates each time you gain more points!Keep up the good work!",
            tab_title9:
              "Our little programmer, you can always find your daily points here, where each time you gain points it will be added here on a daily basis. But it will be reset on every Sunday of every week at 12:00 am.",
            tab_title10:
              "Because technology is so integrated into virtually every aspect of our lives, learning about it is more important than ever. For kids, our coding platform makes it convenient and fun to gain knowledge that will serve them well throughout their lives. You can count on our trusted methods to help them develop and grow their capabilities with computers.",
            tab_title11: "Who Are We?",
            refund: "100% Same-day refund",
          },
          manage_my: {
            title: "Manage My Children’s Accounts",
            desc: "Add your child to HelloCode® to enjoy code learning.",
            card: {
              login_as: "Login as a student",
              is_in_trial: "In Trial Period, 5 free lessons",
              account_status: "Account Status",
              active_course: "Active Course",
              active: "Active",
              inactive: "Inactive",
              completed_courses: "Completed Courses",
              completed_lessons: "Completed Lessons",
              no_courses: "No courses completed yet",
              no_lessons: "No lessons completed yet",
              subscription_plan: "Subscription Plan",
              subscription_expiry: " Subscription Expiry",
              disable_account: "Disable Account",
              click_here: "Click here",
              enable_account: "Enable Account",
              reset_password: "Reset Password",
              see_all: "see all",
              subscription_expired: "Subscription Expired",
              subscription_active: "Subscription is active",
            },
            reset_modal: {
              title: "Reset Password",
              new_pass: "New Password",
              enter_pass: "Enter the password",
              reset_btn: "Reset",
              cancel: "Cancel",
              min_characters: "Min characters is",
              placeholder: "Enter the password",
            },
            enable_disable_modal: {
              title: "Are You Sure ?",
              desc_enable: "Are you sure you want to enable programmer account",
              desc_dis: "Are you sure you want to disable  programmer account",
              yes: "yes",
              no: "no",
            },
            add_child: "Add Child.",
            edit_info: "Edit Information ",
            active: "Active",
            parent_profilt: "Profile",
            add_child_modal: {
              title: "Add a Child Account",
              message:
                "Your child will enjoy  for one month trial period and access to the first fifth lessons for FREE. You can purchase the full access from membership page.",
              child_name: "Child Name",
              first_name: "First Name",
              last_name: "Last Name",
              login_name: "Login Name",
              confirm_password: "Confirm Password",
              password: "Password",
              email_address: "Email Address",
              year_birth: "Year of birth",
              parent_address: "Parent Email Address",
              need_help: "Need help",
              min_characters: "Minimum number of characters is ",
              password_identical_msg: "Passwords must be identical.",
              add_kid: "Add kid",
              provide_valid_email: "Please enter a valid email address",
              select_valid_birthyear: "Please select your childs' age",
              select_age: "Select your age",
            },
            updateInfo:
              "For a better experience please fill in the below information",
            //  update_title:"Update  Information"
          },
          membership: {
            title: "Membership Details",
            desc:
              "Manage your children's accounts details and payment information.",
            table: {
              child_username: "Child Username",
              subscription_plan: "Subscription Plan",
              price: "Price",
              status: "Status",
              subscription_expiry: "Subscription Expiry",
              renew_subscription: "Upgrade",
              cancel_subscription: "Cancel Subscription",
            },
            cancel_modal: {
              title: "Cancel Subscriptions",
              desc1:
                "Your Children accounts will not be renewed automatically.",
              desc2:
                "Children will still be able to login until their current subscription expires.",
              child_account: "Programmer Account",
              subscription_plan: "Subscription Plan",
              subscription_expiry: "Subscription Expiry",
              subscription_status: "Subscription Status",
              subscription_cancel: "Cancel Subscription",
            },
          },
          renewSubscription: {
            stepone:
              "Knowledge has no boundaries! Please select how many of your kids you want to have the chance to learn about coding",
            continuesteo1: "Continue",
            subscription_renewal: "Subscription Renewal",
            desc: "Select the account you want to upgrade.",
            child_username: "Child Username",
            username: "Username",
            upgrade: "Upgrade",
            current_subscription_expiry: "Current Subscription Expires",
            new_subscription_expiry: "New subscription expiry",
            total_price: "TOTAL",
            next: "Next",
            need_help: "Need help",
            message_green:
              "Your Credit Card will be charged. Check the total price. ",
            on: "Yes",
            off: "No",
            select_child: "Upgrade programmer account",
            subscription_plan: "Subscription Plans",
            card_information: "Card Information",
            plan: "Choose Payment Method",
            full_assisted: "Assisted Learning Included",
            features: "Features",
            hello_code: "Hellocode",
            month: "month",
            future_courses: "All Future Courses Included",
            assisted: "Add Assisted Learning",
            select: "Select",
            assisted_learning:
              "A certified tutor from HelloWorldKids will check and mark your child's projects and give guidance through personal feedback.",
            saving: "Save 40%*",
            code: "Enter your Coupon Code",
            discount: "Discount",
            childNumber: "Number of Children Selected = ",
            coupon_assisted: "Assisted Learning",
            subtotal: "Subscription Fees",
            apply: "apply",
            coupon_title: "Discount Coupon ",
            new_price: "New Price",
            stock: "IN STOCK",
            payment: "MY PAYMENT OPTIONS",
            assisted_message:
              "Assisted Learning Service is not included in the discount",
            discount_message:
              "This discount coupon applies only for the subscription fees",
            kid_disc:
              "Get a family discount when you enroll multiple children.",
            course_disc: "Embrace your creativity and save up to ",
            more_disc: "on multiple courses at the Hello Code platform.",
            fifteen_percentage: "Discount",
          },
          subscription_renewal: {
            title: "Subscription Renewal",
            desc:
              "Please enter your credit card information to complete the purchase.",
            name_on_card: "Name on Card",
            credit_card_number: "Credit Card Number",
            card_cvv: "Card CVV",
            exp_Date: "Expiry year",
            exp_mounth: "Expiry month",
            by_clicking:
              "By clicking here, you acknowledge that you have read and agreed on our",
            reccomended: "Best Value",
            terms_of_service: "Terms of Service.",
            renew_btn: "Renew Subscription",
            submit: "Submit",
            back: "Back",
            please_select: "Please select one",
            min_characters: "Min characters is",
            total_price: "Total",
          },
          parent_info: {
            new_kid: "New Kid",
            link_kid: "Link Kid",
            current_lessons: "CURRENT COURSE",
            last_activity: "LAST ACTIVITY",
            expiry: "EXPIRY",
            free: "FREE",
            update: "UPDATE",
            plan: "PLAN",
            login_as: "Log In as",
            more_actions: "More Actions",
            disable: "Disable Account",
            edit_info: "Edit Info",
            update_plan: "Update Plan",
            currently_learning: "What's your kid currently learning",
            current_course: "CURRENT LESSON",
            lesson_name: "Name of the lesson",
            completed_course: "COMPLETED LESSONS",
            coursess: "Courses",
            Projects: "Projects",
            current_project: "CURRENT PROJECT",
            project_name: "Name of the Project",
            basic_info: "Basic Info",
            Badges: "Badges",
            course_badge: "COURSES BADGES",
            bigenner: "Beginner Badge",
            expert_badge: "Expert Badge",
            hwk: "HWK Badge",
            other_badges: "OTHER BADGES",
            completed_projects: "completed projects",
            parent_area: "PARENT AREA",
            hello_Parent: "Hello Parent",
            contoll_Parent:
              "You can monitor your kids performance and control their activities from this dashboard.",
            update_plan: "Update your plan Now",
            lessons: "Lessons",
            select: "select course ",
            no_project: "Let's start creating some projects",
            no_lesson: "Let's start learning how to program",
          },
        },
        assessment_result: {
          lesson_title: "Lesson title",
          number_of_questions: "Number Of Questions",
          skills_rate: "Skill Rate",
          questions_rate: "Question Rate",
          title: "Assessment Result",
          lesson: "Lesson",
          student: "Student",
          back: "Back",
          question_text: "Question Text",
          student_answer: "Student Answer",
          correct_answer: "Correct Answer",
          no_rate: "No Result",
          back_to_the_course: "To get back to the course",
          assessment_results: " To see your detailed assessment result ",
          skills: " To assess your skills again, please tell your teacher.",
          click_here: "Please Click Here",
        },
        submition: {
          approve: "Approved",
          disapprove: "Disapprove",
          student: "Student",
          submission_type: "Submission Type",
          submission_status: "Status",
        },
        competition: {
          step_1: "Step one",
          step_2: "Step two",
          step_3: "Step three",
          basic: "Basic Info",
          plan: "Competition Plans",
          payment: "Payment Methods",
          select: "Please select one",
          course: "Course",
          thank: "Perfect",
          thank_you: "You’ve just been registered!",
          thank_you_1:
            "Thank you for registering in The International Competition For HelloCode Little Programmers 2020",
          thank_you_2:
            "Your account has been activated you can start your self-learning educational journey, to learn programming using SmoothY language. The course contains 20 lessons, which includes a set of educational cartoon episodes and a set of challenges. Adding to that the child gains points during his educational journey and submits projects in the playground which will enhance his chances to reach the finals.",
          thank_you_3: "Account information has been sent to your email",
          details: "Details",
          details_1: "Having troubles? ",
          share: "Sharing",
          invite: "Invite Friends",
          email: "email : support@helloworldkids.org",
          whatsup: "whatsApp : https://wa.me/962790488840",
          direct: "Direct Line : 00962790488840",
          chat: "Chatbox : https://www.hellocode.me/ ",
          contact: "Contact Us",
          error:
            "We apologize for the inconvenience, there was an error in processing the payment!!",
          error_1:
            "Thank you for your interest in registering for The International HelloCode Competition for Little Programmers 2020",
          error_2:
            "Please try again, you may also use an alternative payment method.",
          country: "country",
          provider: "Choose The provider",
        },
        landing: {
          home_title:
            "(Welcome to The HelloCode International Competition 2020!)",
          home_title_1: "HelloCode International Competition",
          destinations_1:
            "The HelloCode international competition is for children from 7-15 years old. Using our unique programming language, SmoothY, registered kids can learn and test out their understanding of the basics of coding.",
          destinations_2:
            "The competition is comprised of a number of stages. Firstly, the registered children complete a set of learning tasks. Those that do best will join a national group of little programmers to compete for a position in the international group. There they will compete against other international winners for the grand prize!",
          containter_content:
            "One winner will receive the grand prize, and there are prizes for second and third place:",
          containter_content_1: "1st place prize: $5000",
          containter_content_2: "2nd place prize: $3000",
          containter_content_3: "3rd place price: $1000",
          containter_content_4:
            "The competition’s registration fee is $ 50, including the child's access to HelloCode account.",
          containter_content_grants_4:
            "The competition’s registration fee is $ 25, including the child's access to HelloCode account.",
          testimonials:
            "Participant’s accounts will be activated to enable them to start a self-learning journey to learn programming using SmoothY. The course contains 20 lessons, which includes a set of educational cartoon episodes and a set of challenges. Adding to that the child gains points during  his educational journey and submits projects in the playground which will enhance his chances to reach the finals.",
          container_register: "ARE YOU READY TO WIN $5000 ?",
          container_register_1: "Register Now",
          container_register_2: "Try Again",
          container_register_4: "Do you want to know more?",
          container_register_5: "Schedule a demo",
          container_register_6: "Do you want to try free lessons ?",
          container_register_7: "Free Trial",
          container_register_8: "Hurry up!",
          container_register_9:
            "Unfortunately, the registration period for the competition has ended",
          com_intruction_1: "Learning journey ends on 15/1/2021",
          com_intruction_2: "Qualifying competition will be on 20/1/2021",
          com_intruction_3:
            "The final international competition will be on 28/1/2021 ",
          com_intruction_4:
            "For any inquiries, please contact us on 00962790488840",
          competition_title: "International Competition 2020",
          hello: "Hello Code",
          text: "Register, Learn, Compete, Win",
          modal_1: "What are you waiting for!",
          modal_2: "You can win!",
          community: "The biggest community in the Arab world",
          learn: "for teaching kids programming",
          school: "From home or school",
          account: "Do you have an account on the Hellocode platform?",
          teacher: "Are you a teacher or school owner?",
          school_title: "Enter programming curricula to your school",
          curriculam: "HelloCode curricula",
          learning: "How to teach programming in school",
          price: "Get a purchase order",
          school_head: "Enter programming curricula",
          school_sub_head: "to your school",
          sample: "Lesson Example",
          grade_1:
            "Students will start their technological journey with the basic knowledge and skills required to interact with computers, they will learn these skills using online games on HelloCode platform, and also start working on the Microsoft Word program. This level will focus on developing their problem solving and thinking techniques skills through thinking games and exercises.",
          grade_2:
            "storage devices. This level also introduces the students to the Microsoft PowerPoint program, so they will create and design attractive presentations. Moreover, this level includes a group of games to improve students’ thinking and problem solving skills. ",
          grade_3:
            "In this level, students will discover what data is and how it’s processed, they will also be introduced to the internet “The global network” and all things related to it. Moreover, they will discover how to use the Microsoft Excel program for organizing and processing data. This level also provides more challenging thinking games.  ",
          grade_4:
            "At this level, students will learn programming basics using SmoothY language, they will start creating programs by adding simple geometric shapes and changing their colors, as well as moving them by mastering determination of object coordinates. They also will be able to add media to their programs using HelloCode images and sounds library.",
          grade_5:
            "Students will learn how to write flexible, large, and well-organized programs using variables and reusable pieces of code called (Functions). They will explore SmoothY’s data types, naming convention rules, and dealing with variables. Students will discover what we mean by (Events) and how to program keyboard’s and mouse’s events using SmoothY language.",
          grade_6:
            "This level will introduce students to conditional statements, arithmetic, logical operator, and arrays. They will face a set of programming challenges that requires them to employ the programming concepts they learned, and aims to enhance their thinking and analysis skills.",
          grade_7:
            "Students will learn what websites and web pages are, and how to create them using (HTML) and style them using (CSS). They will also explore how to program (HTML) components functions using (JavaScript) language. Students will be introduced to many programming concepts in (JavaScript), especially how to deal with (HTML) components via code.",
          grade_8:
            "This level will move students to a higher level in programming, where they will apply previous coding skills using a high-level programming language called (Python). In addition to that, students will learn new programming concepts, such as arrays and new types of functions to build web applications.",
          title_1: "HelloCode Level One – First Grade ",
          title_2: "HelloCode Level Two – Second Grade ",
          title_3: "HelloCode Level Three – Third Grade ",
          title_4: "HelloCode Level Four – Fourth Grade ",
          title_5: "HelloCode Level Five – Fifth Grade ",
          title_6: "HelloCode Level Six – Sixth Grade ",
          title_7: "HelloCode Level Seven – Seventh & Eighth Grade ",
          title_8: "HelloCode Level Eight – Ninth & Tenth Grade ",
          what_we_learn: "What do we offer schools?",
          teacher_learning: "Training of Trainers (TOT)",
          teacher_guid: "Teacher’s Guide",
          school_visit: "School Visits ",
          school_guid: "Technical Follow-up",
          teacher_learning_desc:
            "We will coordinate with the school administration to determine suitable dates to meet the teachers, and start training them on how to use the platform and take full advantage of its powerful features to make their job easier.",
          teacher_guid_desc:
            "Our teacher's guide contains the needed steps to implement the curriculum. The guide aims to introduce the best ways teachers can use to clearly communicate the courses to the students.",
          school_visit_desc:
            "A member of our team will schedule appointments to visit the school twice in each semester, they will attend classes to guide teachers and assist them in reaching the desired results. ",
          school_guid_desc:
            "Our technical support team will provide continuous support to schools and follow-up throughout the academic year to ensure the best results.",
          show_hellocode: "Take a Tour in HelloCode platform",
          contact:
            "For more information and to request a price quote, please contact our sales department through:",
          email: "Email: ",
          whatsApp: "WatsApp: ",
          thanks_message:
            "It will be our pleasure to meet you, and your teachers to present a demonstration of HelloCode platform and its educational curricula.",
          demo: "Request a Demo",
          event_sent_thanks: "Thank you!",
          event_sent:
            "A member of our sales team will be in contact with you to schedule a demo.",
        },
        eFAWATEERcom: {
          title:
            "Pay to HelloCode Competition from Hello World Kids easily through eFAWATEERcom",
          title_1: "Online using:",
          title_2: "Your online banking",
          title_3: "E-wallets",
          title_4: "eFAWATEERcom mobile app and website",
          title_5: "with few steps:",
          title_6: "Select biller category: Education",
          title_7: "Select biller name: Hello World Kids",
          title_8: "Select service and prepaid category: Competition 2020",
          title_13: "Enter your mobile number",
          title_9: "Or pay in cash through:",
          title_10: "All banks’ branches in the kingdom",
          title_11: "Jordan post offices",
          title_12:
            "eFAWATEERcom agents such as the exchange shops, you can check the closest agent to you by visiting our map",
        },
        hellocode_v2: {
          home_title: "The  Coding Community for Kids",
          sub_title:
            "A unique learning experience made specifically for kids to stimulate their creativity.",
          text_inner: "Expanding their thinking skills.",
          lesson: "Developing their communication skills.",
          project: "Improving their academic skills.",
          register: "Register an account, it’s FREE",
          courses: "HelloCode Courses",

          offer: "What HelloCode Offer",
          journey:
            "Start a fun educational journey through a series of lessons and projects created by a team of specialists to help kids master programming.",

          offer: "What HelloCode Offers",
          journey:
            "Start a fun educational journey through a series of lessons and projects created by a team of specialists to help kids master programming.",

          all: "All Courses ",
          basic: "Computer Skills Courses (3)",
          smoothy: "SmoothY Coding Course (6)",
          advance: "Web Development Course (1)",
          trusted: "Trusted by",
          python: "Python Coding(1)",
        },
        parent_v2: {
          subscription_plan: "HelloCode Packages",
          plan_name: "Are you curious?",
          plan_description: "This package includes:",
          plan_feautes_one: "All platform features",
          plan_feautes_two: "Enjoy three free lessons",
          plan_feautes_three: "Learn the coding basics",
          plan_feautes_four: "Create unlimited projects",
          plan_feautes_five: "Reports of your kids performance",
          current_plan: "Current Plan",
          course_plan: "Buy a Course",
          course: "Choose your level",
          plan_title: "HelloCode Courses ",
          update_plan: "Update plan",
          update: "Update your plan and get access to more courses",
          details: "Package details",
          kid_name: "Kids names:",
          update_for: "Update plan for",
          choose: "Choose your kid",
          course_one: "All platform features ",
          course_two: "Performance Monitoring ",
          course_three: "Learning Resources",
          course_four: "Programming Certificates",
          course_five: "Competing with other programmers",
          course_name: "level name",
          recomended: "You are jumping too much!",
          message:
            "You are choosing a course that expoert users are expected to take, we suggest your kid to start learning from our begginers course first.",
          track: "Choose your course",
          track_name: "course name",
          credit: "Credit/ Debit/ Prepaid Cards",
          credit_text:
            "You can pay through your cards and your kid's subscription will be activated directly.",
          paypal: "Paypal",
          paypal_text:
            "You can pay through your PayPal and your kid's subscription will be activated directly.",
          payment: "Payment Info",
          change: "change",
          detail: "Confirm",
          package: "Package Details",
          pay: "Pay Now",
          child_name: "please select your child",
          child_track: "please select your course",
          child_course: "please select the course level",
          child_terms: "read and agree on the terms and conditions first.",
          mobile: "Mobile Balance",
          balance:
            "You can pay through your mobile balance and your kid's subscription will be activated directly.",
          attention_msg:
            "The course you chose is suitable for kids aged 5 to 7. in this course they will learn to interact with computers and their basic skills.",
          text_msg: "Attention",
        },
        parentHeader: {
          kidsTab: "Kids",
          membershipTab: "Memberships",
          accountInfo: "Account Inforamtion",
          logout: "Log Out",
          dashboardParent: "Parent Dashboard",
        },
        teacherHeader: {
          dashboardParent: "Teacher Dashboard",
          Classroom: "Classrooms",
          progress: "Progress",
          code: "Code Review",
        },
        schoolHeader: {
          dashboardschool: "School Dashboard",
          Techers: "Teachers",
          students: "Students",
          teacherheader: "Teachers",
          studentheader: "Students",
        },
        parentAccountInfo: {
          accountInfo: "Account Information",
          basicInfo: "Basic Info",
          kids: "Kids",
          students: "Students",
          basicInformation: "Basic Info",
          name: "Name",
          edit: "Edit",
          email: "Email",
          phoneNumber: "Phone Number",
          country: "Country",
          changePassword: "Change Password",
          oldPassword: "Current Password",
          oldPassPlaceholder: "Enter Current Password",
          newPassword: "New Password",
          newPassPlaceholder: "Enter New Password",
          saveChanges: "Save Changes",
          title: "Parent Details",
          teacherTitle: "Teacher Details",
          subtitle: "Your Informations",
          username: "Username",
          phone: "Mobile Number",
          cancel: "Cancel",
          nameRequired: "This field is required, Please enter a name",
          min_chars: "Minimum number of characters  is",
          max_chars: "Max characters is",
          usernameRequired: "This field is required, Please enter a username",
          emailRequired:
            "This field is required, Please enter an email dddress",
          valid_email: "Please Enter a correct Email Address",
          formatMsg: "The Username can only use: a-z A-Z 0-9 _ - . ",
          primaryWord: "Primary",
          notAllowedSpacing:
            "The password is not allowed to start or end with space.",
          parent: "Sharing Report Modal",
          certi: "Certificates",
        },
        tableKidInfo: {
          title_student: "Student Details",

          subtitle_student: "Information about your student",
          tableTitle: "Kid's List",
          tableStudentTitle: "Student's List",
          downloadList: "Donwload Report",
          downloadStudentList: "Download Students info",
          title: "Kid Details",
          subtitle: "Information about your kid",
          studentName: "Kid name",
          userName: "Username",
          dateCreated: "Date created",
          lastActivity: "Last activity",
          overallMarks: "Overall marks",
          name: "Name",
          generate: "Generate User Name",
          password: "Password",
          passPlaceholder: "Create a Password For Your Kid",
          packagePlan: "Package Plan",
          updatePlan: "Update Plan",
          saveChanges: "Save Changes",
          cancel: "Cancel",
          moreDetails: "More Details",
          passwordRequired: "This field is required, Please Enter a password",
        },
        noKidsModal: {
          msg: "Sorry, You don't add any account Kids",
          btnMsg: "Add Kid",
          msg_email:
            "Please add your email to receive your purchase receipt and the latest updates on our services and products.",
          btnMsg_email: "Add Email",
          email: "We're Missing your Email",
          btnMsg_phone: "Add Phone",
          phone: "We're Missing your Phone",
          msg_phone:
            "Please add your phone to receive your purchase receipt and the latest updates on our services and products",
        },
        student_profile: {
          certficate: "Certficate",
          edit: "Edit",
          basic_info: "Basic info",
          name: "Name",
          cancel: "Cancel",
          save: "Save",
          emoji_header: "Emojis Library",
          emoji: "Emojis",
          upload_image: "Upload Image",
          user_name: "Username",
          b_day: "Birthday",
          school: "School",
          parent: "PARENT",
          link_your_parent: "Invite your parents now",
          plan: "Plan",
          p_msg: "Plans can only be updated by parents.",
          expiry: "PLAN EXPIRY",
          delete_acc: "DELETE ACCOUNT",
          download: "Download",
          previous: "Previous",
          next: "Next",
          all_poimts: "Overall Points",
          earend_points: "Total Points",
          weekly_points: "Weekly Points",
          prog_summary: "Progress Summary",
          certificates: "Certificates",
          challenges: "Challenges",
          projects: "Projects",
          badge: "Badges",
          badge_exp:
            "You can win these badges every time you finish a course with all its levels.",
          trophies_exp:
            "After the completion of programming projects, you can earn these trophies",
          point_one:
            "Project Hero Trophy , after the completion of 10 projects.",
          point_two:
            "Creative Coder Trophy , after the completion of 30 projects.",
          point_three:
            " Coding Innovator Trophy, after the completion of 100 projects.",
          Trophies: "Trophies",
          acc_info: "Account Information",
          basic_info_mob: "Basic Info",
          Summary: "Summary",
          kids_prog: "Kid Progress",
          details: "Details",
          select_course: "Select Course",
          completed_lessons: "Completed Lessons",
          lesson_tiltle: "LESSON TITLE",
          asses_results: "ASSESMENT RESULTS",
          code: "CODE",
          code_review: "Review Code",
          challenge_pro: " Challange Projects",
          pro_name: "PROJECT NAME",
          pro_comment: "PROJECT COMMENT",
          status: "PROJECT STATUS",
          share: "SHARE",
          playground: "Playgrounds Projects",
          lessons_details: "Lessons Details",
          project_details: "Projects Details",
          playground_details: "Playgrounds details",
          challanges_details: "Challanges details",
          challenges: "Challenges",
          projects: "Projects",
          accountInfo: "Account Information",
          edit_info: "Edit Information",
          editmsg: "Edit your infomration",
          save: "Save",
          cancel: "Cancel",
          list_of_certis: "List of certificates for student.",
          list_of_chall: "List of Challenges for student.",
          list_of_pros: "List of Projects for student.",
          dones: "Done",
          email_parent: " Parent email",
          phone_num: "Phone Number",
          title_invite: "Invite your parents",
          btn_invite: "Send invite",
          text_mess: "Email has been sent successfully",
          error_message:
            "OOOPS!seems you already sent the invitation to your parents!",
          main_invite:
            "Add your parents' phone number and we will send them an invite to join you and upgrade your plan.",
          lessons_name: "lessons name",
          Assessment_result: "Assessment result",
          challange_name: "Challange name",
          project_name: "Project name",
          teacher: "Teacher",
          t_msg: "School plan",
          line: "Line of code",
          activ_tab: "Activity",
          prog_tab: "Progress",
          nocertificates: "There are no certificates yet.",
          nochallenge: " There are no challenges yet",
          noproject: "There are no Projects yet",
          Resources: "Resources",
          title_res: "Resource Title ",
          Res: "Resource",
          down: "Download",
          type: "File Type",
        },

        kidHeader: {
          exam: "Exam",
          Playground: "Playground",
          myWorldTab: "My World",
          communityTab: "Community",
          notificationTab: "Notifications",
          allNotifications: "See All Notifications",
          unread: "Mark as Unread",
          read: "Mark as Read",
          accountInfo: "Account Information",
          logout: "Log Out",
          dashboardkid: "Programmer Dashboard",
          dashboardstudent: "Student Dashboard",
        },
        studentWorld: {
          myWorld: "MY WORLD",
          hello: "Hello",
          subTitle: "Track your progress and start your learning journey",
          basic: "Computer Skills ",
          smoothy: "SmoothY Coding",
          advanced: "Web Development",
          playCourse: "Play Level",
          lockMsg:
            "You need to complete the previous course in order to play this course",
          python: "Python coding",
          info: " Please , complete pervious course",
        },
        lessonsList: {
          courses: "Courses",
          details: "Details",
          accomplishments: "Accomplishments",
          graduationCertificate: "Graduation Certificate",
          juniorProgramming: "Computer skills Courses",
          basicProgramming: "SmoothY Coding Courses",
          advancedProgramming: "Web Development Courses",
          earned: "Earned",
          availableLessons: "Available Lessons",
          availableNow: "Availabe Now",
          needPlanUpdate: "Need plan update",
          invite: "invite parent",
          done: "Done",
          completed: "Completed",
          finished: "Finished",
          repeat: "Repeat",
          startLesson: "Start Lesson",
        },
        tableKidHistory: {
          student_name: "Student Name",
          plan_name: "Plan name",
          course_name: "Course name",
          amount: "Amount",
          purchased_at: "Purchased at",
          payment_method: "Payment Method",
          purchases_history: "Membership Details",
          membershipTableTitle: "Memberships List",
        },
        smoothyIde: {
          title: "Smoothy IDE",
          description:
            "You can write Smoothy code here. It's where you can explore coding. Feel free to create your own programs, just the way you want.",
          title_web: "Web IDE",
          description_web:
            "You can write Web code here. It's where you can explore coding. Feel free to create your own programs, just the way you want.",
          title_python: "Python IDE",
          description_python:
            "You can write Python code here. It's where you can explore coding. Feel free to create your own programs, just the way you want.",
          myProjects: "My Projects",
          hello: "Hello",
          soundLibrary: "Sound Library",
          imageLibrary: "Image Library",
          fullScreen: "Full Screen",
          saveProject: "Save Project",
          daily_submission: " Daily Submission",
          run: "Run",
          stop: "Stop",
          submit: "Submit",
          code: "Code",
          output: "Output",
          projectGoal: "Project Goal",
          projectLibraryTitle: "Saved projects",
          startCoding: "Start Coding",
          next: "Next",
          addNewProject: "Add new project",
          placeholderProjectTitle: "Project Title",
          addproject: "Add New Project",
          playgroundProjects: "Playground Projects",
          coursesProjects: "Courses Projects",
          welcomeModalTitle:
            "Dear programmer, we are very excited to see your wonderful projects! ",
          welcomeModalText:
            "You can submit up to three projects per day. Make sure to submit your best projects to increase your points.",
          welcomeModalSubText:
            "Make sure that you submit your completed project. ",
          submitModalText: "Are you sure you want to submit this project?  ",
          submitModalSubText: "Your project will be corrected within a week",
          confirmBtn: "Yes",
          cancelBtn: "No",
          submitModalTitle: "Submit Project",
          goalModalTitle: "Project Goal",
          my_project: "My Project",
          share_code: "Share Code",
          share_code_msg:
            " You have to select a submitted project in order to share a code to the community",
        },
        table_student: {
          cancel: "Cancel",
          approve: "Yes",
          messlockcommunity:
            "Are you sure you want to lock the community for  students?",
          messunlockcommunity:
            "Are you sure you want to unlock the community for  students?",
          unlockcommunity: "Unlock Community",
          lockcommunity: "Lock Community",
          cert_completion: "Completion certificate ",
          attention_msg: "Attention, your student didn't take any lesson yet!",
          selected: "Selected",
          btn_unlock: "Unlock Lessons",
          btn_reset: "Reset Challenges",
          btn_lesson: "Finish Lessons",
          btn_question: "Reset Questions",
          add_text: "Add New Student",
          assi_text: "Assign Existing Student",
          add_student: "A new student will be added to this classroom",
          assi_student:
            "Select a student from the list and enroll them in this classroom",
          detai: "Details",
          name_student: "Student Name",
          username_student: "Username",
          score: "Skill Score",
          all_points: "Total Points",
          search: "Search For Students",
          all: "All",
          assign_exist: "Assign",
          add_student: "Add New Student",
          assign:
            "Select a student from the list and enroll them in this classroom",
          student: "New student will be added to this classroom",
          reset: "Reset Password",
          dele: "Remove From Classroom",
          edit_Sname: "Edit Student Name",
          edit_Username: "Edit Student Username",
          down_report: "Download Report",
          report_tab: "Reports",
          report_des: "Generate report for all students in this classroom",
          assign_class: "Assign To Classroom",
          extra_tab: "Extra Resources",
          down: "Download",
          skills_degree: "Skills degree",
          total_score: "Total Score",
        },
        assign_student: {
          main_text: "Assign students to class room name",
          heading_text:
            "Here are all the studetns you have created. If you want to create new student go your account info.",
          btn_assign: "Save Changes",
          btn_cancel: "Cancel",
        },
        reset_challenges: {
          title_heading: "Reset Challenges for Students",
          text_heading:
            "You are resetting challenges for students; resetting challenges will give the students the chance to solve the challenges again",
          btn_reset: "Reset Challenges ",
          btn_cancel: "Cancel",
          text_question:
            "Are you sure you want to reset the challenge(s) for  this student ?",
          text_questions:
            "Are you sure you want to reset the challenge(s) for this student(s)?",
        },
        resetPassword: {
          btn_reset: "Reset Password Now",
          new_password: "New Password",
          main_text: "Reset Password",
          head_text: "Are you sure you want to reset this student password?",
          head: "Are you sure you want to reset this teacher password ?",
        },
        new_classrooms: {
          search: "Search by Classroom Name",
          head_title: "Classrooms",
          main_text:
            "All the classrooms you listed, engage or created will be shown here.",
          title_card: "You have not added any classrooms yet",
          text_card:
            "All your classrooms will be listed here, once you add a classroom, you will have the chance to add student.",
          add_classroom: "Add your first classroom now",
          main_title: "Add New Classroom",
          btn_classroom: "+New Classroom",
          text_main: "Students in this class.",
          classroom_name: "Classroom Name",
          Grade: "Grade",
          Course: "Course",
          classroom_seats: " Number of Seats",
          btn_create: "Create Classroom",
          btn_cancel: "Cancel",
          Edit: "Edit Classroom",
          btn_edit: "Save Changes",
          del_Classroom: "Delete Classroom",
          title_time: "Set Schedule",
          sub_text: "Choose a day and time that would suit you best",
          day: "sunday",
          first_name: "First Name",
          last_name: "Last Name",
          email: "Email",
          email_address_b12: "B12 Email",
          grade_level: "Grade",
          user_name: "Username",
          password: "Password",
          confirmation: "Confirm Password",
          add_student: "Add Student Name",
          student_title: "Add New Student",
          text_student: "You are adding a student to this class",
          current_course: "Current Course",
          current_students: "Current Students",
          current_student: "Current Student",
          Students: "Students",
          Student: "Student",
          dele_classroom: "Delete Classroom",
          See_deta: "See Details ",
          grade: "Grade",
        },
        remove_student: {
          main_text: "Remove Student",
          student_removed:
            "Are you sure you want to remove this student from the classroom?",
          text_heading: "STUDENT TO BE REMOVED",
          btn_dele: "Remove Student Now",
          cancel_btn: "Cancel",
          text_question:
            "Are you sure you want to remove this student from the classroom?",
          text_questions:
            "Are you sure you want to remove this student(s) from the classroom?",
        },
        teacher_guide: {
          is_correct: " Is correct answer",
          noQuestion: "No Question",
          noLesson: "No Plan Lesson",
          noResource: "No Extra Resource",
          Question: "Question",
          Lesson: "Lesson",
          Lessonsvideo: "Lessons Video",
          ChallengeSolutions: "Challenge Solutions",
          LessonSolutions: "Lesson Solutions",
          QuestionSolutions: "Question Solutions",
          ExtraResources: "Extra Resources",
          lesson_plan: "Lesson Plan",
          title: "Title",
          download: "Download File",
          question_bank: "Questions bank",
        },
        finish_lesson: {
          main_text: "Finish Lessons for Students",
          text_heading:
            "You are ending lessons for students, by doing so you will enable them to study the next lesson.",
          btn_dele: "End Lessons ",
          cancel_btn: "Cancel",
          okay_btn: "Okay",
          text_question:
            "Are you sure you want to finish the lessons for all the selected students in the classroom?",
          text_questions:
            "Are you sure you want to finish the lessons for all the selected students in the classroom?",
        },
        unlocked: {
          title_heading: "Unlock Lessons for Students",
          text_heading:
            "You are unlocking lessons for students; unlocking lessons will open a specific lesson for them.",
          text_heading_two:
            "Are you sure you have completed the previous lesson?",
          text_heading_three:
            "Are you sure you want to mark this lesson as incomplete? Your progress will be reset.",
          text_heading_four: "Are you sure you have completed the last lesson?",
          btn_reset: "Unlock Lessons ",
          btn_cancel: "Cancel",
          btn_yes: "Yes",
        },
        rest_question: {
          text_heading: "Reset Questions for Students",
          text_main:
            "You are resetting questions for students; resetting questions will give the students the chance to solve the questions again and collect more points.",
          rest_btn: "Reset Questions",
          cancel_btn: "Cancel",
          text_question:
            "Are you sure you want to reset the questions for all the students in the classroom?",
        },
        exportfile: {
          text_file: "Import students from a List",
          main_file:
            "Upload your XSL. File or CSV. File with students’ names and we will generate a username for each one.",
          labelfile: "Student List",
          btn_import: "Import Now",
          btn_cancel: "Cancel",
          message_error:
            "5 MB max, make sure the names are in one cell and are not duplicated.",
        },
        classroom_details: {
          flex_text: "Classroom",
          classroom_text: "Name Of the Classroom",
          program_name: "ADVANCED PROGRAMMING",
          classroom_name: "Name of the class room one line",
          small_text: "5 Seats Available | 3RD Grade",
          basic_info: "Basic Information",
          edit: "Edit",
          main_name: "Name",
          text_name: "Name of the classroom",
          GRADE: "Grade",
          active_course: "Current course",
          course_name: "Course Name",
          numOfseats: "Students",
          available_seats: "Available seats",
          Schedule: "Time schedule",
          set_time: "Set-time",
          Techers_Guide: "Teacher Guide",
          Resources_Guide: " Extra Resources ",
          Student_Guide: "Student Guide",
          Add_student: "Add New Student",
          text_student: "Enroll a new student into this Classroom",
          btn_add: "Add",
          export_file: "Import Students ",
          export_text: "Add a list of students to this classroom",
          btn_export: "Import",
          finish: "Finish",
          select: "Please Select A File",
        },
        teacher_account: {
          enrolled: "Enrolled Coursees",
          join: "Joining Date",
          active: "Last Activity",
          remove_student: "Delete Student",
        },
        games_Shared: {
          firsrt_game: "typing game 1",
          secound_game: "typing game 2",
          third_game: "typing game 3",
          fourth_game: "mouse game",
          gaming_welcome: " Welcome, Let’s get Playing",
          play: "Play",
        },
        Examanition: {
          firstname: "First Name",
          Middlename: "Middle Name",
          lastname: "Last Name",
          birth: " Date of Birth",
          language: "Exam language",
          phone: "Mobile number",
          email: " Email address",
          city: "City",
          country: "Country",
          next_btn: "Next",
          per_btn: "Previous",
          date: "dd/mm/yy",
          alert_check:
            "Make sure you fill in the correct candidate information; you will not be able to change the data once you have submitted the form.",
          course: "Courses",
          exam: "Exams",
          Completed: "Completed",
          in_progress: "In progress",
          cs_ex: "Courses and Exams",
          personal_info: "Personal Information",
          review_submit: "Review and Submit",
          third_step:
            "You are almost done! please check your information below.",
          exam_name: "Exam Name",
          full_name: "Full name",
          submit: "Submit",
          submit_modal: "Are you sure you want to submit your form?",
          cant: "You can't update your data once you submit the form.",
          yes: "Yes, Submit",
          no: "Check again",
          success: "You have successfully registered for",
          successfully: ".",
          confirmation:
            "Shortly, you will receive a confirmation email containing the following information:",
          eligible_id: "The Eligibility ID and a time window for registration",
          auth:
            "A letter of authorization that has the candidate's information.",
          link: "A link to schedule the exam.",
          advice:
            "The user is advised to schedule their exam before their eligibility window expires.",
          good_luck: "Good Luck!",
          ar: "Arabic",
          en: "English",
          choose: " Choose the Language",
          enable:
            "you need to finish the following course(s) and exams in order to enable applying to this exam",
          enableCourse:
            "you need to finish the following course(s) in order to enable applying to this exam",
          examanition: "Exams registration",
          your_exams: "Register for your exams and test your abilities.",
          incoplrted: "You have not completed any courses yet.",
          click: " Please click ",
          here: "here",
          to_complete: "to complete the courses.",
          get_back: "Get back to My World",
          soon:
            "This exam is not currently available. It will be released soon",
        },
        Exam_date: {
          main_text:
            "The schedule for the exam's sessions will  be announced soon",
        },
        rules: {
          main_head: "Eligibility Requirements",
          main_text:
            "Young Hello code learners  are eligble to register for the exams if they meet the following requirements:",
          circle_age: "Between the ages of 8 and 18 years old",
          circle_completed: "Completed the exams  in sequence",
          circle_course: "Already completed the exam-related course",
          sm_text: "(individually or through school)",
        },
        exam_home: {
          exam_title: "HelloWorldKids Certification Program ",
          HCP: "(HCP)",
          exam_openingStatment:
            "HelloWorldKids Certification Program (HCP) is an internationally recognized examination and certification program with a large set of perks, designed for young learners (8-18 years old) to acknowledge proficiency in coding and other technology domains.",
          Hello_certificate: "HelloMaster Certificate",
          Hello_certi_details:
            "HelloMaster is the 1st certificate in the HCP program. It is issued to learners who pass a set of exams that measure coding proficiency and mastery of relevant 21st century skills.",
          certificate_stat:
            "The HelloMaster certificate consists of three certificates of specialization: ",
          hello_smoothy: "HelloSmoothY Certificate (HCSY)",
          smoothy_details:
            "This certificate of specialization consists of three exams to evaluate young learners' proficiency in the fundamentals of coding using SmoothY® programming language.",
          smoothy_exam1: "HelloCode SMOOTHY Basic(HCSB)",
          smoothy_exam2: "HelloCode SMOOTHY Intermediate (HCSI)",
          smoothy_exam3: "HelloCode SMOOTHY Advanced (HCSA)",
          hello_web: "HelloWeb Certificate (HC Web)",
          web_details:
            "This certificate of specialization consists of two exams to evaluate young learners' proficiency in web development, particularly in HTML, CSS, and JavaScript.",
          web_exam1: "HelloCode Web Development-1 (HCWD1)",
          web_exam2: "HelloCode Web Development-2(HCWD2)",
          hello_python: "HelloPython Certificate (HCPY)",
          python_details:
            "This certificate of specialization consists of two exams to evaluate young learners' proficiency in learning to program in Python.",
          python_exam1: "HelloPython Level 01 Exam (HCPB)",
          python_exam2: " HelloPython Level 02 Exam (HCPI)",
          exam_btn: "Register for the Exam Now",
        },
        about_exam: {
          contact:
            "To register for an exam, please reach out to your teacher. You can email them directly using the email address provided by the school.",
          thank: "Thank you for your cooperation.",
          main_heading: "Certificate Perks Program",
          para_text:
            "Our certificate perks program is designed to offer competitive opportunities for coding talents worldwide to ensure their future success.",
          sm_text:
            "There are two levels of benefits provided by the Perks Program",
          scholar_title: "HelloWorldKids coding scholarship",
          scholar_expalin:
            "an annual scholarship opportunity to compete for a one-year university tuition coverage for the highest achievers.",
          partial_title: "Full or partial scholarships",
          partial_explain:
            "Universities in our partners' network offer them for talents who wish to pursue higher education in tech fields.",
          network_title:
            "Our network of professional partners offers to young talents:",
          point_one:
            "University and college grants to pursue higher education in tech fields.",
          point_two:
            "Fellowship programs designed to develop interpersonal and entrepreneurial skills.",
          point_three:
            "Professional internship programs to encourage young learners' technical progression.",
          specialization_cer: "Certificate of Specialization Perks",
          rule_one:
            "Learners who earn a certificate of specialization are entitled to receive professional training programs from our partners' network.",
          rule_two:
            "We focus on providing training courses in various tech and non-tech fields such as networking, AI, robotics, communication skills, public speaking, English proficiency, and more.",
        },
        assign_stu: {
          currunt_class: "current classroom",
          okay_btn: "Transfer students",
          cancel_btn: "Cancel",
          choose: "Choose the classroom",
          transfer_class: "Transfer students to another classroom",
          get_cer: "Generate Certficate",
          message_genrate: "Certificate Has Been Successfully Generated",
        },
        communityComponents: {
          school: "Schools",
          admin: "Back",
          readmore: "Read more",
          community: "Community",
          create_post: "Create New Post",
          hellocode_world: "HELLOCODE WORLD",
          greeting_main_message:
            "Discover, Code, Share:Together in the Hello Code Squad!",
          contributions_kids: "Students post",
          top_coontributors: "Top Coders",
          Unfriend: "Unfriend",
          postText:
            "This is the length of the posr it can go/start from this point and reach untill this point, put as much lines as you could",
          hide_posts: "Hide Post",

          edit_post: "Edit post",
          see_post: "See full post",
          date_of_publishing: "2 hours ago",
          text_student_name: "Student Name",
          See_all: "See all posts",
          mob_students: "Top Students",
          mob_top_posts: "Top Posts",
          Moball: "All",
          friend_tag: "Friend",
          level: "level",
          Questions: "Questions",
          Ideas: "Ideas",
          engage: "Engage with the community",
          anyWay: "Think, Write, and Share!",
          post_creation: "Create a post",
          ask: "Wondering? Ask and Explore!",
          ask_description: "Share your questions with fellow coders",
          idea: "Ideas Party. Share your thoughts.",
          idea_description: "Spread your creativity and inspire!.",
          celebrate: "Achievements Time. Celebrate",
          celebration_description:
            "Join the fun and celebrate your milestones!",
          whats_ur_question: "Ask a Coding Question!",
          whats_ur_idea: "Got a Bright Idea to Share ? Write your ideas",
          back: "Back",
          cancel: "Cancel",
          Publish: "Publish",
          what_ur_celebrate:
            "What Milestone Do you Want to Share and Celebrate?",
          Certificates: "Certificates",
          Trophies: "Trophies",
          Badges: "Badges",
          next: "Next",
          choose_certificate: "Choose your certificate",
          recent_certificate: "RECENT CERTIFICATES",
          other_certificate: "OTHER CERTIFICATES",
          choose_throphy: "Choose your Trophy",
          recent_trophy: "RECENT TROPHYS",
          other_trophy: "OTHER TROPHYS",
          choose_badge: "Choose your Badge",
          recent_badge: "RECENT BADGES",
          other_badge: "OTHER BADGES",
          say_something: "Say something about your acheivement",
          celebrate_laststep: "CELEBRATE",
          badgeName: "*badge or whatever name*",
          back_to_home: "Back to Home",
          sucssess_modal_message: "Your post has been seccsesfully publiushed",
          correct_answer: "Correct answer 🎉 🎉",
          commentbox:
            "The description of the comment 👋 Here are🌹Well done.The description of the comment 👋",
          top: "Top",
          newest: "Newest",
          write_comment: "Write a comment...",
          submit: "Submit",
          World: "My World",
          yes: "Yes",
          no: "No",
          no_choose: "Choose another answer",
          undefined_modal: "Are you sure to unfriend ?",
          question_sure: "Are you sure you want to delete this friend?",
          add_friend: "Are you sure you want to add this friend?",
          addfriend: "Add Friend",
          deletefriend: "Remove Friend",
          cancel_btn: "Cancel",
          decline_friend: "Are you sure you want decline this friend?",
          declinefriend: "Decline friend",
          accept_friend: "Are you sure you want accept this friend?",
          accpetfriend: "Accept friend",
          pending: "Pending",
          selectProject: "share your project",
          ShareCode: "Share Code",
          selectCourse: "Choose the course",
          next: "Next",
          noresult: "No results found for your search.",
          community_profile: {
            delecomment: "Delete Comment",
            editcomment: "Edit Comment",
            student_name: "student Name",
            Level: "Level number",
            progress: "Progress Summery",
            activity: "Activity",
            all: "All",
            ques: "Questions",
            idea: "Idea",
            celeb: "Celebrations",
            date: "Date of publishing",
            hide: "hide post",
            unfriend: "Unfriend",
            points: "earn points",
            badges: "badges",
            badge_name: "badge name",
            chall: "Challenges",
            proj: "Projects",
            back: "Back",
            hideden: "Hidden posts",
            hide_stat: "there are no hidden posts yet !",
            no_posts: "You haven't share any post yet!",
            no_posts_friends: "Your friend didn't share any posts yet!",
            add_posts:
              "Start by sharing your ideas ,asking a question ,or celebrating your achievements.",
            cr_post: "Create your first post",
            request_reciver: "Friend requests",
            request_sender: "View sent requests",
            zero_celeb_posts: "you don't have any of celebration posts",
            zero_ques_posts: "you don't have any of question posts",
            zero_idea_posts: "you don't have any of idea posts",
            accept: "Accept Request",
            decline: "Decline Request",
            norequest: "There is no request friend",
            nofriend: "Add friend Now",
            nopeople: "No Friends until now",
            friend: "Friends",
            unhide: "retore post",
            add_theFreind: "you have to add friend to show thier activities",
            unhide: "retore post",
            friend: "Friends",
            pending: "Pending",
            more: "Show more",
            less: "Show less",
            accept: "Confirm",
            decline: "Delete",
            requesmessage: "wants to be your friend",
            notfi: "Notifications",
            commentreply: "commented on your post.",
            createpost: "A post has been created by",
            acceptmessage: "Friend request accepted",
            zero_ques_friend: "your friend doesn't have any of question posts",
            zero_celeb_friend:
              "your friend doesn't have any of celebration posts",
            zero_idea_friend: "your friend doesn't have any of idea posts",
            no_notfication: "No Notifications ",
            likecomment: "Liked your comment",
            markasread: "Mark as read",
            likepost: "Liked your post",
            notify_question: "Answer their Question 😁✅",
            notify_celeb: "Celebrate with them 🥳🎉",
            notify_idea: "Share your thoughts 🤔💭",
            your_correct_answer:
              " has selected your response as the correct answer",
          },
          yes: "yes",
          no: "No",
          edit: "Edit",
          sucssess_delete_message: "Your post has been seccsesfully deleted",
          sucssess_delete_comment: "Your comment has been seccessfully deleted",
          sucssess_edit_message: "Your post has been seccsesfully Edited",
          sure_delete: "Are you sure you want to delete this post?",
          hide_post: "Hide post",
          delete_comment: "ِAre you sure you want to delete this comment?",
          allComments: "All",
          profile: "My profile",
          home: "Home",
          friends: "Friends",
          comment_message: "Your comment has been sussesfully created",
          friend: "Friends",
          no_comments:
            "There are no Comments yet, change that by leaving a Comment of your thoughts.🤔",
          no_answers:
            "There are no Answers yet, change that by trying to answer🤓",
          no_congrats: "There are no Congrates yet, Say something nice.🎉🤗",
          close_modal: "Close",

          friendsCommunity: {
            all: "All friends",
            zero_friends:
              "You have no friends in your community at the moment, here are some coders you may want to add.",
            std_name: "student Name",
            level: "level",
            mut: "mutual friends",
            add: "Add friend",
            people: "People you may know",
            profile: "View profile",
            unfriend: "Unfriend",
            friend: "Friend",
            req_sent: "Cancel Request ",
            acc: "Accept request",
            rej: "Reject",
          },
          correct_message:
            "Are you sure that this is the correct answer for your question?",
          choose_correct: "Choose the correct answer",
          correct_button: "Correct answer",
          see_more_comments: "See more Comments",
          see_less_comments: "See less Comments",
          correct_chosen: "The correct answer has been choosen",
          havent_chosen_yet: "you havent chosen the correct answer yet.",
          on_notification: "turn on notifications",
          off_notification: "turn off notifications",
          comments: "Comments",
          no_certificates: "Get Certificate and Celebrate Your Achievements.",
          no_badges:
            "You haven't earned any Badges yet, earn them and celebrate with your friends 🥳",
          no_throphies:
            "You haven't earned any Trophies yet, earn them and celebrate with your friends 🥳",
          noResults:
            "Sorry, we couldn't find any results matching your search criteria. Please try again with different keywords 😓.",
          is_not_friendC: "Add Freiend",
          request_tag: "Requested",
          no_correct_answer: "student hasn't chosen the correct answer yet",
          confirm_tag: "Confirm",
          delete_tag: "Delete",
          deleteComment: "Delete Comment",
          editComment: "Edit Comment",
          restoringMessage:
            "All hidden posts will appear here, you can restore any post you want.",
          communityCourse: "Course",
          communityClassroom: "Classroom",
          communityFriends: "Friends",
          communityRegion: "Region",
          communityWorld: "Public",
          communitySchool: "School",
          likes_modal: "Likes",
          liked_by: "Liked by :",
          no_likes_yet: "this post doesn't have any likes yet 😓",
          communityFriendsRes:
            "Let's Find some Coding Buddies ! You're  Just a Search Away from Making Friends ",
          communityRegionRes:
            "No one in your region wrote any post yet, be the first 😁",
          communityWorldRes:
            "No one in the world wrote any post yet, be the first 😁",
          communitySchoolRes:
            "No one in your school wrote any post yet, be the first 😁",
        },
        Perks: {
          title: "Perks",
          main_title: "Basic Smoothy Certficate Perks",
          Discount: "Discount 50%",
          text:
            "Eureka Academy is a Technological Institution that is focused on ensuring that young people get a good head start in their quest to garner knowledge of the technological world.",
        },
        memoryGame: {
          memory_game: "Memory Game",
          try_again: "Try again 😥",
          good_job: "Good Job 😊",
          great_job: "Great Job 😊",
          amazing_job: "Amazing Job 🤩",
          time: "You have finished the game in ",
          second: "seconds 🎆",
          no_stars: "No stars erned",
          quit: "Quit game",
          again: "Play Again",
          welcome: "Welcome to the Memory Card Flip Game!🎆",
          Goal: "Goal",
          goal_msg: " Find matching pairs of cards.",
          how: "How to play ?🤔",
          step1: "Click on any two cards to flip them over.",
          step2: "Remember the pictures on each card.",
          step3:
            "If the two cards match, they will stay flipped over, and you'll earn a point.",
          step4:
            "If cards don't match, they will flip back over, and you can try again.",
          step5:
            "Keep flipping cards and finding matches until all pairs are matched.",
          enjoy:
            "Enjoy playing and try to flip all the cards before the time runs out!😊",
          Start: "Start",
          and: "and",
          moves: "moves 🤖",
        },
        puzzlegame: {
          title: "Puzzle Game",
          step_1:
            "Objective: Slide tiles to arrange them correctly and reveal the image.",
          step_2: "Controls: Swipe or drag tiles to slide and align them.",
          step_3:
            " Arrange all tiles properly to reveal the image and  move on to the next lesson; the game must be completed correctly.",
          back: "Back",
          next: "Start",
          submit: "submit",
          try: "Try Again !",
          pass: " You passed this game!",
          cong: "Congratulations !",
          title_mess: "Game work just on laptop",
        },
        draganddrop: {
          total_moves: "Number Of Moves",
          title: "Drag and Drop Challenge.",
          stepone:
            "Objective: Drag and drop objects to their designated positions",
          steptwo:
            "Controls: Click and hold the mouse to select and drag an object then release it to drop the object in the desired position.",
          stepthree:
            "Completion: The game ends when all objects are placed inside the associated boxes.  To move on to the next lesson, the game must be completed correctly.",
          // stepfour:"Matching: Drag and drop objects to their corresponding targets.",
          // stepfive:"Completion: Finish when all objects are correctly placed or objectives are achieved.",
          start_btn: " Start",
          back_btn: "Back",
          level_name: "Level",
          play: "Play",
          game_name: "Drag and drop",
          back_step: "Back",
          next_step: "Next ",
          try:
            "Don't worry, losing just means you're one step closer to winning next time!",
          try_again: "Try agian !",
          total: "Total points",
          well_done: "Well Done !",
          complete: "Complete",
          submit: "Submit",
        },
        Pricing: {
          title: "Enjoy 15% off with sibling registrations  at Hellocode.me! ",
          title2:
            " Enjoy 10% off on multiple course sign-ups at Hellocode.me! ",
          per_user: "for each course",
          start: "Register",
          from: "Starting from",
          Popular: "Popular",
          Basicone: "Basic SmoothY Level 1",
          Basictwo: "Basic SmoothY Level 2",
          interone: "Intermediate SmoothY Level 1",
          intertwo: "Intermediate SmoothY Level 2",
          advanceone: "Advance SmoothY Level 1",
          advancetwo: "Advance SmoothY Level 2",
          juniorone: "Junior One Level",
          juniortwo: "Junior Two Level",
          juniorthree: "Junior Three Level",
          cert: "certificate for each level",
          web: "Web Development Level 1",
          python: "Python Level 1",
          tip_skill:
            "7.2$ per course/per user when you buy the course for more than child.Or 8$ per course/per user",
          tip_smoothy:
            "Or 31.5$ per course/per user when you buy the course for more than child.Or 35$ per course/per user",
          tip_web:
            "Or 40.5$ per course/per user when you buy the course for more than child.Or 45$ per course/per user",
          tip_python:
            "Or 40.5$ per course/per user when you buy the course for more than child.Or 45$ per course/per user",
          smoothy_track:
            "SmoothY track empowers our kids to become tech superheroes! Young learners will master coding fundamentals through engaging short cartoon videos, interactive projects, and creative challenges.",
          web_track:
            "Young learners will learn the art of web design by creating their own webpages using HTML, CSS, and JavaScript.",
          python_track:
            "Python track introduces the young learners to language of tech-savvy pioneers through an engaging and simplified journey.",
          computer_track:
            "Computer Skills fun-filled track introduces kids to basics of computers in a safe engaging environment!",
          title_smoothy: "Smoothy Track",
          title_web: "Web Development",
          title_skill: "Computer Skils Track",
          title_python: "Python",
          see_details: "See Details",
        },
      },
    },
  },
};
export default keys;



//////////////////
// WEBPACK FOOTER
// ./static/translate.js
// module id = null
// module chunks = 